(() => {
  const APPAREL_SIZES = ["S", "M", "L", "XL", "XXL"];
  const NBA_TEAMS = [
    { league: "NBA", code: "ATL", name: "Atlanta Hawks" },
    { league: "NBA", code: "BOS", name: "Boston Celtics" },
    { league: "NBA", code: "BKN", name: "Brooklyn Nets" },
    { league: "NBA", code: "CHA", name: "Charlotte Hornets" },
    { league: "NBA", code: "CHI", name: "Chicago Bulls" },
    { league: "NBA", code: "CLE", name: "Cleveland Cavaliers" },
    { league: "NBA", code: "DAL", name: "Dallas Mavericks" },
    { league: "NBA", code: "DEN", name: "Denver Nuggets" },
    { league: "NBA", code: "DET", name: "Detroit Pistons" },
    { league: "NBA", code: "GSW", name: "Golden State Warriors" },
    { league: "NBA", code: "HOU", name: "Houston Rockets" },
    { league: "NBA", code: "IND", name: "Indiana Pacers" },
    { league: "NBA", code: "LAC", name: "LA Clippers" },
    { league: "NBA", code: "LAL", name: "Los Angeles Lakers" },
    { league: "NBA", code: "MEM", name: "Memphis Grizzlies" },
    { league: "NBA", code: "MIA", name: "Miami Heat" },
    { league: "NBA", code: "MIL", name: "Milwaukee Bucks" },
    { league: "NBA", code: "MIN", name: "Minnesota Timberwolves" },
    { league: "NBA", code: "NOP", name: "New Orleans Pelicans" },
    { league: "NBA", code: "NYK", name: "New York Knicks" },
    { league: "NBA", code: "OKC", name: "Oklahoma City Thunder" },
    { league: "NBA", code: "ORL", name: "Orlando Magic" },
    { league: "NBA", code: "PHI", name: "Philadelphia 76ers" },
    { league: "NBA", code: "PHX", name: "Phoenix Suns" },
    { league: "NBA", code: "POR", name: "Portland Trail Blazers" },
    { league: "NBA", code: "SAC", name: "Sacramento Kings" },
    { league: "NBA", code: "SAS", name: "San Antonio Spurs" },
    { league: "NBA", code: "TOR", name: "Toronto Raptors" },
    { league: "NBA", code: "UTA", name: "Utah Jazz" },
    { league: "NBA", code: "WAS", name: "Washington Wizards" }
  ];
  const NFL_TEAMS = [
    { league: "NFL", code: "ARI", name: "Arizona Cardinals" },
    { league: "NFL", code: "ATL", name: "Atlanta Falcons" },
    { league: "NFL", code: "BAL", name: "Baltimore Ravens" },
    { league: "NFL", code: "BUF", name: "Buffalo Bills" },
    { league: "NFL", code: "CAR", name: "Carolina Panthers" },
    { league: "NFL", code: "CHI", name: "Chicago Bears" },
    { league: "NFL", code: "CIN", name: "Cincinnati Bengals" },
    { league: "NFL", code: "CLE", name: "Cleveland Browns" },
    { league: "NFL", code: "DAL", name: "Dallas Cowboys" },
    { league: "NFL", code: "DEN", name: "Denver Broncos" },
    { league: "NFL", code: "DET", name: "Detroit Lions" },
    { league: "NFL", code: "GB", name: "Green Bay Packers" },
    { league: "NFL", code: "HOU", name: "Houston Texans" },
    { league: "NFL", code: "IND", name: "Indianapolis Colts" },
    { league: "NFL", code: "JAX", name: "Jacksonville Jaguars" },
    { league: "NFL", code: "KC", name: "Kansas City Chiefs" },
    { league: "NFL", code: "LV", name: "Las Vegas Raiders" },
    { league: "NFL", code: "LAC", name: "Los Angeles Chargers" },
    { league: "NFL", code: "LAR", name: "Los Angeles Rams" },
    { league: "NFL", code: "MIA", name: "Miami Dolphins" },
    { league: "NFL", code: "MIN", name: "Minnesota Vikings" },
    { league: "NFL", code: "NE", name: "New England Patriots" },
    { league: "NFL", code: "NO", name: "New Orleans Saints" },
    { league: "NFL", code: "NYG", name: "New York Giants" },
    { league: "NFL", code: "NYJ", name: "New York Jets" },
    { league: "NFL", code: "PHI", name: "Philadelphia Eagles" },
    { league: "NFL", code: "PIT", name: "Pittsburgh Steelers" },
    { league: "NFL", code: "SF", name: "San Francisco 49ers" },
    { league: "NFL", code: "SEA", name: "Seattle Seahawks" },
    { league: "NFL", code: "TB", name: "Tampa Bay Buccaneers" },
    { league: "NFL", code: "TEN", name: "Tennessee Titans" },
    { league: "NFL", code: "WAS", name: "Washington Commanders" }
  ];
  const SOLD_OUT_PACK_TEAM_CODES = {
    basketball: new Set(["NYK"])
  };
  const MODEL_VIEWER_SRC = "https://unpkg.com/@google/model-viewer/dist/model-viewer.min.js";
  const THREE_MODULE_SRC = "https://esm.sh/three@0.160.0";
  const GLTF_LOADER_MODULE_SRC = "https://esm.sh/three@0.160.0/examples/jsm/loaders/GLTFLoader.js";
  const OPEN_PACK_QUERY_PARAM = "wl_open_pack";
  const SKIP_PACK_REDIRECT_QUERY_PARAM = "wl_skip_pack_redirect";
  const PACK_ANIMATION_TEST_QUERY_PARAM = "wl_animation_test";
  const PACK_SWAY_ORBIT_DEGREES = 15;
  const PACK_MOBILE_SWAY_ORBIT_DEGREES = 8;
  const PACK_SWAY_DURATION_MS = 3600;
  const PACK_MODEL_SOURCE_DEBOUNCE_MS = 90;
  const PACK_MODEL_PREFETCH_DELAY_MS = 220;
  const PACK_FRONT_Y_ROTATION = Math.PI;
  const PACK_OPEN_ANIMATION_DURATION_MS = 4000;
  const PACK_OPEN_SPARK_COUNT = 96;
  const PENDING_PACK_CHECKOUT_TTL_MS = 45 * 60 * 1000;
  const PENDING_PACK_EMPTY_CART_GRACE_MS = 12 * 1000;
  const PENDING_PACK_CHECKOUT_MAX_RESUME_ATTEMPTS = 1;
  const PENDING_PACK_MATCH_GRACE_MS = 10 * 60 * 1000;
  const PENDING_PACK_POLL_LIMIT = 16;
  const PENDING_PACK_POLL_INTERVAL_MS = 2500;
  const PACK_GUIDE_CHARACTER_DIMENSIONS = { width: 933, height: 1295 };
  const DEFAULT_PACK_STOCK_NOTE = "READY TO SHIP, ALL IN STOCK";
  const TEAM_STOCK_UNAVAILABLE_MESSAGE = "OUT OF STOCK FOR TEAM/SIZE";
  const THE_ONE_RAFFLE_DESCRIPTION =
    "This is a one-of-one pack. Only one of them exists in the world. Inside are treasures beyond your wildest dreams...it's also very valuable. Good luck!";
  const PACK_GUIDE_COPY = {
    welcome: [
      "Welcome to my forbidden pack emporium, Effendi.",
      "Step closer. The packs have been expecting you, Effendi.",
      "You found the back room of fortune, Effendi.",
      "Enter softly. The packs are listening, Effendi.",
      "Ah, a fresh seeker of value. Welcome, Effendi.",
      "The door was hidden, but you found it, Effendi.",
      "Choose with appetite. The emporium is open, Effendi."
    ],
    browsing: [
      "Each pack contains immense value, Effendi.",
      "Some packs whisper louder than others, Effendi.",
      "A wise eye sees treasure before it opens, Effendi.",
      "Do not rush the choice. The value is watching you, Effendi.",
      "Every pack has a story sealed inside, Effendi.",
      "One of these is calling your name, Effendi.",
      "The finest fortunes prefer sealed packaging, Effendi."
    ],
    open: [
      "A curious choice. Open it, Effendi.",
      "The seal is weak. Your destiny is impatient, Effendi.",
      "Yes, yes. This one wants to be opened, Effendi.",
      "No turning back now, Effendi. Only treasure.",
      "Break the silence. Let the pack speak, Effendi.",
      "The moment has arrived. Open with courage, Effendi.",
      "A bold pick. Now reveal what it owes you, Effendi."
    ],
    opening: [
      "The pack spirits are deciding, Effendi...",
      "The value is taking shape, Effendi...",
      "Silence, Effendi. The pack is thinking.",
      "Fortune is rummaging through the shelves, Effendi...",
      "The sealed world is becoming unsealed, Effendi...",
      "Something inside is moving toward you, Effendi...",
      "The decision has left our hands now, Effendi..."
    ],
    revealed: [
      "A very wise choice, Effendi!",
      "Ha! The pack knew exactly what to give you, Effendi.",
      "Behold. Fortune has manners today, Effendi.",
      "A beautiful pull, Effendi. Very beautiful.",
      "The emporium smiles upon you, Effendi.",
      "This is why patience is expensive, Effendi.",
      "You chose well. The pack approves, Effendi."
    ],
    shipping: [
      "Shipping immediately, Effendi!",
      "I will send it before the dust settles, Effendi.",
      "Your treasure is being prepared for departure, Effendi.",
      "The package leaves my hands soon, Effendi.",
      "Consider it claimed, packed, and moving, Effendi.",
      "Your goods are entering the outside world, Effendi.",
      "I am wrapping the fortune as we speak, Effendi."
    ]
  };

  const PACK_INFO_CONTENT = {
    railroadbum: {
      name: "Railroad Bum Budget Pack",
      price: "",
      guaranteed: ["1 random item"],
      randomSlots: [
        {
          label: "Random item",
          odds: [
            { chance: "45%", item: "1 pair of socks" },
            { chance: "42%", item: "Hat" },
            { chance: "10%", item: "T-shirt" },
            { chance: "3%", item: "Mainline piece" }
          ]
        }
      ]
    },
    forbiddenmerchant: {
      name: "Forbidden Merchant Cursed Pack",
      price: "",
      guaranteed: ["1 random item"],
      randomSlots: [
        {
          label: "Random item",
          odds: [
            { chance: "57%", item: "Hat" },
            { chance: "21%", item: "T-shirt" },
            { chance: "10%", item: "Hoodie" },
            { chance: "6%", item: "Pencil" },
            { chance: "6%", item: "Mainline piece" }
          ]
        }
      ]
    },
    unclesams: {
      name: "Uncle Sam's Crack Pack",
      price: "",
      guaranteed: ["1 random item"],
      randomSlots: [
        {
          label: "Random item",
          odds: [
            { chance: "50%", item: "Hat" },
            { chance: "25%", item: "T-shirt" },
            { chance: "15%", item: "Hoodie" },
            { chance: "10%", item: "Mainline piece" }
          ]
        }
      ]
    },
    fast: {
      name: "Fast Pack",
      price: "$77.77",
      guaranteed: ["1 T-shirt", "1 Random Item"],
      randomSlots: [
        {
          label: "Random item odds",
          odds: [
            { chance: "50%", item: "Hat" },
            { chance: "49%", item: "Accessory" },
            { chance: "1%", item: "Mainline piece" }
          ]
        }
      ]
    },
    fiesta: {
      name: "Fiesta Pack",
      price: "$88.88",
      guaranteed: ["1 random item"],
      randomSlots: [
        {
          label: "Random item odds",
          odds: [
            { chance: "50%", item: "Hat" },
            { chance: "27.5%", item: "T-shirt" },
            { chance: "15%", item: "Hoodie" },
            { chance: "7.5%", item: "Mainline piece" }
          ]
        }
      ]
    },
    hot_streak: {
      name: "Hot Streak Pack",
      price: "$249.99",
      guaranteed: ["1 Hoodie", "1 T-shirt", "1 Hat", "1 random item"],
      randomSlots: [
        {
          label: "Random item odds",
          odds: [
            { chance: "50%", item: "2nd T-shirt" },
            { chance: "47%", item: "Accessory" },
            { chance: "3%", item: "Mainline piece" }
          ]
        }
      ]
    },
    holy_grail: {
      name: "Holy Grail Pack",
      price: "$299.99",
      guaranteed: ["1 Hoodie", "2 T-shirts", "1 random item"],
      randomSlots: [
        {
          label: "Random item odds",
          odds: [
            { chance: "88%", item: "Hat" },
            { chance: "12%", item: "Mainline piece" }
          ]
        }
      ]
    },
    free_love: {
      name: "Free Love Pack",
      price: "$555",
      guaranteed: ["1 Mainline piece", "1 T-shirt", "1 Hat", "1 random item"],
      randomSlots: [
        {
          label: "Random item odds",
          odds: [
            { chance: "40%", item: "Hoodie" },
            { chance: "35%", item: "2nd T-shirt" },
            { chance: "25%", item: "Accessory" }
          ]
        }
      ]
    },
    hard_labor: {
      name: "Hard Labor Pack",
      price: "$2,500",
      guaranteedLabel: "Guaranteed Items",
      guaranteed: ["100% chance of you know what, hand-selected for you by Warren Lotas himself"],
      randomSlots: []
    },
    penny_pincher: {
      name: "Penny Pincher Pack",
      price: "$49.97",
      guaranteed: ["1 pair of socks"],
      randomSlots: [
        {
          label: "Random item",
          odds: [
            { chance: "60%", item: "Socks" },
            { chance: "30%", item: "Hat" },
            { chance: "10%", item: "T-shirt" }
          ]
        }
      ]
    },
    gold: {
      name: "Gold Pack",
      price: "$95",
      guaranteed: ["1 T-shirt"],
      randomSlots: [
        {
          label: "Random item",
          odds: [
            { chance: "10%", item: "T-shirt" },
            { chance: "35%", item: "Hat" },
            { chance: "25%", item: "Socks" },
            { chance: "30%", item: "OS accessory" }
          ]
        }
      ]
    },
    basketball: {
      name: "Basketball Pack",
      price: "",
      guaranteed: ["1 selected-team pair of sports socks"],
      randomSlots: [
        {
          label: "Selected-team random item",
          odds: [
            { chance: "75%", item: "T-shirt" },
            { chance: "15%", item: "Hoodie" },
            { chance: "10%", item: "NBA Nylon Sets" }
          ]
        },
        {
          label: "Bonus kicker",
          odds: [
            { chance: "5%", item: "Sports socks" },
            { chance: "5%", item: "NBA Nylon Sets" },
            { chance: "90%", item: "No bonus item" }
          ]
        }
      ]
    },
    football: {
      name: "Football Pack",
      price: "",
      guaranteed: ["1 selected-team T-shirt"],
      randomSlots: [
        {
          label: "Bonus hoodie roll",
          odds: [
            { chance: "25%", item: "Hoodie" },
            { chance: "75%", item: "No bonus item" }
          ]
        },
        {
          label: "Bonus T-shirt roll",
          odds: [
            { chance: "2%", item: "Extra T-shirt" },
            { chance: "98%", item: "No bonus item" }
          ]
        }
      ]
    },
    honey: {
      name: "Honey Pack",
      price: "$123.45",
      guaranteed: ["1 T-shirt"],
      randomSlots: [
        {
          label: "Random item",
          odds: [
            { chance: "35%", item: "T-shirt" },
            { chance: "37%", item: "Hat" },
            { chance: "20%", item: "Two pairs of socks" },
            { chance: "8%", item: "Hoodie" }
          ]
        }
      ]
    },
    anime: {
      name: "Anime Pack",
      price: "$175",
      guaranteed: ["1 Anime T-shirt"],
      randomSlots: [
        {
          label: "Smaller item",
          odds: [
            { chance: "30%", item: "Two pairs of socks" },
            { chance: "35%", item: "Hat" },
            { chance: "35%", item: "OS accessory" }
          ]
        },
        {
          label: "Random item",
          odds: [
            { chance: "55%", item: "T-shirt" },
            { chance: "20%", item: "Hoodie" },
            { chance: "5%", item: "Two pairs of socks" },
            { chance: "15%", item: "Hat" },
            { chance: "5%", item: "OS accessory" }
          ]
        }
      ]
    },
    classics: {
      name: "Classics Pack",
      price: "$175",
      guaranteed: ["1 Classics T-shirt"],
      randomSlots: [
        {
          label: "Smaller item",
          odds: [
            { chance: "30%", item: "Two pairs of socks" },
            { chance: "40%", item: "Hat" },
            { chance: "30%", item: "OS accessory" }
          ]
        },
        {
          label: "Random item",
          odds: [
            { chance: "55%", item: "T-shirt" },
            { chance: "20%", item: "Hoodie" },
            { chance: "10%", item: "Two pairs of socks" },
            { chance: "7.5%", item: "Hat" },
            { chance: "7.5%", item: "OS accessory" }
          ]
        }
      ]
    },
    platinum: {
      name: "Platinum Pack",
      price: "$250",
      guaranteed: ["1 T-shirt", "1 Hoodie"],
      randomSlots: [
        {
          label: "Random item",
          odds: [
            { chance: "60%", item: "Hat" },
            { chance: "25%", item: "T-shirt" },
            { chance: "10%", item: "Hoodie" },
            { chance: "5%", item: "Two pairs of socks" }
          ]
        }
      ]
    },
    serenity: {
      name: "Serenity Pack",
      price: "$444",
      guaranteed: ["1 T-shirt", "1 Hoodie"],
      randomSlots: [
        {
          label: "Smaller item",
          odds: [
            { chance: "70%", item: "Hat" },
            { chance: "30%", item: "OS accessory" }
          ]
        },
        {
          label: "Random item",
          odds: [
            { chance: "25%", item: "T-shirt" },
            { chance: "35%", item: "Hoodie" },
            { chance: "40%", item: "Mainline piece" }
          ]
        }
      ]
    },
    diamond: {
      name: "Diamond Pack",
      price: "$500",
      guaranteed: ["2 T-shirts", "1 Hoodie"],
      randomSlots: [
        {
          label: "Smaller item",
          odds: [
            { chance: "25%", item: "Two pairs of socks" },
            { chance: "45%", item: "Hat" },
            { chance: "30%", item: "OS accessory" }
          ]
        },
        {
          label: "Random item",
          odds: [
            { chance: "20%", item: "T-shirt" },
            { chance: "45%", item: "Hoodie" },
            { chance: "35%", item: "Mainline piece" }
          ]
        }
      ]
    },
    mainline: {
      name: "Mainline Pack",
      price: "$995",
      guaranteed: ["1 Mainline piece", "2 Hoodies", "2 T-shirts"],
      randomSlots: [
        {
          label: "Random item 1",
          odds: [
            { chance: "25%", item: "T-shirt" },
            { chance: "50%", item: "Hoodie" },
            { chance: "25%", item: "Mainline piece" }
          ]
        },
        {
          label: "Random item 2",
          odds: [
            { chance: "25%", item: "T-shirt" },
            { chance: "50%", item: "Hoodie" },
            { chance: "25%", item: "Mainline piece" }
          ]
        }
      ]
    },
    vision_quest: {
      name: "Vision Quest Pack",
      price: "$26",
      guaranteed: [],
      randomSlots: [
        {
          label: "Pack outcome",
          odds: [
            { chance: "5%", item: "Mainline piece" },
            { chance: "25%", item: "30% credits back" },
            { chance: "20%", item: "40% credits back" },
            { chance: "20%", item: "50% credits back" },
            { chance: "15%", item: "60% credits back" },
            { chance: "15%", item: "75% credits back" }
          ]
        }
      ]
    },
    lost_in_vegas: {
      name: "Lost in Vegas Pack",
      price: "$37",
      guaranteed: [],
      randomSlots: [
        {
          label: "Pack outcome",
          odds: [
            { chance: "7%", item: "Mainline piece" },
            { chance: "33%", item: "30% credits back" },
            { chance: "30%", item: "50% credits back" },
            { chance: "18%", item: "75% credits back" },
            { chance: "8%", item: "100% credits back" },
            { chance: "4%", item: "150% credits back" }
          ]
        }
      ]
    },
    chip_stacker: {
      name: "Chip Stacker Pack",
      price: "$58",
      guaranteed: [],
      randomSlots: [
        {
          label: "Pack outcome",
          odds: [
            { chance: "10%", item: "Mainline piece" },
            { chance: "40%", item: "40% credits back" },
            { chance: "25%", item: "50% credits back" },
            { chance: "13%", item: "60% credits back" },
            { chance: "8%", item: "75% credits back" },
            { chance: "4%", item: "100% credits back" }
          ]
        },
        {
          label: "Physical win bonus roll",
          odds: [
            { chance: "5%", item: "Bonus T-shirt" },
            { chance: "95%", item: "No bonus item" }
          ]
        }
      ]
    },
    bank_breaker: {
      name: "Bank Breaker Pack",
      price: "$77",
      guaranteed: [],
      randomSlots: [
        {
          label: "Pack outcome",
          odds: [
            { chance: "15%", item: "Mainline piece" },
            { chance: "30%", item: "5% credits back" },
            { chance: "27%", item: "10% credits back" },
            { chance: "14%", item: "20% credits back" },
            { chance: "10%", item: "100% credits back" },
            { chance: "4%", item: "150% credits back" }
          ]
        },
        {
          label: "Bonus T-shirt roll",
          odds: [
            { chance: "10%", item: "Bonus T-shirt" },
            { chance: "90%", item: "No bonus item" }
          ]
        },
        {
          label: "Bonus hoodie roll",
          odds: [
            { chance: "5%", item: "Bonus Hoodie" },
            { chance: "95%", item: "No bonus item" }
          ]
        }
      ]
    },
    slavic: {
      name: "Slavic Pack",
      price: "$88",
      guaranteed: [],
      randomSlots: [
        {
          label: "Pack outcome",
          odds: [
            { chance: "6%", item: "Mainline piece" },
            { chance: "22%", item: "50% credits back" },
            { chance: "24%", item: "75% credits back" },
            { chance: "28%", item: "100% credits back" },
            { chance: "20%", item: "150% credits back" }
          ]
        },
        {
          label: "Physical win bonus roll",
          odds: [
            { chance: "15%", item: "Bonus Hoodie" },
            { chance: "85%", item: "No bonus item" }
          ]
        }
      ]
    },
    breadwinner: {
      name: "Breadwinner Pack",
      price: "$72",
      guaranteed: [],
      randomSlots: [
        {
          label: "Pack outcome",
          odds: [
            { chance: "45%", item: "Shorts" },
            { chance: "22%", item: "75% credits back" },
            { chance: "20%", item: "100% credits back" },
            { chance: "13%", item: "150% credits back" }
          ]
        },
        {
          label: "Physical win bonus roll",
          odds: [
            { chance: "12%", item: "Bonus T-shirt" },
            { chance: "8%", item: "Bonus Hoodie" },
            { chance: "80%", item: "No bonus item" }
          ]
        }
      ]
    },
    ooze_sprayer: {
      name: "Ooze Pack",
      price: "$52",
      guaranteed: [],
      randomSlots: [
        {
          label: "Pack outcome",
          odds: [
            { chance: "19%", item: "Hoodie" },
            { chance: "20%", item: "Shorts" },
            { chance: "21%", item: "40% credits back" },
            { chance: "22%", item: "60% credits back" },
            { chance: "18%", item: "75% credits back" }
          ]
        },
        {
          label: "Physical win bonus roll",
          odds: [
            { chance: "8%", item: "Bonus T-shirt" },
            { chance: "92%", item: "No bonus item" }
          ]
        }
      ]
    },
    gusher: {
      name: "Gusher Pack",
      price: "$34",
      guaranteed: [],
      randomSlots: [
        {
          label: "Pack outcome",
          odds: [
            { chance: "32%", item: "T-shirt" },
            { chance: "12%", item: "Shorts" },
            { chance: "18%", item: "30% credits back" },
            { chance: "20%", item: "50% credits back" },
            { chance: "18%", item: "75% credits back" }
          ]
        },
        {
          label: "Physical win bonus roll",
          odds: [
            { chance: "6%", item: "Bonus Hat" },
            { chance: "94%", item: "No bonus item" }
          ]
        }
      ]
    }
  };

  const FALLBACK_PACK_PRODUCTS = [
    {
      packKey: "railroadbum",
      title: "Railroad Bum Budget Pack",
      price: "$29.97",
      imageUrl: "https://cdn.shopify.com/s/files/1/1430/1974/files/railroad-bum-budget-pack.png?v=1779678102"
    },
    {
      packKey: "forbiddenmerchant",
      title: "Forbidden Merchant Cursed Pack",
      price: "$66.66",
      imageUrl: "https://cdn.shopify.com/s/files/1/1430/1974/files/forbidden-merchants-cursed-pack.png?v=1779678159"
    },
    {
      packKey: "unclesams",
      title: "Uncle Sam's Crack Pack",
      price: "$91.29",
      imageUrl: "https://cdn.shopify.com/s/files/1/1430/1974/files/uncle-sams-memorial-day-crack-pack.png?v=1779756553"
    },
    {
      packKey: "fast",
      title: "Fast Pack",
      price: "$77.77",
      imageUrl: "https://cdn.shopify.com/s/files/1/1430/1974/files/fast-pack.png?v=1780075966"
    },
    {
      packKey: "fiesta",
      title: "Fiesta Pack",
      price: "$88.88",
      imageUrl: "https://cdn.shopify.com/s/files/1/1430/1974/files/fiesta-pack.png?v=1780076015"
    },
    {
      packKey: "hot_streak",
      title: "Hot Streak Pack",
      price: "$249.99",
      imageUrl: "https://cdn.shopify.com/s/files/1/1430/1974/files/hot-streak.png?v=1780076089"
    },
    {
      packKey: "holy_grail",
      title: "Holy Grail Pack",
      price: "$299.99",
      imageUrl: "https://cdn.shopify.com/s/files/1/1430/1974/files/holy-grail.png?v=1780076144"
    },
    {
      packKey: "free_love",
      title: "Free Love Pack",
      price: "$555",
      imageUrl: "https://cdn.shopify.com/s/files/1/1430/1974/files/free-love.png?v=1780076676"
    },
    {
      packKey: "hard_labor",
      title: "Hard Labor Pack",
      price: "$2,500",
      imageUrl: ""
    },
    {
      packKey: "penny_pincher",
      title: "Penny Pincher Pack",
      price: "$49.97",
      imageUrl: "https://cdn.shopify.com/s/files/1/1430/1974/files/penny_pincher_pack.png?v=1779472332"
    },
    {
      packKey: "gold",
      title: "Gold Pack",
      price: "$95",
      imageUrl: "https://cdn.shopify.com/s/files/1/1430/1974/files/gold_pack.png?v=1779427460"
    },
    {
      packKey: "honey",
      title: "Honey Pack",
      price: "$123.45",
      imageUrl: "https://cdn.shopify.com/s/files/1/1430/1974/files/honey_pack.png?v=1779472239"
    },
    {
      packKey: "anime",
      title: "Anime Pack",
      price: "$175",
      imageUrl: "https://cdn.shopify.com/s/files/1/1430/1974/files/anime_pack.png?v=1779472130"
    },
    {
      packKey: "classics",
      title: "Classics Pack",
      price: "$175",
      imageUrl: "https://cdn.shopify.com/s/files/1/1430/1974/files/classics_pack_3fd75b45-841b-467b-be3a-1d06aedb53a3.png?v=1779472179"
    },
    {
      packKey: "platinum",
      title: "Platinum Pack",
      price: "$250",
      imageUrl: "https://cdn.shopify.com/s/files/1/1430/1974/files/platinum_pack.png?v=1779427491"
    },
    {
      packKey: "serenity",
      title: "Serenity Pack",
      price: "$444",
      imageUrl: "https://cdn.shopify.com/s/files/1/1430/1974/files/serenity_pack.png?v=1779472374"
    },
    {
      packKey: "diamond",
      title: "Diamond Pack",
      price: "$500",
      imageUrl: "https://cdn.shopify.com/s/files/1/1430/1974/files/diamond_pack.png?v=1779427547"
    },
    {
      packKey: "mainline",
      title: "Mainline Pack",
      price: "$995",
      imageUrl: "https://cdn.shopify.com/s/files/1/1430/1974/files/mainline_pack.png?v=1779427589"
    },
    {
      packKey: "vision_quest",
      title: "Vision Quest Pack",
      price: "$26",
      imageUrl: ""
    },
    {
      packKey: "lost_in_vegas",
      title: "Lost in Vegas Pack",
      price: "$37",
      imageUrl: ""
    },
    {
      packKey: "chip_stacker",
      title: "Chip Stacker Pack",
      price: "$58",
      imageUrl: ""
    },
    {
      packKey: "bank_breaker",
      title: "Bank Breaker Pack",
      price: "$77",
      imageUrl: ""
    },
    {
      packKey: "slavic",
      title: "Slavic Pack",
      price: "$88",
      imageUrl: ""
    },
    {
      packKey: "breadwinner",
      title: "Breadwinner Pack",
      price: "$72",
      imageUrl: ""
    },
    {
      packKey: "ooze_sprayer",
      title: "Ooze Pack",
      price: "$52",
      imageUrl: ""
    },
    {
      packKey: "gusher",
      title: "Gusher Pack",
      price: "$34",
      imageUrl: ""
    }
  ];

  const initAll = (scope = document) => {
    scope.querySelectorAll("[data-wl-packs]").forEach((root) => {
      if (!(root instanceof HTMLElement)) return;
      if (root.dataset.wlPacksInitialized === "true") return;
      root.dataset.wlPacksInitialized = "true";
      new WlPacks(root).init();
    });
  };

  class WlPacks {
    constructor(root) {
      this.root = root;
      this.mount = root.querySelector("[data-wl-packs-app]");
      this.packProducts = getPackProducts(root);
      this.raffleProducts = getRaffleProducts(root);
      this.selectedPackIndex = firstAvailablePackIndex(this.packProducts);
      this.selectedPackSize = "";
      this.selectedPackTeamCode = "";
      this.packState = { creditBalance: 0, unopenedPacks: [], openedPacks: [], settledPacks: [] };
      this.raffleState = { creditBalance: 0, raffleTicketBalance: 0, freeEntryAvailable: false, freeEntryAvailableAt: null, raffles: [] };
      this.activeView = "packs";
      this.selectedRaffleId = "";
      this.raffleTicketQuantity = 1;
      this.raffleBusyAction = "";
      this.bonusPackState = null;
      this.revealedPackPurchase = null;
      this.revealedPackQueueTotal = 0;
      this.focusedPackPurchaseId = "";
      this.buyingPackVariantId = "";
      this.buyingPackWithCreditsVariantId = "";
      this.addingPackVariantId = "";
      this.openingPackPurchaseId = "";
      this.testingPackAnimation = false;
      this.shippingPackPurchaseId = "";
      this.sellingPackPurchaseId = "";
      this.rewardActionMessage = "";
      this.accountMenuOpen = false;
      this.notificationsOpen = false;
      this.readNotificationIds = new Set();
      this.waitingForPendingPack = false;
      this.packInfoPackKey = "";
      this.creditsInfoModalOpen = false;
      this.creditConfirmPack = null;
      this.creditOpeningPackPurchase = null;
      this.bonusPackSizeModalOpen = false;
      this.selectedBonusPackSize = this.selectedPackSize;
      this.packPointer = null;
      this.lastPackDragAt = 0;
      this.packSwayFrame = 0;
      this.packSwayResumeTimer = 0;
      this.packSwayViewer = null;
      this.packModelLoadToken = 0;
      this.packModelLoadCleanup = null;
      this.packModelSourceTimer = 0;
      this.packModelPrefetchTimer = 0;
      this.pendingPackPollTimer = 0;
      this.pendingPackPollAttempts = 0;
      this.packAvailability = { key: "", status: "idle", available: true, code: null, message: null };
      this.packAvailabilityRequestId = 0;
      this.raffleTimer = 0;
      this.packGuideCopyKey = "";
      this.packGuideCopyValue = "";
      this.previousPackGuideCopyByState = {};
      this.toastTimer = 0;
    }

    init() {
      if (!this.mount) return;
      ensureModelViewer();
      document.body.classList.add("wl-packs-page-active");
      window.addEventListener(
        "pagehide",
        () => {
          document.body.classList.remove("wl-packs-page-active");
          this.cancelPackSway();
          this.cancelPackModelSource();
          this.cancelPackModelPrefetch();
          this.cancelPendingPackPoll();
          this.stopRaffleTimer();
        },
        { once: true }
      );
      window.addEventListener("pageshow", (event) => {
        document.body.classList.add("wl-packs-page-active");
        if (!event.persisted || !this.config().customerId) return;
        this.refreshState({ quiet: true })
          .then(() => this.maybeAutoOpenPack())
          .catch((error) => this.toast(getErrorMessage(error)));
      });
      this.mount.innerHTML = this.shellMarkup();
      this.bind();
      this.readNotificationIds = loadReadNotificationIds(this.config());
      this.renderAll();
      this.startRaffleTimer();
      if (this.config().customerId) {
        this.refreshState({ quiet: true })
          .then(() => this.maybeAutoOpenPack())
          .catch((error) => this.toast(getErrorMessage(error)));
      }
    }

    config() {
      const localDev = localDevConfig();
      return {
        apiBase: localDev.apiBase || this.root.dataset.apiBase || "/apps/wl-packs",
        shop: localDev.shop || this.root.dataset.shop || "warren-lotus.myshopify.com",
        customerId: localDev.customerId || this.root.dataset.customerId || "",
        customerLabel: localDev.customerLabel || this.root.dataset.customerLabel || "",
        creditBalance: localDev.creditBalance || "",
        raffleTicketVariantId: localDev.raffleTicketVariantId || this.raffleState.raffleTicketVariantId || "",
        storefrontOrigin: this.root.dataset.storefrontOrigin || "",
        loginUrl: buildCustomerAccountUrl(
          this.root.dataset.loginUrl || "/customer_authentication/login",
          this.root.dataset.storefrontOrigin || ""
        ),
        cartUrl: normalizeLocalUrl(this.root.dataset.cartUrl || "/cart"),
        accountUrl: normalizeLocalUrl(this.root.dataset.accountUrl || "/account"),
        logoutUrl: normalizeLocalUrl(this.root.dataset.logoutUrl || "/account/logout"),
        bonusPackModelUrl: this.root.dataset.bonusPackModelUrl || modelUrlForPack(this.root, "bonus")
      };
    }

    bind() {
      this.root.addEventListener("pointerdown", (event) => this.trackPackPointerStart(event), { passive: true });
      this.root.addEventListener("pointermove", (event) => this.trackPackPointerMove(event), { passive: true });
      this.root.addEventListener("pointerup", (event) => this.trackPackPointerEnd(event), { passive: true });
      this.root.addEventListener("pointercancel", () => this.cancelPackPointer(), { passive: true });

      this.root.addEventListener("click", (event) => {
        const target = event.target instanceof Element ? event.target : null;
        const actionElement = target?.closest("[data-action]");
        const action = actionElement?.getAttribute("data-action");

        if (!target?.closest("[data-account-menu]")) {
          this.accountMenuOpen = false;
          this.renderAccountMenu();
        }
        if (!target?.closest("[data-notifications-menu]")) {
          this.notificationsOpen = false;
          this.renderNotificationsMenu();
        }

        if (!action || !(actionElement instanceof HTMLElement)) return;
        if (actionElement.closest(".wl-pack-card") && this.shouldSuppressPackCardClick()) {
          event.preventDefault();
          return;
        }
        event.preventDefault();

        if (action === "toggle-account-menu") this.toggleAccountMenu();
        if (action === "toggle-notifications") this.toggleNotifications();
        if (action === "mark-notification-read") this.markNotificationRead(actionElement.dataset.notificationId || "");
        if (action === "mark-all-notifications-read") this.markAllNotificationsRead();
        if (action === "pack-prev") this.movePackSelection(-1);
        if (action === "pack-next") this.movePackSelection(1);
        if (action === "open-raffles") void this.openRafflesView();
        if (action === "close-raffles") this.closeRafflesView();
        if (action === "select-raffle") this.selectRaffle(actionElement.dataset.raffleId || "");
        if (action === "raffle-back") {
          this.selectedRaffleId = "";
          this.renderRaffleView();
        }
        if (action === "raffle-qty-dec") this.changeRaffleTicketQuantity(-1);
        if (action === "raffle-qty-inc") this.changeRaffleTicketQuantity(1);
        if (action === "raffle-free-entry") void this.enterSelectedRaffleFree();
        if (action === "raffle-paid-entry") void this.enterSelectedRafflePaid("ticket");
        if (action === "raffle-credit-entry") void this.enterSelectedRafflePaid("credit");
        if (action === "buy-raffle-tickets") void this.buyRaffleTickets();
        if (action === "select-pack") this.selectPack(Number(actionElement.dataset.packIndex));
        if (action === "select-pack-size") this.selectPackSize(actionElement.dataset.packSize || "");
        if (action === "buy-pack") void this.buySelectedPack();
        if (action === "buy-pack-credits") void this.buySelectedPackWithCredits();
        if (action === "add-pack-to-cart") void this.addSelectedPackToCart();
        if (action === "pack-login") window.location.assign(this.config().loginUrl);
        if (action === "test-pack-opening") void this.testPackOpenAnimation();
        if (action === "open-pack") {
          const packPurchaseId = actionElement.dataset.packPurchaseId || this.focusedUnopenedPack()?.id || "";
          if (packPurchaseId) void this.openPackPurchase(packPurchaseId);
        }
        if (action === "resume-pack") {
          this.notificationsOpen = false;
          this.markNotificationRead(actionElement.dataset.notificationId || "", { silent: true });
          void this.resumePackQueue(actionElement.dataset.packPurchaseId || "");
        }
        if (action === "ship-pack") {
          const packPurchaseId = actionElement.dataset.packPurchaseId || this.revealedPackPurchase?.id || "";
          if (packPurchaseId) void this.shipPackPurchase(packPurchaseId);
        }
        if (action === "sell-pack") {
          const packPurchaseId = actionElement.dataset.packPurchaseId || this.revealedPackPurchase?.id || "";
          if (packPurchaseId) void this.sellPackPurchase(packPurchaseId);
        }
        if (action === "pack-home") this.returnToPackHome();
        if (action === "open-pack-info") this.openPackInfo(actionElement.dataset.packKey || "");
        if (action === "close-pack-info") this.closePackInfo();
        if (action === "open-credits-info") this.openCreditsInfo();
        if (action === "close-credits-info") this.closeCreditsInfo();
        if (action === "confirm-credit-pack") void this.confirmCreditPackPurchase();
        if (action === "close-credit-confirm") this.closeCreditConfirmModal();
        if (action === "open-bonus-pack") void this.openBonusPackAction();
        if (action === "close-bonus-pack-size") this.closeBonusPackSizeModal();
        if (action === "select-bonus-pack-size") this.selectBonusPackSize(actionElement.dataset.bonusPackSize || "");
        if (action === "confirm-bonus-pack-size") void this.confirmBonusPackSize();
      });

      this.root.addEventListener("change", (event) => {
        const target = event.target instanceof HTMLSelectElement ? event.target : null;
        if (target?.matches("[data-pack-team-select]")) {
          this.selectPackTeam(target.value);
        }
      });

      this.root.addEventListener("keydown", (event) => {
        if (event.key === "Escape") {
          if (this.packInfoPackKey) this.closePackInfo();
          if (this.creditsInfoModalOpen) this.closeCreditsInfo();
          if (this.creditConfirmPack) this.closeCreditConfirmModal();
          if (this.bonusPackSizeModalOpen) this.closeBonusPackSizeModal();
          this.accountMenuOpen = false;
          this.renderAccountMenu();
        }
        if (!this.packInfoPackKey && !this.creditsInfoModalOpen && !this.bonusPackSizeModalOpen && event.key === "ArrowLeft") {
          this.movePackSelection(-1);
        }
        if (!this.packInfoPackKey && !this.creditsInfoModalOpen && !this.bonusPackSizeModalOpen && event.key === "ArrowRight") {
          this.movePackSelection(1);
        }
      });
    }

    shellMarkup() {
      const config = this.config();
      return `
        <div class="wl-pack-screen" data-pack-screen aria-hidden="false">
          <div class="wl-pack-screen__topbar">
            <div class="wl-pack-screen__left-actions">
              <a class="wl-pack-main-store-link" href="/?${SKIP_PACK_REDIRECT_QUERY_PARAM}=1">Back to Main Store</a>
              <button type="button" class="wl-pack-side-button" data-action="open-raffles" data-raffle-nav-button>RAFFLE</button>
            </div>
            <div class="wl-pack-screen__actions">
              <button
                type="button"
                class="wl-pack-screen__credits"
                data-action="open-credits-info"
                data-credit-balance
                aria-haspopup="dialog"
              >
                <span class="wl-pack-screen__credits-label">Credits</span>
                <strong class="wl-pack-screen__credits-value" data-credit-balance-value>0</strong>
              </button>
              <div class="wl-notifications-menu" data-notifications-menu>
                <button
                  type="button"
                  class="wl-notifications-button"
                  data-action="toggle-notifications"
                  data-notifications-button
                  aria-haspopup="menu"
                  aria-expanded="false"
                  aria-label="Open notifications"
                >
                  <span class="wl-notifications-icon" aria-hidden="true"></span>
                  <strong data-notifications-count hidden>0</strong>
                </button>
                <div class="wl-notifications-menu__dropdown" data-notifications-panel role="menu"></div>
              </div>
              <div class="wl-account-menu wl-pack-account-menu" data-account-menu>
                <button
                  type="button"
                  class="wl-account-status"
                  data-action="toggle-account-menu"
                  data-account-status
                  aria-haspopup="menu"
                  aria-expanded="false"
                  aria-label="Open menu"
                >
                  <span class="wl-user-icon" aria-hidden="true"></span>
                </button>
                <div class="wl-account-menu__dropdown" role="menu">
                  <a href="${escapeAttr(config.cartUrl)}" role="menuitem" data-account-cart-link>Cart</a>
                  <a href="${escapeAttr(config.accountUrl)}" role="menuitem" data-account-orders-link>Past Orders</a>
                  <button type="button" class="wl-account-menu__button" data-action="open-bonus-pack" data-account-bonus-button role="menuitem">Bonus Packs</button>
                  ${config.customerId ? `<a href="${escapeAttr(config.logoutUrl)}" role="menuitem" data-account-logout-link>Log Out</a>` : `<a href="${escapeAttr(config.loginUrl)}" role="menuitem" data-account-login-link>Sign In</a>`}
                </div>
              </div>
              <a class="wl-pack-cart-button" href="${escapeAttr(config.cartUrl)}" aria-label="Open cart" data-pack-cart-link>
                <span class="wl-cart-icon" aria-hidden="true"></span>
              </a>
            </div>
          </div>
          <div class="wl-pack-guide" data-pack-guide hidden></div>
          <section class="wl-pack-screen__stage" data-pack-stage aria-labelledby="wl-pack-screen-title">
            <h1 id="wl-pack-screen-title" class="wl-visually-hidden" data-pack-title>WL Packs</h1>
            <div class="wl-pack-screen__queue" data-pack-queue hidden></div>
            <div class="wl-pack-screen__viewport">
              <button type="button" class="wl-pack-screen__arrow wl-pack-screen__arrow--previous" data-action="pack-prev" aria-label="Previous pack">&lt;</button>
              <div class="wl-pack-screen__track" data-pack-track></div>
              <button type="button" class="wl-pack-screen__arrow wl-pack-screen__arrow--next" data-action="pack-next" aria-label="Next pack">&gt;</button>
            </div>
            <div class="wl-pack-screen__dots" data-pack-dots aria-hidden="true"></div>
            <p class="wl-pack-screen__price" data-pack-price>$0</p>
            <div class="wl-pack-screen__sizes" data-pack-size-options aria-label="Choose pack size"></div>
            <div class="wl-pack-screen__team" data-pack-team-control hidden></div>
            <p class="wl-pack-screen__stock-note" data-pack-stock-note hidden>${escapeHtml(DEFAULT_PACK_STOCK_NOTE)}</p>
            <button type="button" class="wl-pack-screen__buy" data-action="buy-pack" data-pack-buy>Buy pack</button>
            <button type="button" class="wl-pack-screen__credit-buy" data-action="buy-pack-credits" data-pack-credit-buy hidden>Buy with credits</button>
            <button type="button" class="wl-pack-screen__add-cart" data-action="add-pack-to-cart" data-pack-add-cart>Add to cart</button>
            <div class="wl-pack-screen__reveal" data-pack-reveal hidden></div>
          </section>
          <section class="wl-raffle-view" data-raffle-view hidden aria-labelledby="wl-raffle-title"></section>
        </div>
        <div class="wl-credit-modal" data-credit-confirm-modal aria-hidden="true">
          <button type="button" class="wl-credit-modal__backdrop" data-action="close-credit-confirm" aria-label="Close"></button>
          <section class="wl-credit-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="wl-credit-confirm-title">
            <h2 id="wl-credit-confirm-title">Buy with credits</h2>
            <p data-credit-confirm-copy></p>
            <div class="wl-credit-modal__actions">
              <button type="button" data-action="close-credit-confirm">Back</button>
              <button type="button" data-action="confirm-credit-pack" data-credit-confirm-yes>Yes</button>
            </div>
          </section>
        </div>
        <div class="wl-credits-info-modal" data-credits-info-modal aria-hidden="true">
          <button type="button" class="wl-credits-info-modal__backdrop" data-action="close-credits-info" aria-label="Close"></button>
          <section class="wl-credits-info-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="wl-credits-info-title">
            <button type="button" class="wl-credits-info-modal__close" data-action="close-credits-info" data-credits-info-close aria-label="Close">&times;</button>
            <header class="wl-credits-info__header">
              <p class="wl-slot__hint">WL CREDITS</p>
              <h2 id="wl-credits-info-title">How credits work</h2>
              <strong data-credits-info-balance>Credits: 0</strong>
            </header>
            <div class="wl-credits-info__content">
              <section class="wl-credits-info__section">
                <h3>What they do</h3>
                <p>Credits are account balance for WL Packs. Use them toward eligible pack openings, raffle entries, and other pack-side rewards when available. We are constantly developing new ways for you to use these credits, so stay tuned.</p>
              </section>
              <section class="wl-credits-info__section">
                <h3>How to earn</h3>
                <p>When an eligible opened pack is sold back instead of shipped, or when a credit-award pack reveals credits, credits can be added back to your signed-in account.</p>
              </section>
              <section class="wl-credits-info__section">
                <h3>At checkout</h3>
                <p>If you have enough credits, some packs can open immediately. If you only have part of the cost, credits may be applied toward checkout where supported.</p>
              </section>
            </div>
          </section>
        </div>
        <div class="wl-pack-info-modal" data-pack-info-modal aria-hidden="true">
          <button type="button" class="wl-pack-info-modal__backdrop" data-action="close-pack-info" aria-label="Close"></button>
          <section class="wl-pack-info-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="wl-pack-info-title">
            <button type="button" class="wl-pack-info-modal__close" data-action="close-pack-info" data-pack-info-close aria-label="Close">&times;</button>
            <div data-pack-info-body></div>
          </section>
        </div>
        <div class="wl-size-modal wl-bonus-size-modal" data-bonus-size-modal aria-hidden="true">
          <button type="button" class="wl-size-modal__backdrop" data-action="close-bonus-pack-size" aria-label="Close"></button>
          <section class="wl-size-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="wl-bonus-size-modal-title">
            <header>
              <div>
                <p class="wl-slot__hint">BONUS PACK</p>
                <h2 id="wl-bonus-size-modal-title">Choose Size</h2>
                <p class="wl-size-modal__summary" data-bonus-size-modal-summary>Choose before claiming</p>
              </div>
              <button type="button" class="wl-size-modal__close" data-action="close-bonus-pack-size" aria-label="Close">&times;</button>
            </header>
            <div class="wl-size-modal__groups wl-bonus-size-modal__groups">
              <section class="wl-size-modal__group wl-bonus-size-modal__group">
                <h3>Bonus Pack Size</h3>
                <p class="wl-bonus-size-modal__note">Used if your bonus pack hits apparel.</p>
                <div class="wl-size-modal__options" data-bonus-size-options></div>
                <button type="button" class="wl-bonus-size-modal__claim" data-action="confirm-bonus-pack-size" data-bonus-size-confirm>
                  Confirm size
                </button>
              </section>
            </div>
          </section>
        </div>
        <div class="wl-toast" data-toast></div>
      `;
    }

    renderAll() {
      const screen = this.root.querySelector("[data-pack-screen]");
      if (screen) screen.dataset.activeView = this.activeView;
      this.renderPackSelection();
      this.renderRaffleView();
      this.renderPackInfoModal();
      this.renderCreditsInfoModal();
      this.renderCreditConfirmModal();
      this.renderBonusPackSizeModal();
      this.renderNotificationsMenu();
      this.renderAccountMenu();
    }

    renderCreditBalance() {
      const creditBalance = this.root.querySelector("[data-credit-balance]");
      const creditBalanceValue = this.root.querySelector("[data-credit-balance-value]");
      const config = this.config();
      const raffleCredits = Number(this.raffleState?.creditBalance);
      const packCredits = Number(this.packState?.creditBalance);
      const devCreditBalanceValue = String(config.creditBalance || "").trim();
      const devCreditBalance = devCreditBalanceValue ? Number(devCreditBalanceValue) : NaN;
      const availableCredits = Number.isFinite(devCreditBalance)
        ? devCreditBalance
        : Number.isFinite(raffleCredits) && this.activeView === "raffles"
          ? raffleCredits
          : packCredits;
      const normalized = config.customerId ? Math.max(0, Number(availableCredits) || 0) : 0;
      const formatted = formatCredits(normalized);
      if (creditBalanceValue) creditBalanceValue.textContent = formatted;
      if (creditBalance) {
        if (!creditBalanceValue) creditBalance.textContent = `Credits: ${formatted}`;
        creditBalance.setAttribute("aria-label", `Open credits explanation. Current balance: ${formatted} credits.`);
      }
      return normalized;
    }

    renderPackSelection() {
      const screen = this.root.querySelector("[data-pack-screen]");
      if (!screen) return;
      const stage = this.root.querySelector("[data-pack-stage]");
      if (this.activeView !== "packs") {
        if (stage) stage.hidden = true;
        this.cancelPackModelSourceTimer();
        this.cancelPackModelPrefetch();
        this.hidePackGuide();
        this.renderCreditBalance();
        return;
      }
      if (stage) stage.hidden = false;

      if (this.packProducts.length === 0) {
        screen.dataset.packMode = "empty";
        this.require("[data-pack-track]").innerHTML = `<p class="wl-pack-empty">No packs are configured.</p>`;
        this.require("[data-pack-price]").textContent = "Unavailable";
        this.require("[data-pack-buy]").disabled = true;
        this.require("[data-pack-buy]").textContent = "Unavailable";
        this.require("[data-pack-add-cart]").hidden = true;
        this.require("[data-pack-size-options]").hidden = true;
        this.require("[data-pack-team-control]").hidden = true;
        this.require("[data-pack-stock-note]").hidden = true;
        this.renderPackGuide(this.randomPackGuideCopy("welcome", "empty"));
        return;
      }

      const config = this.config();
      const selected = this.packProducts[this.selectedPackIndex] || this.packProducts[0];
      const unopened = this.creditOpeningPackPurchase || this.focusedUnopenedPack();
      const revealed = this.revealedPackPurchase;
      const pendingCheckout = this.waitingForPendingPack ? loadPendingPackCheckout(config.shop) : null;
      const pendingPack = pendingCheckout ? this.packProductForPendingCheckout(pendingCheckout) : null;
      const displayPack =
        (revealed ? this.packProductForPurchase(revealed) : null) ||
        (unopened ? this.packProductForPurchase(unopened) : null) ||
        pendingPack ||
        selected;
      const displayPackIndex = displayPack ? this.packProducts.findIndex((pack) => {
        if (pack === displayPack) return true;
        if (displayPack.packKey && pack.packKey === displayPack.packKey) return true;
        const packProductId = normalizeShopifyNumericId(pack.productId || pack.id);
        const displayProductId = normalizeShopifyNumericId(displayPack.productId || displayPack.id);
        return Boolean(packProductId && displayProductId && packProductId === displayProductId);
      }) : -1;
      const activePackIndex = displayPackIndex >= 0 ? displayPackIndex : this.selectedPackIndex;
      const packMode = revealed ? "revealed" : unopened ? "open" : "checkout";
      const selectedVariant = packCheckoutVariant(selected, this.selectedPackSize);
      const selectedPackHasAvailableSizes = Boolean(selected?.available);
      const selectedPackNeedsSize =
        packMode === "checkout" && Boolean(selected && selectedPackHasAvailableSizes && !this.selectedPackSize);
      const selectedPackTeamRequirement = sportsLeagueForPack(selected);
      const selectedPackTeam = packTeamSelection(selected, this.selectedPackTeamCode);
      const selectedPackNeedsTeam =
        packMode === "checkout" && Boolean(selected && selectedPackTeamRequirement && !selectedPackTeam);
      const selectedPackSoldOut =
        packMode === "checkout" &&
        Boolean(selected && (!selectedPackHasAvailableSizes || (this.selectedPackSize && !selectedVariant)));
      const selectedPackTeamSoldOut = Boolean(
        packMode === "checkout" &&
          selectedPackTeamRequirement &&
          selectedPackTeam &&
          isPackTeamSoldOut(selected, selectedPackTeam)
      );
      if (packMode === "checkout" && selectedPackTeamRequirement && selectedPackTeam && selectedVariant && !selectedPackTeamSoldOut) {
        this.ensurePackAvailability(selected, selectedVariant, this.selectedPackSize, selectedPackTeam);
      }
      const selectedPackAvailability = config.customerId ? this.packAvailabilityFor(
        selected,
        selectedVariant,
        this.selectedPackSize,
        selectedPackTeam
      ) : null;
      const selectedPackAvailabilityLoading = Boolean(selectedPackAvailability?.status === "loading");
      const selectedPackTeamStockUnavailable = Boolean(
        packMode === "checkout" &&
          selectedPackTeamRequirement &&
          selectedPackTeam &&
          selectedVariant &&
          (selectedPackTeamSoldOut || selectedPackAvailability?.available === false)
      );
      const animationTestMode = isPackAnimationTestMode();
      const displayVariant = displayPack
        ? packCheckoutVariant(displayPack, revealed?.packSize || unopened?.packSize || pendingCheckout?.packSize || this.selectedPackSize)
        : null;
      const requiresLogin = !config.customerId;
      const queue = this.require("[data-pack-queue]");
      const title = this.require("[data-pack-title]");
      const creditBalance = this.require("[data-credit-balance]");
      const price = this.require("[data-pack-price]");
      const buyButton = this.require("[data-pack-buy]");
      const creditBuyButton = this.require("[data-pack-credit-buy]");
      const addToCartButton = this.require("[data-pack-add-cart]");
      const sizeOptions = this.require("[data-pack-size-options]");
      const teamControl = this.require("[data-pack-team-control]");
      const stockNote = this.require("[data-pack-stock-note]");
      const reveal = this.require("[data-pack-reveal]");
      const dots = this.require("[data-pack-dots]");
      const previous = this.require("[data-action='pack-prev']");
      const next = this.require("[data-action='pack-next']");
      const unopenedCount = this.totalUnopenedPacks();
      const waitingForPendingPack = this.waitingForPendingPack && packMode === "checkout";

      screen.dataset.packMode = packMode;
      this.renderPackGuide(this.packGuideCopy(config, selected, unopened, revealed, waitingForPendingPack));
      previous.hidden = Boolean(unopened || revealed) || this.packProducts.length <= 1;
      next.hidden = previous.hidden;
      previous.disabled = previous.hidden;
      next.disabled = next.hidden;

      title.textContent = revealed
        ? `${revealed.packTitle} Opened`
        : unopened
          ? `Open ${unopened.packTitle}`
          : pendingPack
            ? `Preparing ${pendingPack.packName || pendingPack.title || "Pack"}`
          : selected?.packName || selected?.title || "WL Packs";
      price.textContent = revealed
        ? `${revealed.packSize} / ${revealed.shopifyOrderName || "Opened"}`
        : unopened
          ? `${unopened.packSize} / ${unopened.shopifyOrderName || "Paid"}`
          : pendingCheckout
            ? `${pendingCheckout.packSize || "Pack"} / Preparing`
          : selectedVariant?.price || selected?.price || "Unavailable";

      const queueMarkup = waitingForPendingPack
        ? "CHECKING PURCHASE / PREPARING OPENING"
        : revealed
          ? escapeHtml(packQueueOpenedStatus(this.revealedPackQueueTotal, unopenedCount))
          : unopened
            ? escapeHtml(packQueueReadyStatus(unopenedCount))
            : "";
      queue.hidden = !queueMarkup;
      queue.innerHTML = queueMarkup;
      const availableCredits = this.renderCreditBalance();

      const showCheckoutSizes = Boolean(selected && !unopened && !revealed && !waitingForPendingPack);
      sizeOptions.hidden = !showCheckoutSizes;
      stockNote.hidden = !showCheckoutSizes;
      sizeOptions.innerHTML = showCheckoutSizes
        ? APPAREL_SIZES.map((size) => {
            const variant = packCheckoutVariant(selected, size);
            const active = size === this.selectedPackSize;
            return `
              <button
                type="button"
                class="${active ? "is-active" : ""}"
                data-action="select-pack-size"
                data-pack-size="${escapeAttr(size)}"
                aria-pressed="${active}"
                ${variant?.available ? "" : "disabled"}
              >${escapeHtml(size)}</button>
            `;
          }).join("")
        : "";
      const showTeamSelector = Boolean(showCheckoutSizes && selectedPackTeamRequirement);
      teamControl.hidden = !showTeamSelector;
      teamControl.innerHTML = showTeamSelector
        ? packTeamSelectMarkup(selected, selectedPackTeamRequirement, this.selectedPackTeamCode)
        : "";
      stockNote.classList.toggle("is-unavailable", selectedPackTeamStockUnavailable);
      stockNote.textContent = selectedPackTeamStockUnavailable ? TEAM_STOCK_UNAVAILABLE_MESSAGE : DEFAULT_PACK_STOCK_NOTE;

      buyButton.hidden = Boolean(revealed);
      buyButton.dataset.action = animationTestMode && packMode === "checkout"
        ? "test-pack-opening"
        : selectedPackSoldOut || selectedPackTeamStockUnavailable
          ? "buy-pack"
          : requiresLogin
            ? "pack-login"
            : unopened
              ? "open-pack"
              : "buy-pack";
      if (unopened) buyButton.dataset.packPurchaseId = unopened.id;
      else buyButton.removeAttribute("data-pack-purchase-id");
      const packCartBusy = Boolean(this.buyingPackVariantId || this.buyingPackWithCreditsVariantId || this.addingPackVariantId);
      const checkoutBusy = Boolean(this.buyingPackVariantId);
      const openBusy = Boolean(this.openingPackPurchaseId || this.testingPackAnimation);
      buyButton.disabled = waitingForPendingPack
        ? true
        : unopened
          ? openBusy
          : animationTestMode && packMode === "checkout"
            ? openBusy || !displayPack
            : selectedPackNeedsSize
              ? true
            : selectedPackNeedsTeam
              ? true
              : selectedPackAvailabilityLoading
                ? true
              : selectedPackTeamStockUnavailable
                ? true
              : selectedPackSoldOut
                ? true
                : requiresLogin
                  ? false
                  : !selectedVariant || packCartBusy;
      buyButton.classList.toggle("is-busy", waitingForPendingPack || checkoutBusy || openBusy);
      buyButton.setAttribute("aria-busy", String(waitingForPendingPack || checkoutBusy || openBusy));
      let buyButtonText = "Sold out";
      if (waitingForPendingPack) {
        buyButtonText = "Checking purchase";
      } else if (selectedPackNeedsSize) {
        buyButtonText = "Choose size";
      } else if (selectedPackNeedsTeam) {
        buyButtonText = "Choose team";
      } else if (selectedPackAvailabilityLoading) {
        buyButtonText = "Checking stock";
      } else if ((selectedPackSoldOut || selectedPackTeamStockUnavailable) && !(animationTestMode && packMode === "checkout")) {
        buyButtonText = "Sold out";
      } else if (animationTestMode && packMode === "checkout") {
        buyButtonText = openBusy ? "Testing opening" : "TEST OPENING";
      } else if (requiresLogin) {
        buyButtonText = "SIGN IN TO BUY";
      } else if (unopened) {
        buyButtonText = openBusy ? "Opening pack" : "OPEN PACK";
      } else if (checkoutBusy) {
        buyButtonText = "Opening checkout";
      } else if (selectedVariant) {
        buyButtonText = `Checkout${selectedVariant.price ? ` - ${selectedVariant.price}` : ""}`;
      }
      buyButton.textContent = buyButtonText;

      const selectedCreditCost = selectedVariant ? creditsForPriceCents(packPriceCents(selected, selectedVariant)) : 0;
      const showCreditBuy =
        packMode === "checkout" &&
        !waitingForPendingPack &&
        !animationTestMode &&
        config.customerId &&
        availableCredits > 0 &&
        selectedVariant &&
        !selectedPackNeedsTeam &&
        !selectedPackAvailabilityLoading &&
        !selectedPackSoldOut &&
        !selectedPackTeamStockUnavailable;
      creditBuyButton.hidden = !showCreditBuy;
      creditBuyButton.disabled = !showCreditBuy || packCartBusy;
      creditBuyButton.classList.toggle("is-busy", Boolean(this.buyingPackWithCreditsVariantId));
      creditBuyButton.setAttribute("aria-busy", String(Boolean(this.buyingPackWithCreditsVariantId)));
      creditBuyButton.textContent =
        showCreditBuy && availableCredits >= selectedCreditCost
          ? `Buy with ${formatCredits(selectedCreditCost)} credits`
          : "Buy with credits";

      addToCartButton.hidden =
        packMode !== "checkout" ||
        waitingForPendingPack ||
        requiresLogin ||
        selectedPackSoldOut ||
        selectedPackTeamStockUnavailable ||
        animationTestMode;
      addToCartButton.dataset.action = requiresLogin ? "pack-login" : "add-pack-to-cart";
      addToCartButton.disabled =
        requiresLogin ? false : !selectedVariant || selectedPackNeedsTeam || selectedPackAvailabilityLoading || packCartBusy;
      addToCartButton.classList.toggle("is-busy", Boolean(this.addingPackVariantId));
      addToCartButton.setAttribute("aria-busy", String(Boolean(this.addingPackVariantId)));
      addToCartButton.textContent = "Add to cart";

      this.renderPackModel(displayPack, displayVariant, activePackIndex, packMode, unopened);

      reveal.hidden = !revealed;
      reveal.innerHTML = revealed
        ? packRevealMarkup(revealed, unopenedCount, {
            shipping: this.shippingPackPurchaseId === revealed.id,
            selling: this.sellingPackPurchaseId === revealed.id,
            message: this.rewardActionMessage
          })
        : "";
      bindRevealImageFallbacks(reveal);

      dots.hidden = this.packProducts.length <= 1 || Boolean(unopened || revealed);
      dots.innerHTML = this.packProducts
        .map((_, index) => `<span class="${index === activePackIndex ? "is-active" : ""}"></span>`)
        .join("");
    }

    renderRaffleView() {
      const raffleView = this.root.querySelector("[data-raffle-view]");
      const navButton = this.root.querySelector("[data-raffle-nav-button]");
      if (!raffleView) return;
      const active = this.activeView === "raffles";
      raffleView.hidden = !active;
      if (navButton) {
        navButton.textContent = active ? "PACKS" : "RAFFLE";
        navButton.dataset.action = active ? "close-raffles" : "open-raffles";
      }
      if (!active) return;

      const config = this.config();
      const raffles = this.mergedRaffles();
      const selected = this.selectedRaffle();
      raffleView.classList.toggle("is-detail", Boolean(selected));
      raffleView.innerHTML = selected
        ? raffleDetailMarkup(selected, {
            loggedIn: Boolean(config.customerId),
            quantity: this.raffleTicketQuantity,
            busyAction: this.raffleBusyAction,
            creditBalance: Number(this.raffleState.creditBalance || 0),
            ticketBalance: Number(this.raffleState.raffleTicketBalance || 0),
            ticketVariantId: config.raffleTicketVariantId
          })
        : raffleListMarkup(raffles, {
            loggedIn: Boolean(config.customerId),
            loading: this.raffleBusyAction === "loading"
          });
      this.bindRaffleModelFallbacks(raffleView);
      this.updateRaffleTimers();
      this.renderCreditBalance();
    }

    bindRaffleModelFallbacks(root) {
      root.querySelectorAll("[data-raffle-model]").forEach((mount) => {
        if (mount.dataset.raffleModelBound) return;
        const modelViewer = mount.querySelector("model-viewer");
        if (!modelViewer) return;
        mount.dataset.raffleModelBound = "true";
        modelViewer.addEventListener(
          "load",
          () => {
            mount.classList.remove("is-model-loading");
            mount.classList.add("is-model-loaded");
            this.startPackSway(modelViewer);
          },
          { once: true }
        );
        modelViewer.addEventListener(
          "error",
          () => {
            mount.classList.remove("is-model-loading");
            mount.classList.add("is-model-error");
          },
          { once: true }
        );
      });
    }

    mergedRaffles() {
      const productByVariant = new Map();
      const productByProduct = new Map();
      this.raffleProducts.forEach((product) => {
        productByProduct.set(normalizeId(product.productId || product.id), product);
        (product.variants || []).forEach((variant) => productByVariant.set(normalizeId(variant.id), { product, variant }));
      });
      return (this.raffleState.raffles || []).map((raffle) => {
        const match =
          productByVariant.get(normalizeId(raffle.shopifyVariantId)) ||
          productByProduct.get(normalizeId(raffle.shopifyProductId));
        const product = match?.product || match || null;
        const variant = match?.variant || null;
        const productImageUrl = String(product?.imageUrl || "").trim();
        const raffleImageUrl = String(raffle.imageUrl || "").trim();
        const modelPackKey =
          product?.packKey ||
          packKeyForProductText([raffle.title, product?.title, product?.packName, variant?.title].join(" ").toLowerCase());
        return {
          ...raffle,
          title: raffle.title || product?.title || product?.packName || "Raffle",
          packKey: modelPackKey || product?.packKey || "",
          description: raffle.description || product?.description || "",
          imageUrl: productImageUrl || raffleImageUrl || "",
          modelUrl: raffle.modelUrl || product?.modelUrl || modelUrlForPack(this.root, modelPackKey) || "",
          variantTitle: variant?.title || ""
        };
      });
    }

    selectedRaffle() {
      const raffles = this.mergedRaffles();
      if (this.selectedRaffleId) {
        return raffles.find((raffle) => raffle.id === this.selectedRaffleId) || null;
      }
      return null;
    }

    packGuideCopy(config, selected, unopened, revealed, waitingForPendingPack) {
      if (this.shippingPackPurchaseId) return this.randomPackGuideCopy("shipping", this.shippingPackPurchaseId);
      if (revealed) return this.randomPackGuideCopy("revealed", revealed.id || revealed.shopifyOrderName || "revealed");
      if (this.openingPackPurchaseId || this.testingPackAnimation || waitingForPendingPack) {
        return this.randomPackGuideCopy("opening", this.openingPackPurchaseId || (waitingForPendingPack ? "pending" : "test"));
      }
      if (unopened) return this.randomPackGuideCopy("open", unopened.id || unopened.shopifyOrderName || "open");
      if (!config.customerId) return this.randomPackGuideCopy("welcome", "guest");
      return selected
        ? this.randomPackGuideCopy("browsing", selected.id || selected.packKey || selected.handle || selected.title || this.selectedPackIndex)
        : this.randomPackGuideCopy("welcome", "logged-in-empty");
    }

    randomPackGuideCopy(state, context = "") {
      const copyOptions = PACK_GUIDE_COPY[state] || PACK_GUIDE_COPY.browsing;
      const normalizedOptions = Array.isArray(copyOptions) ? copyOptions : [copyOptions];
      const usableOptions = normalizedOptions.map((copy) => String(copy || "").trim()).filter(Boolean);
      if (usableOptions.length === 0) return "";

      const cacheKey = `${state}:${context}`;
      if (this.packGuideCopyKey === cacheKey && this.packGuideCopyValue) return this.packGuideCopyValue;

      const previousCopy = this.previousPackGuideCopyByState[state] || "";
      const nonRepeatingOptions = usableOptions.filter((copy) => copy !== previousCopy);
      const activeOptions = nonRepeatingOptions.length > 0 ? nonRepeatingOptions : usableOptions;
      const selectedCopy = activeOptions[Math.floor(Math.random() * activeOptions.length)];

      this.packGuideCopyKey = cacheKey;
      this.packGuideCopyValue = selectedCopy;
      this.previousPackGuideCopyByState[state] = selectedCopy;
      return selectedCopy;
    }

    renderPackGuide(copy = PACK_GUIDE_COPY.browsing[0]) {
      const guide = this.root.querySelector("[data-pack-guide]");
      if (!guide) return;

      const characterUrl = packGuideCharacterUrl(this.root);
      if (!characterUrl) {
        guide.hidden = true;
        guide.innerHTML = "";
        guide.removeAttribute("data-pack-guide-rendered-key");
        return;
      }

      const renderedKey = `${characterUrl}:${copy}`;
      guide.hidden = false;
      if (guide.dataset.packGuideRenderedKey === renderedKey) return;

      guide.dataset.packGuideRenderedKey = renderedKey;
      guide.innerHTML = `
        <p class="wl-pack-guide__bubble">${escapeHtml(copy)}</p>
        <img
          class="wl-pack-guide__character"
          src="${escapeAttr(characterUrl)}"
          width="${PACK_GUIDE_CHARACTER_DIMENSIONS.width}"
          height="${PACK_GUIDE_CHARACTER_DIMENSIONS.height}"
          alt=""
          loading="eager"
          decoding="async"
        >
      `;
    }

    hidePackGuide() {
      const guide = this.root.querySelector("[data-pack-guide]");
      if (!guide) return;
      guide.hidden = true;
      guide.innerHTML = "";
      guide.removeAttribute("data-pack-guide-rendered-key");
    }

    renderPackModel(displayPack, displayVariant, activePackIndex, packMode, unopened) {
      const track = this.require("[data-pack-track]");
      const modelUrl = displayPack?.modelUrl || modelUrlForPack(this.root, displayPack?.packKey) || "";
      const fallbackImageUrl = packFallbackImageUrl(displayPack);
      const staticModelAvailable = Boolean(modelUrl && (packMode === "checkout" || !fallbackImageUrl));
      const modelControls = isMobilePackViewport() ? "" : "camera-controls";
      const animationTestAvailable = packMode === "checkout" && isPackAnimationTestMode();
      const infoAvailable = packMode === "checkout" && !animationTestAvailable;
      const cardAction = animationTestAvailable ? "test-pack-opening" : infoAvailable ? "open-pack-info" : unopened ? "open-pack" : "select-pack";
      const cardLabel = infoAvailable
        ? `View ${displayPack.packName} contents and odds`
        : animationTestAvailable
          ? `Test ${displayPack.packName} opening animation`
          : `${displayPack.packName} ${displayVariant?.price || displayPack.price || ""}`.trim();

      if (staticModelAvailable) {
        this.renderCheckoutPackModel(track, {
          activePackIndex,
          cardAction,
          cardLabel,
          displayPack,
          modelControls,
          modelUrl,
          packMode,
          unopened
        });
        return;
      }

      this.cancelPackModelSource();
      this.cancelPackModelPrefetch();
      const imageUrl = fallbackImageUrl;
      const modelKey = `${displayPack?.id || ""}:${modelUrl}:${imageUrl}:${packMode}:image:${unopened?.id || ""}`;

      if (track.dataset.packModelKey === modelKey) {
        const card = track.querySelector(".wl-pack-card");
        if (card) {
          card.dataset.action = cardAction;
          card.dataset.packIndex = String(activePackIndex);
          card.dataset.packKey = displayPack.packKey;
          card.classList.toggle("is-revealed-pack", packMode === "revealed");
          if (unopened) card.dataset.packPurchaseId = unopened.id;
          else card.removeAttribute("data-pack-purchase-id");
          card.setAttribute("aria-label", cardLabel);
        }
        return;
      }

      this.cancelPackSway();
      track.dataset.packModelMode = "fallback-image";
      track.dataset.packModelKey = modelKey;
      track.innerHTML = `
        <button
          type="button"
          class="wl-pack-card is-active ${packMode === "revealed" ? "is-revealed-pack" : ""}"
          data-action="${escapeAttr(cardAction)}"
          data-pack-index="${activePackIndex}"
          data-pack-key="${escapeAttr(displayPack.packKey)}"
          ${unopened ? `data-pack-purchase-id="${escapeAttr(unopened.id)}"` : ""}
          aria-label="${escapeAttr(cardLabel)}"
          aria-pressed="true"
        >
          <span class="wl-pack-card__tap-label" aria-hidden="true">TAP THE PACK</span>
          <span class="wl-pack-model ${imageUrl ? "" : "is-image-missing"}" data-pack-model aria-hidden="true">
            ${imageUrl ? `<img class="wl-pack-model__fallback" src="${escapeAttr(imageUrl)}" alt="">` : ""}
            <span class="wl-pack-model__placeholder">${escapeHtml(packImageFallbackLabel(displayPack))}</span>
          </span>
        </button>
      `;
      const modelMount = track.querySelector("[data-pack-model]");
      const modelViewer = modelMount?.querySelector("model-viewer");
      if (modelViewer) {
        modelViewer.addEventListener(
          "load",
          () => {
            modelMount.classList.remove("is-model-loading");
            modelMount.classList.add("is-model-loaded");
            this.startPackSway(modelViewer);
          },
          { once: true }
        );
        modelViewer.addEventListener(
          "error",
          () => {
            modelMount.classList.remove("is-model-loading");
            modelMount.classList.add("is-model-error");
          },
          { once: true }
        );
      }
      const fallbackImage = modelMount?.querySelector(".wl-pack-model__fallback");
      if (fallbackImage instanceof HTMLImageElement) {
        modelMount.classList.add("is-swaying-fallback");
        fallbackImage.addEventListener("load", () => modelMount.classList.remove("is-image-missing"), { once: true });
        fallbackImage.addEventListener("error", () => modelMount.classList.add("is-image-missing"), { once: true });
      }
    }

    renderCheckoutPackModel(track, options) {
      const { activePackIndex, cardAction, cardLabel, displayPack, modelControls, modelUrl, packMode, unopened } = options;
      const modelKey = `${displayPack?.id || ""}:${modelUrl}:${packMode}:model:${unopened?.id || ""}`;
      const hasReusableModel =
        track.dataset.packModelMode === "static-model" &&
        track.querySelector(".wl-pack-card") &&
        track.querySelector("[data-pack-model] model-viewer");

      if (!hasReusableModel) {
        this.cancelPackSway();
        this.cancelPackModelSource();
        track.dataset.packModelMode = "static-model";
        track.innerHTML = `
          <button
            type="button"
            class="wl-pack-card is-active ${packMode === "revealed" ? "is-revealed-pack" : ""}"
            aria-pressed="true"
          >
            <span class="wl-pack-card__tap-label" aria-hidden="true">TAP THE PACK</span>
            <span class="wl-pack-model has-static-model is-model-loading" data-pack-model aria-hidden="true">
              <model-viewer disable-zoom interaction-prompt="none" loading="eager" reveal="auto" camera-orbit="${packFrontCameraOrbit()}" min-camera-orbit="${packSwayMinOrbit()}" max-camera-orbit="${packSwayMaxOrbit()}" field-of-view="30deg" min-field-of-view="30deg" max-field-of-view="30deg" shadow-intensity="0.85"></model-viewer>
            </span>
          </button>
        `;
      }

      const card = track.querySelector(".wl-pack-card");
      const modelMount = track.querySelector("[data-pack-model]");
      const modelViewer = modelMount?.querySelector("model-viewer");
      if (!(card instanceof HTMLElement) || !(modelMount instanceof HTMLElement) || !(modelViewer instanceof HTMLElement)) return;
      const currentModelSrc = String(modelViewer.getAttribute("src") || "").trim();
      const modelSettled =
        modelMount.classList.contains("is-model-loaded") || modelMount.classList.contains("is-model-error");

      card.dataset.action = cardAction;
      card.dataset.packIndex = String(activePackIndex);
      card.dataset.packKey = displayPack.packKey;
      card.classList.toggle("is-revealed-pack", packMode === "revealed");
      if (unopened) card.dataset.packPurchaseId = unopened.id;
      else card.removeAttribute("data-pack-purchase-id");
      card.setAttribute("aria-label", cardLabel);

      modelViewer.toggleAttribute("camera-controls", Boolean(modelControls));
      modelViewer.setAttribute("disable-zoom", "");
      modelViewer.setAttribute("interaction-prompt", "none");
      modelViewer.setAttribute("loading", "eager");
      modelViewer.setAttribute("reveal", "auto");
      modelViewer.setAttribute("camera-orbit", packFrontCameraOrbit());
      modelViewer.setAttribute("min-camera-orbit", packSwayMinOrbit());
      modelViewer.setAttribute("max-camera-orbit", packSwayMaxOrbit());
      modelViewer.setAttribute("field-of-view", "30deg");
      modelViewer.setAttribute("min-field-of-view", "30deg");
      modelViewer.setAttribute("max-field-of-view", "30deg");
      modelViewer.setAttribute("shadow-intensity", "0.85");
      modelViewer.setAttribute("alt", displayPack.packName || displayPack.title || "WL Pack");

      if (track.dataset.packModelKey === modelKey && currentModelSrc === modelUrl && !this.packModelSourceTimer && modelSettled) {
        this.queueNearbyPackModelPrefetch(activePackIndex);
        return;
      }

      this.loadCheckoutPackModel(track, modelMount, modelViewer, modelUrl, modelKey);
      this.queueNearbyPackModelPrefetch(activePackIndex);
    }

    loadCheckoutPackModel(track, modelMount, modelViewer, modelUrl, modelKey) {
      const nextSrc = String(modelUrl || "").trim();
      if (!nextSrc) return;
      const currentSrc = String(modelViewer.getAttribute("src") || "").trim();
      const delayMs = currentSrc ? PACK_MODEL_SOURCE_DEBOUNCE_MS : 0;
      const loadToken = String(++this.packModelLoadToken);

      if (this.packModelSourceTimer) window.clearTimeout(this.packModelSourceTimer);
      this.packModelSourceTimer = 0;
      this.cancelPackSway();
      if (currentSrc === nextSrc) {
        this.cleanupPackModelLoadListeners();
        track.dataset.packModelKey = modelKey;
        modelMount.dataset.packModelLoadToken = loadToken;
        modelMount.dataset.packModelSrc = nextSrc;
        modelMount.classList.remove("is-model-loading", "is-model-error");
        modelMount.classList.add("is-model-loaded");
        this.startPackSway(modelViewer);
        return;
      }
      this.cleanupPackModelLoadListeners();
      modelMount.dataset.packModelLoadToken = loadToken;
      modelMount.dataset.packModelSrc = nextSrc;
      modelMount.classList.add("has-static-model", "is-model-loading");
      modelMount.classList.remove("is-model-loaded", "is-model-error", "is-image-missing", "is-swaying-fallback");

      const startLoad = () => {
        this.packModelSourceTimer = 0;
        if (!modelMount.isConnected || modelMount.dataset.packModelLoadToken !== loadToken) return;
        track.dataset.packModelKey = modelKey;

        const finishLoad = () => {
          cleanupListeners();
          if (!modelMount.isConnected || modelMount.dataset.packModelLoadToken !== loadToken) return;
          if (String(modelViewer.getAttribute("src") || "").trim() !== nextSrc) return;
          modelMount.classList.remove("is-model-loading", "is-model-error");
          modelMount.classList.add("is-model-loaded");
          this.startPackSway(modelViewer);
        };
        const failLoad = () => {
          cleanupListeners();
          if (!modelMount.isConnected || modelMount.dataset.packModelLoadToken !== loadToken) return;
          modelMount.classList.remove("is-model-loading", "is-model-loaded");
          modelMount.classList.add("is-model-error");
        };
        const cleanupListeners = () => {
          modelViewer.removeEventListener("load", finishLoad);
          modelViewer.removeEventListener("error", failLoad);
          if (this.packModelLoadCleanup === cleanupListeners) this.packModelLoadCleanup = null;
        };

        modelViewer.addEventListener("load", finishLoad, { once: true });
        modelViewer.addEventListener("error", failLoad, { once: true });
        this.packModelLoadCleanup = cleanupListeners;
        modelViewer.setAttribute("src", nextSrc);
      };

      if (delayMs > 0) {
        this.packModelSourceTimer = window.setTimeout(startLoad, delayMs);
      } else {
        startLoad();
      }
    }

    cleanupPackModelLoadListeners() {
      if (!this.packModelLoadCleanup) return;
      this.packModelLoadCleanup();
      this.packModelLoadCleanup = null;
    }

    cancelPackModelSourceTimer() {
      if (this.packModelSourceTimer) window.clearTimeout(this.packModelSourceTimer);
      this.packModelSourceTimer = 0;
    }

    cancelPackModelSource() {
      this.cancelPackModelSourceTimer();
      this.cleanupPackModelLoadListeners();
      this.packModelLoadToken += 1;
    }

    queueNearbyPackModelPrefetch(activePackIndex) {
      this.cancelPackModelPrefetch();
      if (this.packProducts.length <= 1) return;
      const nearbyUrls = [-1, 1]
        .map((offset) => this.packProducts[wrapIndex(activePackIndex + offset, this.packProducts.length)])
        .map((pack) => pack?.modelUrl || modelUrlForPack(this.root, pack?.packKey))
        .filter(Boolean);
      if (nearbyUrls.length === 0) return;
      this.packModelPrefetchTimer = window.setTimeout(() => {
        this.packModelPrefetchTimer = 0;
        prefetchPackModels(nearbyUrls);
      }, PACK_MODEL_PREFETCH_DELAY_MS);
    }

    cancelPackModelPrefetch() {
      if (this.packModelPrefetchTimer) window.clearTimeout(this.packModelPrefetchTimer);
      this.packModelPrefetchTimer = 0;
    }

    startPackSway(modelViewer) {
      if (!(modelViewer instanceof HTMLElement)) return;
      this.cancelPackSway();
      this.packSwayViewer = modelViewer;
      const swayDegrees = packSwayOrbitDegrees();
      if (swayDegrees <= 0) {
        modelViewer.setAttribute("camera-orbit", packFrontCameraOrbit());
        return;
      }
      const startedAt = performance.now();
      const tick = (now) => {
        if (!modelViewer.isConnected || this.packSwayViewer !== modelViewer) return;
        const progress = ((now - startedAt) % PACK_SWAY_DURATION_MS) / PACK_SWAY_DURATION_MS;
        const orbit = 180 + Math.sin(progress * Math.PI * 2) * swayDegrees;
        modelViewer.setAttribute("camera-orbit", `${orbit.toFixed(2)}deg ${packCameraPolarAngle()} auto`);
        this.packSwayFrame = window.requestAnimationFrame(tick);
      };
      modelViewer.setAttribute("camera-orbit", packFrontCameraOrbit());
      this.packSwayFrame = window.requestAnimationFrame(tick);
    }

    cancelPackSway() {
      if (this.packSwayFrame) window.cancelAnimationFrame(this.packSwayFrame);
      if (this.packSwayResumeTimer) window.clearTimeout(this.packSwayResumeTimer);
      this.packSwayFrame = 0;
      this.packSwayResumeTimer = 0;
      this.packSwayViewer = null;
    }

    resetPackModelViewport(options = {}) {
      const resumeSway = options.resumeSway !== false;
      this.cancelPackSway();
      const modelViewer = this.root.querySelector("[data-pack-model] model-viewer");
      if (modelViewer instanceof HTMLElement) {
        modelViewer.blur();
        modelViewer.setAttribute("camera-orbit", packFrontCameraOrbit());
        modelViewer.setAttribute("field-of-view", "30deg");
        if (resumeSway) this.startPackSway(modelViewer);
      }
      const card = this.root.querySelector(".wl-pack-card");
      if (card instanceof HTMLElement) card.blur();
    }

    schedulePackSwayResume() {
      if (this.packSwayResumeTimer) window.clearTimeout(this.packSwayResumeTimer);
      this.packSwayResumeTimer = window.setTimeout(() => {
        this.packSwayResumeTimer = 0;
        if (this.packInfoPackKey) return;
        const modelViewer = this.root.querySelector("[data-pack-model] model-viewer");
        if (modelViewer instanceof HTMLElement) this.startPackSway(modelViewer);
      }, 360);
    }

    renderPackInfoModal() {
      const modal = this.root.querySelector("[data-pack-info-modal]");
      const body = this.root.querySelector("[data-pack-info-body]");
      if (!modal || !body) return;

      const packKey = normalizePackProductKey(this.packInfoPackKey);
      const content = packKey ? PACK_INFO_CONTENT[packKey] : null;
      const open = Boolean(packKey && content && !this.focusedUnopenedPack() && !this.revealedPackPurchase);
      modal.classList.toggle("is-open", open);
      modal.setAttribute("aria-hidden", open ? "false" : "true");

      if (!open || !packKey || !content) {
        body.innerHTML = "";
        if (this.packInfoPackKey && !open) this.packInfoPackKey = "";
        return;
      }

      const product = this.packProducts.find((pack) => pack.packKey === packKey);
      body.innerHTML = packInfoMarkup(content, product?.packName || content.name, product?.price || content.price);
    }

    renderCreditsInfoModal() {
      const modal = this.root.querySelector("[data-credits-info-modal]");
      const balance = this.root.querySelector("[data-credits-info-balance]");
      if (!modal) return;
      modal.classList.toggle("is-open", this.creditsInfoModalOpen);
      modal.setAttribute("aria-hidden", this.creditsInfoModalOpen ? "false" : "true");
      if (balance) balance.textContent = `Credits: ${formatCredits(this.renderCreditBalance())}`;
    }

    renderCreditConfirmModal() {
      const modal = this.root.querySelector("[data-credit-confirm-modal]");
      const copy = this.root.querySelector("[data-credit-confirm-copy]");
      const yesButton = this.root.querySelector("[data-credit-confirm-yes]");
      if (!modal || !copy || !yesButton) return;
      const pending = this.creditConfirmPack;
      const open = Boolean(pending);
      modal.classList.toggle("is-open", open);
      modal.setAttribute("aria-hidden", open ? "false" : "true");
      copy.textContent = pending
        ? `Do you want to buy this pack with credits? It will cost ${formatCredits(pending.creditCost)} credits. The pack will be opened immediately.`
        : "";
      yesButton.disabled = Boolean(this.buyingPackWithCreditsVariantId);
      yesButton.textContent = this.buyingPackWithCreditsVariantId ? "Opening" : "Yes";
    }

    renderBonusPackSizeModal() {
      const modal = this.root.querySelector("[data-bonus-size-modal]");
      const options = this.root.querySelector("[data-bonus-size-options]");
      const summary = this.root.querySelector("[data-bonus-size-modal-summary]");
      const confirmButton = this.root.querySelector("[data-bonus-size-confirm]");
      if (!modal || !options || !summary || !confirmButton) return;
      modal.classList.toggle("is-open", this.bonusPackSizeModalOpen);
      modal.setAttribute("aria-hidden", this.bonusPackSizeModalOpen ? "false" : "true");
      options.innerHTML = APPAREL_SIZES.map((size) => {
        const active = size === this.selectedBonusPackSize;
        return `
          <button
            type="button"
            class="${active ? "is-active" : ""}"
            data-action="select-bonus-pack-size"
            data-bonus-pack-size="${escapeAttr(size)}"
            aria-pressed="${active}"
          >${escapeHtml(size)}</button>
        `;
      }).join("");
      summary.textContent = this.selectedBonusPackSize ? `Selected ${this.selectedBonusPackSize}` : "Choose before claiming";
      confirmButton.disabled = Boolean(this.openingPackPurchaseId) || !this.selectedBonusPackSize;
      confirmButton.textContent = this.openingPackPurchaseId ? "Claiming" : "Confirm size";
    }

    renderNotificationsMenu() {
      const menu = this.root.querySelector("[data-notifications-menu]");
      const button = this.root.querySelector("[data-notifications-button]");
      const count = this.root.querySelector("[data-notifications-count]");
      const panel = this.root.querySelector("[data-notifications-panel]");
      if (!menu || !button || !count || !panel) return;

      const notifications = this.packNotifications();
      const unreadNotifications = notifications.filter((notification) => !notification.read);
      const unreadCount = unreadNotifications.length;
      menu.classList.toggle("is-open", this.notificationsOpen);
      button.setAttribute("aria-expanded", String(this.notificationsOpen));
      button.setAttribute(
        "aria-label",
        unreadCount > 0 ? `Open ${unreadCount} notifications` : "Open notifications"
      );
      count.hidden = unreadCount <= 0;
      count.textContent = String(unreadCount);
      panel.innerHTML = notifications.length
        ? notificationPanelMarkup(notifications, unreadCount)
        : emptyNotificationsMarkup(Boolean(this.config().customerId));
    }

    renderAccountMenu() {
      const menu = this.root.querySelector("[data-account-menu]");
      const status = this.root.querySelector("[data-account-status]");
      const bonusButton = this.root.querySelector("[data-account-bonus-button]");
      const config = this.config();
      if (menu) menu.classList.toggle("is-open", this.accountMenuOpen);
      if (status) {
        status.setAttribute("aria-expanded", String(this.accountMenuOpen));
        status.setAttribute(
          "aria-label",
          config.customerId ? `Open menu for ${config.customerLabel || "customer"}` : "Open account menu"
        );
      }
      if (bonusButton) bonusButton.textContent = bonusPackMenuLabel(this.bonusPackState, Boolean(config.customerId));
    }

    toggleAccountMenu() {
      this.accountMenuOpen = !this.accountMenuOpen;
      if (this.accountMenuOpen) this.notificationsOpen = false;
      this.renderNotificationsMenu();
      this.renderAccountMenu();
    }

    toggleNotifications() {
      this.notificationsOpen = !this.notificationsOpen;
      if (this.notificationsOpen) this.accountMenuOpen = false;
      this.renderAccountMenu();
      this.renderNotificationsMenu();
    }

    markNotificationRead(notificationId, options = {}) {
      if (!notificationId) return;
      this.readNotificationIds.add(notificationId);
      saveReadNotificationIds(this.config(), this.readNotificationIds);
      if (!options.silent) this.renderNotificationsMenu();
    }

    markAllNotificationsRead() {
      const notifications = this.packNotifications();
      notifications.forEach((notification) => this.readNotificationIds.add(notification.id));
      saveReadNotificationIds(this.config(), this.readNotificationIds);
      this.renderNotificationsMenu();
    }

    trackPackPointerStart(event) {
      const target = event.target instanceof Element ? event.target : null;
      const card = target?.closest(".wl-pack-card");
      const viewport = target?.closest(".wl-pack-screen__viewport");
      if (!card && !viewport) {
        this.cancelPackPointer();
        return;
      }
      this.packPointer = {
        pointerId: event.pointerId,
        startX: event.clientX,
        startY: event.clientY,
        dragged: false,
        startedOnCard: Boolean(card),
        startedInViewport: Boolean(viewport),
        pointerType: event.pointerType || ""
      };
    }

    trackPackPointerMove(event) {
      if (!this.packPointer || this.packPointer.pointerId !== event.pointerId) return;
      const deltaX = event.clientX - this.packPointer.startX;
      const deltaY = event.clientY - this.packPointer.startY;
      if (Math.hypot(deltaX, deltaY) > 8) this.packPointer.dragged = true;
    }

    trackPackPointerEnd(event) {
      if (!this.packPointer || this.packPointer.pointerId !== event.pointerId) return;
      const deltaX = event.clientX - this.packPointer.startX;
      const deltaY = event.clientY - this.packPointer.startY;
      const didSwipe = this.handlePackSwipe(deltaX, deltaY);
      if (this.packPointer.dragged && (this.packPointer.startedOnCard || didSwipe)) this.lastPackDragAt = Date.now();
      this.cancelPackPointer();
    }

    cancelPackPointer() {
      this.packPointer = null;
    }

    handlePackSwipe(deltaX, deltaY) {
      if (!this.packPointer?.startedInViewport) return false;
      if (!this.canSwipePackSelection()) return false;
      const horizontal = Math.abs(deltaX);
      const vertical = Math.abs(deltaY);
      const touchLike = this.packPointer.pointerType === "touch" || window.matchMedia("(max-width: 767px)").matches;
      if (!touchLike || horizontal < 46 || horizontal < vertical * 1.35) return false;
      this.movePackSelection(deltaX < 0 ? 1 : -1);
      return true;
    }

    canSwipePackSelection() {
      return (
        this.packProducts.length > 1 &&
        !this.focusedUnopenedPack() &&
        !this.revealedPackPurchase &&
        !this.packInfoPackKey &&
        !this.creditsInfoModalOpen &&
        !this.creditConfirmPack &&
        !this.bonusPackSizeModalOpen
      );
    }

    shouldSuppressPackCardClick() {
      return Date.now() - this.lastPackDragAt < 500;
    }

    selectPackSize(size) {
      const normalized = normalizeApparelSize(size);
      if (!normalized) return;
      this.selectedPackSize = normalized;
      this.selectedBonusPackSize = normalized;
      this.renderAll();
    }

    selectPackTeam(teamCode) {
      const pack = this.packProducts[this.selectedPackIndex] || this.packProducts[0];
      const team = packTeamSelection(pack, teamCode);
      this.selectedPackTeamCode = team?.code || "";
      this.renderAll();
    }

    selectBonusPackSize(size) {
      const normalized = normalizeApparelSize(size);
      if (!normalized) return;
      this.selectedBonusPackSize = normalized;
      this.renderBonusPackSizeModal();
    }

    selectPack(index) {
      if (index < 0 || index >= this.packProducts.length) return;
      this.selectedPackIndex = index;
      this.selectedPackSize = this.selectedPackSize ? packSizeOrFallback(this.packProducts[index], this.selectedPackSize) : "";
      this.selectedPackTeamCode = "";
      this.focusedPackPurchaseId = "";
      this.revealedPackPurchase = null;
      this.creditConfirmPack = null;
      this.creditsInfoModalOpen = false;
      this.renderAll();
    }

    selectedPackTeam(pack) {
      return packTeamSelection(pack, this.selectedPackTeamCode);
    }

    packAvailabilityFor(pack, variant, packSize, packTeam) {
      const key = packAvailabilityKey(pack, variant, packSize, packTeam);
      return key && this.packAvailability.key === key ? this.packAvailability : null;
    }

    isPackTeamStockUnavailable(pack, variant, packSize, packTeam) {
      if (isPackTeamSoldOut(pack, packTeam)) return true;
      return this.packAvailabilityFor(pack, variant, packSize, packTeam)?.available === false;
    }

    ensurePackAvailability(pack, variant, packSize, packTeam) {
      if (!this.config().customerId) return;
      if (isPackTeamSoldOut(pack, packTeam)) return;
      const key = packAvailabilityKey(pack, variant, packSize, packTeam);
      if (!key) return;
      if (this.packAvailability.key === key && ["loading", "ready", "error"].includes(this.packAvailability.status)) return;

      const requestId = this.packAvailabilityRequestId + 1;
      this.packAvailabilityRequestId = requestId;
      this.packAvailability = { key, status: "loading", available: true, code: null, message: null };
      this.api("pack/availability", {
        method: "POST",
        body: packAvailabilityPayload(pack, variant, packSize, packTeam)
      })
        .then((result) => {
          if (this.packAvailabilityRequestId !== requestId || this.packAvailability.key !== key) return;
          this.packAvailability = {
            key,
            status: "ready",
            available: result?.available !== false,
            code: result?.code || null,
            message: result?.message || null
          };
          this.renderPackSelection();
        })
        .catch((error) => {
          if (this.packAvailabilityRequestId !== requestId || this.packAvailability.key !== key) return;
          this.packAvailability = {
            key,
            status: "error",
            available: true,
            code: null,
            message: getErrorMessage(error)
          };
          this.renderPackSelection();
        });
    }

    requireSelectedPackTeam(pack) {
      if (!sportsLeagueForPack(pack)) return null;
      const team = this.selectedPackTeam(pack);
      if (!team) this.toast("CHOOSE A TEAM");
      if (team && isPackTeamSoldOut(pack, team)) {
        this.toast(TEAM_STOCK_UNAVAILABLE_MESSAGE);
        return null;
      }
      return team;
    }

    movePackSelection(delta) {
      if (this.packProducts.length <= 1 || this.focusedUnopenedPack() || this.revealedPackPurchase) return;
      this.selectPack(wrapIndex(this.selectedPackIndex + delta, this.packProducts.length));
    }

    openPackInfo(packKey) {
      if (this.focusedUnopenedPack() || this.revealedPackPurchase) return;
      const normalized = normalizePackProductKey(packKey);
      if (!normalized) return;
      this.resetPackModelViewport({ resumeSway: false });
      this.packInfoPackKey = normalized;
      this.renderPackInfoModal();
      window.setTimeout(() => this.root.querySelector("[data-pack-info-close]")?.focus());
    }

    closePackInfo() {
      this.packInfoPackKey = "";
      this.renderPackInfoModal();
      this.resetPackModelViewport({ resumeSway: false });
      this.schedulePackSwayResume();
    }

    openCreditsInfo() {
      this.accountMenuOpen = false;
      this.notificationsOpen = false;
      this.creditsInfoModalOpen = true;
      this.renderAll();
      window.setTimeout(() => this.root.querySelector("[data-credits-info-close]")?.focus());
    }

    closeCreditsInfo() {
      this.creditsInfoModalOpen = false;
      this.renderCreditsInfoModal();
      window.setTimeout(() => this.root.querySelector("[data-credit-balance]")?.focus());
    }

    returnToPackHome() {
      this.focusedPackPurchaseId = "";
      this.revealedPackPurchase = null;
      this.creditConfirmPack = null;
      this.creditsInfoModalOpen = false;
      this.rewardActionMessage = "";
      this.waitingForPendingPack = false;
      this.renderAll();
    }

    async openRafflesView() {
      this.activeView = "raffles";
      this.selectedRaffleId = "";
      this.raffleTicketQuantity = 1;
      this.renderAll();
      if (!this.config().customerId) return;
      await this.refreshRaffles({ quiet: true });
    }

    closeRafflesView() {
      this.activeView = "packs";
      this.selectedRaffleId = "";
      this.raffleBusyAction = "";
      this.renderAll();
    }

    selectRaffle(raffleId) {
      this.selectedRaffleId = raffleId;
      this.raffleTicketQuantity = 1;
      this.renderRaffleView();
    }

    changeRaffleTicketQuantity(delta) {
      const raffle = this.selectedRaffle();
      const ticketMax = Math.max(0, Math.min(10, Number(raffle?.paidEntriesRemaining || 0) || 0));
      const creditCostPerEntry = Math.max(0, Number(raffle?.ticketCostCredits || 0) || 0);
      const creditBalance = Math.max(0, Number(this.raffleState?.creditBalance || 0) || 0);
      const creditMax = creditCostPerEntry > 0 ? Math.min(25, Math.floor(creditBalance / creditCostPerEntry)) : 0;
      const maxQuantity = Math.max(1, ticketMax, creditMax);
      this.raffleTicketQuantity = Math.max(1, Math.min(maxQuantity, this.raffleTicketQuantity + delta));
      this.renderRaffleView();
    }

    startRaffleTimer() {
      if (this.raffleTimer) return;
      this.raffleTimer = window.setInterval(() => this.updateRaffleTimers(), 1000);
    }

    stopRaffleTimer() {
      if (!this.raffleTimer) return;
      window.clearInterval(this.raffleTimer);
      this.raffleTimer = 0;
    }

    updateRaffleTimers() {
      this.root.querySelectorAll("[data-raffle-timer]").forEach((element) => {
        element.textContent = raffleTimerLabel(element.dataset.raffleStatus, element.dataset.raffleTarget);
      });
    }

    async refreshRaffles({ quiet = false } = {}) {
      if (!this.config().customerId) {
        this.renderAll();
        return;
      }
      this.raffleBusyAction = this.raffleBusyAction || "loading";
      this.renderRaffleView();
      try {
        this.raffleState = await this.api("raffle/state");
        if (!quiet) this.toast("RAFFLES REFRESHED");
      } catch (error) {
        this.toast(getErrorMessage(error));
      } finally {
        this.raffleBusyAction = "";
        this.renderAll();
      }
    }

    async enterSelectedRaffleFree() {
      const raffle = this.selectedRaffle();
      if (!raffle || this.raffleBusyAction) return;
      if (!this.config().customerId) {
        window.location.assign(this.config().loginUrl);
        return;
      }
      this.raffleBusyAction = "free";
      this.renderRaffleView();
      try {
        const result = await this.api(`raffle/${encodeURIComponent(raffle.id)}/free-entry`, { method: "POST" });
        this.raffleState = result.state || (await this.api("raffle/state"));
        this.toast("FREE RAFFLE ENTRY ADDED");
      } catch (error) {
        this.toast(getErrorMessage(error));
        await this.refreshRaffles({ quiet: true });
      } finally {
        this.raffleBusyAction = "";
        this.renderAll();
      }
    }

    async enterSelectedRafflePaid(paymentMethod = "ticket") {
      const raffle = this.selectedRaffle();
      if (!raffle || this.raffleBusyAction) return;
      if (!this.config().customerId) {
        window.location.assign(this.config().loginUrl);
        return;
      }
      const isCreditEntry = paymentMethod === "credit";
      this.raffleBusyAction = isCreditEntry ? "paid-credit" : "paid-ticket";
      this.renderRaffleView();
      try {
        let quantity = 1;
        if (isCreditEntry) {
          const creditCostPerEntry = Math.max(0, Number(raffle.ticketCostCredits || 0) || 0);
          const creditBalance = Math.max(0, Number(this.raffleState?.creditBalance || 0) || 0);
          const creditMax = creditCostPerEntry > 0 ? Math.min(25, Math.floor(creditBalance / creditCostPerEntry)) : 0;
          if (creditMax <= 0) return;
          quantity = Math.max(1, Math.min(25, creditMax, this.raffleTicketQuantity));
        } else {
          const remaining = Math.max(0, Number(raffle.paidEntriesRemaining ?? 10) || 0);
          if (remaining <= 0) return;
          quantity = Math.max(1, Math.min(10, remaining, this.raffleTicketQuantity));
        }
        const result = await this.api(`raffle/${encodeURIComponent(raffle.id)}/paid-entry`, {
          method: "POST",
          body: {
            quantity,
            idempotencyKey: idempotencyKey(isCreditEntry ? "raffle-credit-entry" : "raffle-entry"),
            paymentMethod: isCreditEntry ? "credit" : "ticket"
          }
        });
        this.raffleState = result.state || (await this.api("raffle/state"));
        if (Number.isFinite(Number(result.creditBalance))) {
          this.raffleState = { ...this.raffleState, creditBalance: Number(result.creditBalance) };
        }
        if (Number.isFinite(Number(result.raffleTicketBalance))) {
          this.raffleState = { ...this.raffleState, raffleTicketBalance: Number(result.raffleTicketBalance) };
        }
        this.toast(`${result.entriesCreated || quantity} RAFFLE ENTR${(result.entriesCreated || quantity) === 1 ? "Y" : "IES"} ADDED`);
      } catch (error) {
        this.toast(getErrorMessage(error));
        await this.refreshRaffles({ quiet: true });
      } finally {
        this.raffleBusyAction = "";
        this.renderAll();
      }
    }

    async buyRaffleTickets() {
      const config = this.config();
      if (!config.customerId) {
        window.location.assign(config.loginUrl);
        return;
      }
      const variantId = normalizeShopifyNumericId(config.raffleTicketVariantId);
      if (!variantId) {
        this.toast("RAFFLE TICKETS NOT AVAILABLE");
        return;
      }
      if (this.raffleBusyAction) return;

      this.raffleBusyAction = "buy-tickets";
      this.renderRaffleView();
      try {
        await submitRaffleTicketCartLine(variantId);
        window.location.assign("/checkout");
      } catch (error) {
        this.toast(getErrorMessage(error));
      } finally {
        this.raffleBusyAction = "";
        this.renderRaffleView();
      }
    }

    async resumePackQueue(packPurchaseId = "") {
      this.activeView = "packs";
      this.selectedRaffleId = "";
      this.raffleBusyAction = "";

      if (this.config().customerId) {
        try {
          await this.refreshState({ quiet: true });
        } catch (error) {
          this.toast(getErrorMessage(error));
        }
      }

      const opened = packPurchaseId
        ? this.allOpenedPacks().find((pack) => pack.id === packPurchaseId)
        : this.nextOpenedPack();
      if (opened) {
        this.focusedPackPurchaseId = opened.id;
        this.revealedPackPurchase = opened;
        this.rewardActionMessage = "";
        this.renderAll();
        return;
      }

      const creditAwarded = packPurchaseId
        ? this.creditAwardReviewPacks().find((pack) => pack.id === packPurchaseId)
        : this.nextCreditAwardReviewPack();
      if (creditAwarded) {
        this.focusedPackPurchaseId = creditAwarded.id;
        this.revealedPackPurchase = creditAwarded;
        this.rewardActionMessage = "";
        this.renderAll();
        return;
      }

      const unopened = packPurchaseId
        ? this.allUnopenedPacks().find((pack) => pack.id === packPurchaseId)
        : this.nextUnopenedPack();
      if (unopened) {
        this.focusedPackPurchaseId = unopened.id;
        this.revealedPackPurchase = null;
        this.rewardActionMessage = "";
        this.renderAll();
        return;
      }

      this.toast("NO PACKS READY");
    }

    focusedUnopenedPack() {
      if (this.focusedPackPurchaseId) {
        const focused = this.allUnopenedPacks().find((pack) => pack.id === this.focusedPackPurchaseId);
        if (focused) return focused;
      }
      return null;
    }

    nextUnopenedPack() {
      const paidPack = this.packState.unopenedPacks.find((pack) => pack.packKey !== "bonus");
      return paidPack || this.packState.unopenedPacks[0] || this.bonusPackState?.unopenedPack || null;
    }

    nextOpenedPack() {
      const paidPack = this.packState.openedPacks.find((pack) => pack.packKey !== "bonus");
      return paidPack || this.packState.openedPacks[0] || this.bonusPackState?.openedPack || null;
    }

    allOpenedPacks() {
      const packs = [...this.packState.openedPacks];
      if (this.bonusPackState?.openedPack && !packs.some((pack) => pack.id === this.bonusPackState.openedPack.id)) {
        packs.push(this.bonusPackState.openedPack);
      }
      return packs;
    }

    allSettledPacks() {
      return Array.isArray(this.packState.settledPacks) ? [...this.packState.settledPacks] : [];
    }

    creditAwardReviewPacks() {
      return this.allSettledPacks().filter(packRevealCreditAward);
    }

    nextCreditAwardReviewPack() {
      const paidPack = this.creditAwardReviewPacks().find((pack) => pack.packKey !== "bonus");
      return paidPack || this.creditAwardReviewPacks()[0] || null;
    }

    allUnopenedPacks() {
      const packs = [...this.packState.unopenedPacks];
      if (this.bonusPackState?.unopenedPack && !packs.some((pack) => pack.id === this.bonusPackState.unopenedPack.id)) {
        packs.push(this.bonusPackState.unopenedPack);
      }
      return packs;
    }

    totalUnopenedPacks() {
      return this.allUnopenedPacks().length;
    }

    totalOpenedPacks() {
      return this.allOpenedPacks().length;
    }

    packNotifications() {
      const notifications = [];
      const openedCount = this.totalOpenedPacks();
      if (openedCount > 0) {
        this.allOpenedPacks().forEach((purchase) => {
          const rewardCount = Array.isArray(purchase.items) ? purchase.items.length : 0;
          const id = notificationIdForPurchase(purchase, "opened");
          notifications.push({
            id,
            read: this.readNotificationIds.has(id),
            packPurchaseId: purchase.id,
            title: `${rewardCount || 1} item${(rewardCount || 1) === 1 ? "" : "s"} secured`,
            detail: rewardNotificationDetail(purchase),
            actionLabel: "Review"
          });
        });
      }

      this.creditAwardReviewPacks().forEach((purchase) => {
        const creditAward = packRevealCreditAward(purchase);
        const id = notificationIdForPurchase(purchase, "credits_awarded");
        notifications.push({
          id,
          read: this.readNotificationIds.has(id),
          packPurchaseId: purchase.id,
          title: `${formatCredits(creditAward?.credits || 0)} credits added`,
          detail: packSourceLabel(purchase),
          actionLabel: "Review"
        });
      });

      const unopenedCount = this.totalUnopenedPacks();
      if (unopenedCount > 0) {
        this.allUnopenedPacks().forEach((purchase) => {
          const id = notificationIdForPurchase(purchase, "allocated");
          notifications.push({
            id,
            read: this.readNotificationIds.has(id),
            packPurchaseId: purchase.id,
            title: "Pack ready to open",
            detail: packSourceLabel(purchase),
            actionLabel: "Open"
          });
        });
      }

      return notifications;
    }

    packProductForPurchase(purchase) {
      if (!purchase) return null;
      if (purchase.packKey === "bonus") {
        const fallback = this.packProducts[0];
        const title = purchase.packTitle || "Bonus Packs";
        return fallback
          ? {
              ...fallback,
              id: `bonus:${fallback.id}`,
              title,
              packName: title,
              packKey: "bonus",
              modelUrl: this.config().bonusPackModelUrl || fallback.modelUrl
            }
          : null;
      }
      return (
        this.packProducts.find((pack) => pack.packKey === purchase.packKey) ||
        this.packProducts.find((pack) => normalizePackLookupLabel(pack.packName) === normalizePackLookupLabel(purchase.packTitle)) ||
        this.packProducts.find((pack) => normalizePackLookupLabel(pack.title) === normalizePackLookupLabel(purchase.packTitle)) ||
        fallbackPackProductForPurchase(this.root, purchase) ||
        this.packProducts[0] ||
        null
      );
    }

    packProductForPendingCheckout(pending) {
      if (!pending) return null;
      const packKey = normalizePackProductKey(pending.packKey);
      const productId = normalizeShopifyNumericId(pending.packId);
      const variantId = normalizeShopifyNumericId(pending.variantId);
      const matchedPack =
        (productId
          ? this.packProducts.find((pack) => normalizeShopifyNumericId(pack.productId || pack.id) === productId)
          : null) ||
        (variantId
          ? this.packProducts.find((pack) =>
              (pack.variants || []).some((variant) => normalizeShopifyNumericId(variant.id) === variantId)
            )
          : null) ||
        (packKey ? this.packProducts.find((pack) => pack.packKey === packKey) : null) ||
        this.packProducts.find((pack) => normalizePackLookupLabel(pack.packName) === normalizePackLookupLabel(pending.packName)) ||
        this.packProducts.find((pack) => normalizePackLookupLabel(pack.title) === normalizePackLookupLabel(pending.packName)) ||
        fallbackPackProductForPurchase(this.root, {
          packKey,
          packTitle: pending.packName,
          packSize: pending.packSize
        });
      if (!matchedPack) return null;
      const modelUrl = String(pending.modelUrl || "").trim() || matchedPack.modelUrl || modelUrlForPack(this.root, packKey || matchedPack.packKey);
      return {
        ...matchedPack,
        title: pending.packName || matchedPack.title,
        packName: pending.packName || matchedPack.packName,
        packKey: packKey || matchedPack.packKey,
        modelUrl
      };
    }

    async buySelectedPack() {
      const config = this.config();
      const pack = this.packProducts[this.selectedPackIndex] || this.packProducts[0];
      if (!pack || this.buyingPackVariantId || this.addingPackVariantId) return;
      if (!config.customerId) {
        window.location.assign(config.loginUrl);
        return;
      }
      if (!this.selectedPackSize) {
        this.toast("CHOOSE A SIZE");
        return;
      }
      const variant = packCheckoutVariant(pack, this.selectedPackSize);
      if (!pack.available || !variant) {
        this.toast("PACK NOT AVAILABLE");
        return;
      }
      const packTeam = this.requireSelectedPackTeam(pack);
      if (sportsLeagueForPack(pack) && !packTeam) return;
      if (this.isPackTeamStockUnavailable(pack, variant, this.selectedPackSize, packTeam)) {
        this.toast(TEAM_STOCK_UNAVAILABLE_MESSAGE);
        return;
      }

      this.buyingPackVariantId = variant.id;
      this.renderPackSelection();
      try {
        const pendingCheckout = {
          packId: pack.id,
          variantId: variant.id,
          packKey: pack.packKey,
          packName: pack.packName,
          packSize: variant.size,
          packTeam,
          modelUrl: pack.modelUrl || modelUrlForPack(this.root, pack.packKey),
          createdAt: Date.now()
        };
        savePendingPackCheckout(config.shop, pendingCheckout);
        const cartLine = await submitPackCartLine(pack, variant, this.selectedPackSize, null, packTeam);
        savePendingPackCheckout(config.shop, {
          ...pendingCheckout,
          cartLineKey: cartLineKeyFromAddResponse(cartLine)
        });
        window.location.assign("/checkout");
      } catch (error) {
        clearPendingPackCheckout(config.shop);
        this.buyingPackVariantId = "";
        this.renderPackSelection();
        this.toast(getErrorMessage(error));
      }
    }

    async buySelectedPackWithCredits() {
      const config = this.config();
      const pack = this.packProducts[this.selectedPackIndex] || this.packProducts[0];
      if (!pack || this.buyingPackVariantId || this.buyingPackWithCreditsVariantId || this.addingPackVariantId) return;
      if (!config.customerId) {
        window.location.assign(config.loginUrl);
        return;
      }
      if (!this.selectedPackSize) {
        this.toast("CHOOSE A SIZE");
        return;
      }
      const variant = packCheckoutVariant(pack, this.selectedPackSize);
      if (!pack.available || !variant) {
        this.toast("PACK NOT AVAILABLE");
        return;
      }
      const packTeam = this.requireSelectedPackTeam(pack);
      if (sportsLeagueForPack(pack) && !packTeam) return;
      if (this.isPackTeamStockUnavailable(pack, variant, this.selectedPackSize, packTeam)) {
        this.toast(TEAM_STOCK_UNAVAILABLE_MESSAGE);
        return;
      }

      const creditCost = creditsForPriceCents(packPriceCents(pack, variant));
      if (Number(this.packState.creditBalance || 0) >= creditCost) {
        this.creditConfirmPack = {
          pack,
          variant,
          packSize: this.selectedPackSize,
          packTeam,
          creditCost,
          idempotencyKey: idempotencyKey("credit-pack")
        };
        this.renderCreditConfirmModal();
        window.setTimeout(() => this.root.querySelector("[data-credit-confirm-yes]")?.focus());
        return;
      }

      await this.reserveCreditsAndCheckout(pack, variant, this.selectedPackSize, packTeam);
    }

    closeCreditConfirmModal() {
      this.creditConfirmPack = null;
      this.renderCreditConfirmModal();
    }

    async confirmCreditPackPurchase() {
      const pending = this.creditConfirmPack;
      if (!pending || this.buyingPackWithCreditsVariantId) return;
      const openingPurchase = buildCreditOpeningPurchase(pending);
      const queueTotalBeforeOpen = Math.max(1, this.totalUnopenedPacks() + 1);
      this.buyingPackWithCreditsVariantId = pending.variant.id;
      this.openingPackPurchaseId = openingPurchase.id;
      this.focusedPackPurchaseId = openingPurchase.id;
      this.creditOpeningPackPurchase = openingPurchase;
      this.creditConfirmPack = null;
      this.renderAll();
      try {
        const result = await this.api("pack/credit-purchase", {
          method: "POST",
          body: creditPackPayload(pending.pack, pending.variant, pending.packSize, pending.idempotencyKey, pending.packTeam)
        });
        const animatedPack =
          this.packProductForPurchase(result.purchase) ||
          this.packProductForPurchase(this.creditOpeningPackPurchase) ||
          pending.pack;
        await this.playPackOpenAnimation(animatedPack);
        this.revealedPackPurchase = result.purchase;
        this.packState = await this.api("pack/state");
        this.bonusPackState = await this.safeBonusPackState();
        this.focusedPackPurchaseId = result.purchase?.id || "";
        this.revealedPackQueueTotal = Math.max(queueTotalBeforeOpen, this.totalUnopenedPacks() + 1);
      } catch (error) {
        const refreshedState = await this.api("pack/state").catch(() => null);
        const committedPurchase = findCreditPurchaseByIdempotency(refreshedState, pending.idempotencyKey);
        if (committedPurchase) {
          this.packState = refreshedState;
          this.revealedPackPurchase = committedPurchase;
          this.focusedPackPurchaseId = committedPurchase.id || "";
          this.revealedPackQueueTotal = Math.max(queueTotalBeforeOpen, this.totalUnopenedPacks() + 1);
          this.bonusPackState = await this.safeBonusPackState();
        } else {
          this.creditConfirmPack = pending;
        }
        this.toast(getErrorMessage(error));
      } finally {
        this.buyingPackWithCreditsVariantId = "";
        this.openingPackPurchaseId = "";
        this.creditOpeningPackPurchase = null;
        if (this.focusedPackPurchaseId === openingPurchase.id) this.focusedPackPurchaseId = "";
        this.renderAll();
      }
    }

    async reserveCreditsAndCheckout(pack, variant, packSize, packTeam) {
      const config = this.config();
      this.buyingPackWithCreditsVariantId = variant.id;
      this.renderPackSelection();
      let reservation = null;
      try {
        reservation = await this.api("pack/credit-checkout-reservation", {
          method: "POST",
          body: creditPackPayload(pack, variant, packSize, idempotencyKey("credit-reservation"), packTeam)
        });
        const pendingCheckout = {
          packId: pack.id,
          variantId: variant.id,
          packKey: pack.packKey,
          packName: pack.packName,
          packSize,
          packTeam,
          modelUrl: pack.modelUrl || modelUrlForPack(this.root, pack.packKey),
          creditReservationId: reservation.reservationId,
          reservedCredits: reservation.reservedCredits,
          discountCode: reservation.discountCode,
          discountUrl: reservation.discountUrl,
          expiresAt: reservation.expiresAt,
          createdAt: Date.now()
        };
        savePendingPackCheckout(config.shop, pendingCheckout);
        const cartLine = await submitPackCartLine(pack, variant, packSize, reservation, packTeam);
        savePendingPackCheckout(config.shop, {
          ...pendingCheckout,
          cartLineKey: cartLineKeyFromAddResponse(cartLine)
        });
        window.location.assign(reservation.discountUrl || "/checkout");
      } catch (error) {
        if (reservation?.reservationId) {
          await this.cancelCreditReservation(reservation.reservationId);
        }
        clearPendingPackCheckout(config.shop);
        this.buyingPackWithCreditsVariantId = "";
        this.renderPackSelection();
        this.toast(getErrorMessage(error));
      }
    }

    async cancelCreditReservation(reservationId) {
      try {
        const result = await this.api("pack/credit-checkout-reservation/cancel", {
          method: "POST",
          body: { reservationId }
        });
        if (Number.isFinite(Number(result.creditBalance))) {
          this.packState = { ...this.packState, creditBalance: Number(result.creditBalance) };
        }
      } catch {
        // The server-side expiry worker still releases abandoned reservations.
      }
    }

    async addSelectedPackToCart() {
      const config = this.config();
      const pack = this.packProducts[this.selectedPackIndex] || this.packProducts[0];
      if (!pack || this.buyingPackVariantId || this.addingPackVariantId) return;
      if (!config.customerId) {
        window.location.assign(config.loginUrl);
        return;
      }
      if (!this.selectedPackSize) {
        this.toast("CHOOSE A SIZE");
        return;
      }
      const variant = packCheckoutVariant(pack, this.selectedPackSize);
      if (!pack.available || !variant) {
        this.toast("PACK NOT AVAILABLE");
        return;
      }
      const packTeam = this.requireSelectedPackTeam(pack);
      if (sportsLeagueForPack(pack) && !packTeam) return;
      if (this.isPackTeamStockUnavailable(pack, variant, this.selectedPackSize, packTeam)) {
        this.toast(TEAM_STOCK_UNAVAILABLE_MESSAGE);
        return;
      }

      this.addingPackVariantId = variant.id;
      this.renderPackSelection();
      try {
        await submitPackCartLine(pack, variant, this.selectedPackSize, null, packTeam);
        this.toast("PACK ADDED TO CART");
      } catch (error) {
        this.toast(getErrorMessage(error));
      } finally {
        this.addingPackVariantId = "";
        this.renderPackSelection();
      }
    }

    async openPackPurchase(packPurchaseId) {
      if (this.openingPackPurchaseId) return;
      const queueTotalBeforeOpen = Math.max(1, this.totalUnopenedPacks());
      this.openingPackPurchaseId = packPurchaseId;
      this.focusedPackPurchaseId = packPurchaseId;
      this.renderPackSelection();
      try {
        const result = await this.api("pack/open", {
          method: "POST",
          body: { packPurchaseId }
        });
        const animatedPack = this.packProductForPurchase(result.purchase) || this.packProductForPurchase(this.focusedUnopenedPack());
        await this.playPackOpenAnimation(animatedPack);
        this.revealedPackPurchase = result.purchase;
        this.packState = await this.api("pack/state");
        this.bonusPackState = await this.safeBonusPackState();
        this.focusedPackPurchaseId = result.purchase?.id || "";
        this.revealedPackQueueTotal = Math.max(queueTotalBeforeOpen, this.totalUnopenedPacks() + 1);
        clearPendingPackCheckout(this.config().shop);
      } catch (error) {
        this.toast(getErrorMessage(error));
      } finally {
        this.openingPackPurchaseId = "";
        this.renderAll();
      }
    }

    async testPackOpenAnimation() {
      if (!isPackAnimationTestMode() || this.testingPackAnimation || this.openingPackPurchaseId) return;
      const pack = this.packProducts[this.selectedPackIndex] || this.packProducts[0];
      if (!pack) return;

      this.testingPackAnimation = true;
      this.renderPackSelection();
      try {
        await this.playPackOpenAnimation(pack);
        this.revealedPackPurchase = buildTestRevealPurchase(pack, this.selectedPackSize);
      } catch (error) {
        this.toast(getErrorMessage(error));
      } finally {
        this.testingPackAnimation = false;
        this.renderAll();
      }
    }

    async shipPackPurchase(packPurchaseId) {
      if (this.shippingPackPurchaseId || this.sellingPackPurchaseId) return;
      this.shippingPackPurchaseId = packPurchaseId;
      this.rewardActionMessage = "";
      this.renderAll();
      try {
        await this.api("pack/ship", {
          method: "POST",
          body: { packPurchaseId }
        });
        this.packState = await this.api("pack/state");
        this.bonusPackState = await this.safeBonusPackState();
        this.revealedPackPurchase = null;
        this.focusedPackPurchaseId = "";
        this.returnToPackHome();
        this.toast("PACK SHIPPING CREATED");
      } catch (error) {
        this.rewardActionMessage = getErrorMessage(error);
        this.toast(`SHIP FAILED: ${this.rewardActionMessage}`);
      } finally {
        this.shippingPackPurchaseId = "";
        this.renderAll();
      }
    }

    async sellPackPurchase(packPurchaseId) {
      if (this.sellingPackPurchaseId || this.shippingPackPurchaseId) return;
      this.sellingPackPurchaseId = packPurchaseId;
      this.rewardActionMessage = "";
      this.renderAll();
      try {
        const result = await this.api("pack/sell", {
          method: "POST",
          body: { packPurchaseId }
        });
        this.packState = await this.api("pack/state");
        this.bonusPackState = await this.safeBonusPackState();
        this.revealedPackPurchase = null;
        this.focusedPackPurchaseId = "";
        this.returnToPackHome();
        this.toast(`+${formatCredits(result.creditsGranted || 0)} CREDITS`);
      } catch (error) {
        this.rewardActionMessage = getErrorMessage(error);
        this.toast(`SELLBACK FAILED: ${this.rewardActionMessage}`);
      } finally {
        this.sellingPackPurchaseId = "";
        this.renderAll();
      }
    }

    async refreshState({ quiet = false } = {}) {
      const config = this.config();
      if (!config.customerId) {
        this.renderAll();
        return;
      }
      try {
        this.packState = await this.api("pack/state");
        this.bonusPackState = await this.safeBonusPackState();
        this.reconcileFocusedPack();
        if (!quiet) this.toast("PACKS REFRESHED");
      } finally {
        this.renderAll();
      }
    }

    reconcileFocusedPack() {
      const pending = loadPendingPackCheckout(this.config().shop);
      if (pending) {
        const unopened = this.allUnopenedPacks().find((pack) => packMatchesPendingCheckout(pack, pending));
        if (unopened) {
          this.focusedPackPurchaseId = unopened.id;
        }
      }
      const focusedPackExists =
        this.allUnopenedPacks().some((pack) => pack.id === this.focusedPackPurchaseId) ||
        this.allOpenedPacks().some((pack) => pack.id === this.focusedPackPurchaseId) ||
        this.allSettledPacks().some((pack) => pack.id === this.focusedPackPurchaseId);
      if (this.focusedPackPurchaseId && !focusedPackExists) {
        this.focusedPackPurchaseId = "";
      }
      if (
        this.revealedPackPurchase &&
        !this.allOpenedPacks().some((pack) => pack.id === this.revealedPackPurchase.id) &&
        !this.allSettledPacks().some((pack) => pack.id === this.revealedPackPurchase.id)
      ) {
        this.revealedPackPurchase = null;
      }
    }

    async safeBonusPackState() {
      try {
        return await this.api("bonus-pack/state");
      } catch {
        return this.bonusPackState;
      }
    }

    async openBonusPackAction() {
      const config = this.config();
      this.accountMenuOpen = false;
      this.renderAccountMenu();
      if (!config.customerId) {
        window.location.assign(config.loginUrl);
        return;
      }

      const state = this.bonusPackState || (await this.safeBonusPackState());
      this.bonusPackState = state;
      if (state?.unopenedPack) {
        this.focusedPackPurchaseId = state.unopenedPack.id;
        this.revealedPackPurchase = null;
        this.renderAll();
        return;
      }
      if (state?.openedPack) {
        this.focusedPackPurchaseId = state.openedPack.id;
        this.revealedPackPurchase = state.openedPack;
        this.renderAll();
        return;
      }
      if (state?.eligible && !state.claimed) {
        this.openBonusPackSizeModal();
        return;
      }
      this.toast("NO BONUS PACK AVAILABLE");
    }

    openBonusPackSizeModal() {
      this.selectedBonusPackSize = this.selectedPackSize || "";
      this.bonusPackSizeModalOpen = true;
      this.renderBonusPackSizeModal();
      window.setTimeout(() => this.root.querySelector("[data-bonus-pack-size].is-active")?.focus());
    }

    closeBonusPackSizeModal() {
      this.bonusPackSizeModalOpen = false;
      this.renderBonusPackSizeModal();
    }

    async confirmBonusPackSize() {
      if (!this.selectedBonusPackSize || this.openingPackPurchaseId) return;
      try {
        const claimed = await this.api("bonus-pack/claim", {
          method: "POST",
          body: { preferredSize: this.selectedBonusPackSize }
        });
        this.bonusPackState = claimed.state;
        this.bonusPackSizeModalOpen = false;
        this.packState = await this.api("pack/state");
        const pack = claimed.pack || claimed.state?.unopenedPack;
        if (pack?.id) {
          this.focusedPackPurchaseId = pack.id;
          await this.openPackPurchase(pack.id);
        } else {
          this.toast("BONUS PACK CLAIMED");
          this.renderAll();
        }
      } catch (error) {
        this.toast(getErrorMessage(error));
      } finally {
        this.renderBonusPackSizeModal();
      }
    }

    async maybeAutoOpenPack() {
      const url = new URL(window.location.href);
      const pending = loadPendingPackCheckout(this.config().shop);
      const requestedOpen = url.searchParams.has(OPEN_PACK_QUERY_PARAM);
      if (!requestedOpen && !pending) return;
      const pendingCartLines = pending ? await pendingCheckoutCartLines(pending) : [];
      if (
        pending &&
        pendingCartLines.length > 0 &&
        (await this.handlePendingCheckoutReturn(pending, { cartLines: pendingCartLines, requestedOpen, url }))
      ) {
        return;
      }

      const pack = pending
        ? this.allUnopenedPacks().find((candidate) => packMatchesPendingCheckout(candidate, pending))
        : this.nextUnopenedPack();
      if (pack) {
        this.cancelPendingPackPoll();
        this.waitingForPendingPack = false;
        this.buyingPackVariantId = "";
        this.buyingPackWithCreditsVariantId = "";
        if (requestedOpen) {
          url.searchParams.delete(OPEN_PACK_QUERY_PARAM);
          window.history.replaceState(window.history.state, "", serializeUrl(url));
        }
        await this.openPackPurchase(pack.id);
        return;
      }
      if (
        pending &&
        pendingCartLines.length === 0 &&
        !isCreditPendingCheckout(pending) &&
        pendingCheckoutAgeMs(pending) >= PENDING_PACK_EMPTY_CART_GRACE_MS
      ) {
        this.cancelPendingPackPoll();
        clearPendingPackCheckout(this.config().shop);
        this.waitingForPendingPack = false;
        this.buyingPackVariantId = "";
        this.buyingPackWithCreditsVariantId = "";
        if (requestedOpen) {
          url.searchParams.delete(OPEN_PACK_QUERY_PARAM);
          window.history.replaceState(window.history.state, "", serializeUrl(url));
        }
        await this.refreshState({ quiet: true });
        this.toast("CHECKOUT NOT COMPLETED");
        return;
      }
      if (!pack) {
        if (this.pendingPackPollAttempts >= PENDING_PACK_POLL_LIMIT) {
          clearPendingPackCheckout(this.config().shop);
          this.waitingForPendingPack = false;
          this.renderAll();
          this.toast("PACK STILL PROCESSING");
          return;
        }
        this.waitingForPendingPack = true;
        this.renderPackSelection();
        this.schedulePendingPackAutoOpen();
        return;
      }
    }

    async handlePendingCheckoutReturn(pending, { cartLines = null, requestedOpen = false, url = null } = {}) {
      const lines = cartLines || await pendingCheckoutCartLines(pending);
      if (lines.length === 0) return false;
      if (!isCreditPendingCheckout(pending) || pendingCreditCheckoutExpired(pending)) {
        await this.clearAbandonedPendingCheckout(pending, lines);
        return true;
      }
      if (shouldResumePendingCheckout(pending)) {
        const resumed = {
          ...pending,
          checkoutResumeAttempts: Number(pending.checkoutResumeAttempts || 0) + 1,
          checkoutResumeAttemptedAt: Date.now()
        };
        savePendingPackCheckout(this.config().shop, resumed);
        if (requestedOpen && url) {
          url.searchParams.delete(OPEN_PACK_QUERY_PARAM);
          window.history.replaceState(window.history.state, "", serializeUrl(url));
        }
        this.waitingForPendingPack = true;
        this.renderPackSelection();
        window.location.assign(pendingCheckoutUrl(resumed));
        return true;
      }
      if (this.pendingPackPollAttempts >= PENDING_PACK_POLL_LIMIT) {
        this.waitingForPendingPack = false;
        this.renderAll();
        this.toast("CHECKOUT STILL PENDING");
      } else {
        this.waitingForPendingPack = true;
        this.renderPackSelection();
        this.schedulePendingPackAutoOpen();
      }
      return true;
    }

    async clearAbandonedPendingCheckout(pending, cartLines = null) {
      const lines = cartLines || await pendingCheckoutCartLines(pending);
      if (lines.length === 0) return false;
      this.cancelPendingPackPoll();
      this.waitingForPendingPack = false;

      await Promise.allSettled(lines.map((line) => removeCartLine(line)));
      if (pending.creditReservationId) {
        await this.cancelCreditReservation(pending.creditReservationId);
      }
      clearPendingPackCheckout(this.config().shop);
      this.buyingPackVariantId = "";
      this.buyingPackWithCreditsVariantId = "";
      await this.refreshState({ quiet: true });
      this.toast("CHECKOUT CANCELLED");
      return true;
    }

    schedulePendingPackAutoOpen() {
      if (this.pendingPackPollTimer || this.pendingPackPollAttempts >= PENDING_PACK_POLL_LIMIT) return;
      this.pendingPackPollAttempts += 1;
      this.pendingPackPollTimer = window.setTimeout(async () => {
        this.pendingPackPollTimer = 0;
        try {
          await this.refreshState({ quiet: true });
          await this.maybeAutoOpenPack();
        } catch (error) {
          this.toast(getErrorMessage(error));
        }
      }, PENDING_PACK_POLL_INTERVAL_MS);
    }

    cancelPendingPackPoll() {
      if (this.pendingPackPollTimer) window.clearTimeout(this.pendingPackPollTimer);
      this.pendingPackPollTimer = 0;
      this.pendingPackPollAttempts = 0;
    }

    async playPackOpenAnimation(displayPack) {
      const mount = this.root.querySelector("[data-pack-model]");
      const displayPackModelUrl = displayPack
        ? displayPack.modelUrl || modelUrlForPack(this.root, displayPack.packKey)
        : "";
      const modelUrl = displayPack
        ? displayPackModelUrl
        : mount?.querySelector("model-viewer")?.getAttribute("src") || "";
      if (!mount || !modelUrl) {
        await playFallbackPackOpenAnimation(mount);
        return;
      }

      try {
        await new PackOpeningAnimator(mount, modelUrl).play();
      } catch (error) {
        console.warn("WL pack opening animation fell back to CSS shake.", error);
        await playFallbackPackOpenAnimation(mount);
      }
    }

    async api(path, options = {}) {
      const url = packApiUrl(this.config(), path);
      const response = await fetch(url, {
        method: options.method || "GET",
        headers: options.body ? { "Content-Type": "application/json" } : undefined,
        body: options.body ? JSON.stringify(options.body) : undefined
      });
      const text = await response.text();
      const payload = text ? safeJson(text) : {};
      if (!response.ok) throw new Error(payload.message || payload.code || `Request failed with ${response.status}`);
      return payload;
    }

    toast(message) {
      const toast = this.root.querySelector("[data-toast]");
      if (!toast) return;
      toast.textContent = String(message || "");
      toast.classList.add("is-visible");
      window.clearTimeout(this.toastTimer);
      this.toastTimer = window.setTimeout(() => toast.classList.remove("is-visible"), 2600);
    }

    require(selector) {
      const element = this.root.querySelector(selector);
      if (!element) throw new Error(`Missing WL Packs element ${selector}`);
      return element;
    }
  }

  const getPackProducts = (root) => {
    const source = root.querySelector("[data-pack-products]")?.textContent?.trim();
    if (!source) return [];
    try {
      const parsed = JSON.parse(source);
      if (!Array.isArray(parsed)) return [];
      const products = parsed.flatMap((pack, index) => normalizePackProduct(root, pack, index));
      return products;
    } catch (error) {
      console.warn("Could not parse WL pack products.", error);
      return [];
    }
  };

  const getRaffleProducts = (root) => {
    const source = root.querySelector("[data-raffle-products]")?.textContent?.trim();
    if (!source) return [];
    try {
      const parsed = JSON.parse(source);
      if (!Array.isArray(parsed)) return [];
      return parsed.flatMap((product, index) => normalizePackProduct(root, product, index));
    } catch (error) {
      console.warn("Could not parse WL raffle products.", error);
      return [];
    }
  };

  const fallbackPackProductForPurchase = (root, purchase) => {
    const packKey =
      normalizePackProductKey(purchase?.packKey) ||
      packKeyForProductText([purchase?.packTitle, purchase?.packSize].map((value) => String(value || "")).join(" "));
    if (!packKey) return null;
    const fallback = FALLBACK_PACK_PRODUCTS.find((pack) => pack.packKey === packKey);
    if (!fallback) return null;
    const packSize = normalizeApparelSize(purchase?.packSize) || String(purchase?.packSize || "M").trim() || "M";
    const sizes = Array.from(new Set([packSize, ...APPAREL_SIZES]));
    const title = cleanNotificationText(purchase?.packTitle) || fallback.title;
    return {
      id: `fallback-purchase-${packKey}`,
      productId: "",
      title,
      packName: title,
      packKey,
      price: fallback.price,
      priceCents: 0,
      imageUrl: fallback.imageUrl,
      modelUrl: modelUrlForPack(root, packKey),
      available: false,
      url: "",
      variants: sizes.map((size) => ({
        id: `fallback-purchase-${packKey}-${size}`,
        title: size,
        size,
        available: false,
        price: fallback.price,
        priceCents: 0,
        sku: "",
        options: [size]
      })),
      fallbackOnly: true
    };
  };

  const normalizePackProduct = (root, pack, index) => {
    const title = String(pack?.title || "").trim();
    if (isBonusPackProductTitle(title)) return [];
    const packName = String(pack?.packName || pack?.variantTitle || title).trim();
    const packKey = packKeyForPayload(pack);
    if (!title || !packName || !packKey) return [];
    const variants = Array.isArray(pack.variants)
      ? pack.variants.flatMap((variant) => normalizePackVariant(variant))
      : normalizeLegacyPackVariant(pack);
    const firstAvailableVariant = variants.find((variant) => variant.available) || variants[0];
    if (variants.length === 0) return [];
    return [
      {
        id: String(pack.id || pack.productId || `pack-${index}`),
        productId: String(pack.productId || pack.id || "").trim(),
        title,
        packName,
        packKey,
        description: String(pack.description || "").trim(),
        price: tokenPrice(pack.price, pack.priceCents) || firstAvailableVariant?.price || "",
        priceCents: pack.priceCents,
        imageUrl: String(pack.imageUrl || "").trim(),
        modelUrl: String(pack.modelUrl || "").trim() || modelUrlForPayloadProduct(root, pack, packKey),
        available: pack.available !== false && variants.some((variant) => variant.available),
        url: normalizeLocalUrl(String(pack.url || "")),
        variants
      }
    ];
  };

  const normalizePackVariant = (variant) => {
    const id = String(variant?.id || "").trim();
    if (!id) return [];
    const optionFields = [variant.option1, variant.option2, variant.option3];
    const options = (Array.isArray(variant.options) ? variant.options : optionFields)
      .map((option) => String(option || "").trim())
      .filter(Boolean);
    const title = String(variant.title || options.join(" / ") || "Default Title").trim();
    const size = normalizeApparelSize(options.find(isApparelSizeLabel) || title);
    if (!size) return [];
    return [
      {
        id,
        title,
        size,
        available: variant.available !== false,
        price: tokenPrice(variant.price, variant.priceCents),
        priceCents: variant.priceCents,
        sku: String(variant.sku || "").trim(),
        options
      }
    ];
  };

  const normalizeLegacyPackVariant = (pack) => {
    const variantId = String(pack?.variantId || "").trim();
    if (!variantId) return [];
    const title = String(pack.variantTitle || pack.packName || pack.title || "M").trim();
    return [
      {
        id: variantId,
        title,
        size: normalizeApparelSize(title) || "M",
        available: pack.available !== false,
        price: tokenPrice(pack.price, pack.priceCents),
        priceCents: pack.priceCents,
        sku: String(pack.sku || "").trim(),
        options: [title]
      }
    ];
  };

  const firstAvailablePackIndex = (packs) => {
    const index = packs.findIndex((pack) => pack.available);
    return index >= 0 ? index : 0;
  };

  const packCheckoutVariant = (pack, packSize) => {
    if (!pack?.available) return null;
    const availableVariants = pack.variants.filter((variant) => variant.available);
    return availableVariants.find((variant) => variant.size === packSize) || null;
  };

  const packAvailabilityKey = (pack, variant, packSize, packTeam) => {
    if (!pack || !variant || !packSize || !packTeam) return "";
    return [
      pack.productId || pack.id,
      variant.id,
      pack.packKey || "",
      packSize,
      packTeam.league || "",
      packTeam.code || ""
    ].join("|");
  };

  const packSizeOrFallback = (pack, preferredSize) => {
    if (!pack) return preferredSize || "M";
    if (packCheckoutVariant(pack, preferredSize)) return preferredSize;
    return pack.variants.find((variant) => variant.available)?.size || pack.variants[0]?.size || preferredSize || "M";
  };

  const sportsLeagueForPack = (pack) => {
    const packKey = normalizePackProductKey(pack?.packKey) || packKeyForPayload(pack);
    if (packKey === "basketball") return "NBA";
    if (packKey === "football") return "NFL";
    return "";
  };

  const sportsTeamsForLeague = (league) => (league === "NBA" ? NBA_TEAMS : league === "NFL" ? NFL_TEAMS : []);

  const packTeamSelection = (pack, teamCode) => {
    const league = sportsLeagueForPack(pack);
    if (!league) return null;
    const normalizedCode = normalizeTeamCode(teamCode);
    return sportsTeamsForLeague(league).find((team) => team.code === normalizedCode) || null;
  };

  const isPackTeamSoldOut = (pack, team) => {
    if (!pack || !team) return false;
    const packKey = normalizePackProductKey(pack.packKey) || packKeyForPayload(pack);
    return isPackTeamSoldOutForPackKey(packKey, team.code);
  };

  const isPackTeamSoldOutForPackKey = (packKey, teamCode) => {
    const normalizedPackKey = normalizePackProductKey(packKey);
    const normalizedTeamCode = normalizeTeamCode(teamCode);
    return Boolean(normalizedPackKey && normalizedTeamCode && SOLD_OUT_PACK_TEAM_CODES[normalizedPackKey]?.has(normalizedTeamCode));
  };

  const packTeamSelectMarkup = (pack, league, selectedCode) => {
    const selected = normalizeTeamCode(selectedCode);
    const packKey = normalizePackProductKey(pack?.packKey) || packKeyForPayload(pack);
    const label = league === "NBA" ? "NBA team" : "NFL team";
    return `
      <label class="wl-pack-screen__team-label">
        <span>${escapeHtml(label)}</span>
        <select data-pack-team-select aria-label="Choose ${escapeAttr(label)}">
          <option value="">Choose team</option>
          ${sportsTeamsForLeague(league)
            .map(
              (team) => {
                const teamSoldOut = isPackTeamSoldOutForPackKey(packKey, team.code);
                return `
                <option value="${escapeAttr(team.code)}" ${team.code === selected ? "selected" : ""} ${teamSoldOut ? "disabled" : ""}>
                  ${escapeHtml(teamSoldOut ? `${team.name} - Sold out` : team.name)}
                </option>
              `;
              }
            )
            .join("")}
        </select>
      </label>
    `;
  };

  const normalizeTeamCode = (value) =>
    String(value || "")
      .trim()
      .toUpperCase()
      .replace(/[^A-Z0-9]+/g, "");

  const packCartPayload = (pack, variant, packSize, reservation = null, packTeam = null) => ({
    items: [
      {
        id: variant.id,
        quantity: 1,
        properties: {
          _wl_pack: "Pack Game",
          _wl_pack_key: pack.packKey,
          _wl_pack_size: packSize,
          _wl_pack_product: pack.title,
          _wl_pack_product_id: pack.productId,
          _wl_pack_variant_id: variant.id,
          ...(packTeam
            ? {
                _wl_pack_team_league: packTeam.league,
                _wl_pack_team_code: packTeam.code,
                _wl_pack_team_name: packTeam.name
              }
            : {}),
          ...(reservation?.reservationId
            ? {
                _wl_credit_reservation_id: reservation.reservationId,
                _wl_credit_reserved_credits: String(reservation.reservedCredits || 0),
                _wl_credit_discount_code: reservation.discountCode || ""
              }
            : {})
        }
      }
    ]
  });

  const submitPackCartLine = async (pack, variant, packSize, reservation = null, packTeam = null) => {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(packCartPayload(pack, variant, packSize, reservation, packTeam))
    });
    if (!response.ok) throw await cartError(response, "Selected pack is not available in Shopify checkout yet.");
    return response.json().catch(() => ({}));
  };

  const submitRaffleTicketCartLine = async (variantId) => {
    const cartVariantId = normalizeShopifyNumericId(variantId);
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items: [
          {
            id: cartVariantId,
            quantity: 1,
            properties: {
              _wl_raffle_ticket_pack: "10"
            }
          }
        ]
      })
    });
    if (!response.ok) throw await cartError(response, "Raffle tickets are not available in Shopify checkout yet.");
    return response.json().catch(() => ({}));
  };

  const cartLineKeyFromAddResponse = (payload) =>
    String(payload?.items?.[0]?.key || payload?.key || "").trim();

  const pendingCheckoutCartLines = async (pending) => {
    try {
      const response = await fetch("/cart.js", { headers: { Accept: "application/json" } });
      if (!response.ok) return [];
      const cart = await response.json();
      return (Array.isArray(cart?.items) ? cart.items : []).filter((line) => cartLineMatchesPending(line, pending));
    } catch {
      return [];
    }
  };

  const removeCartLine = async (line) => {
    const key = String(line?.key || "").trim();
    if (!key) return;
    await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: 0 })
    });
  };

  const cartLineMatchesPending = (line, pending) => {
    if (pending.cartLineKey && String(line?.key || "") === String(pending.cartLineKey)) return true;
    const reservationId = cartPropertyValue(line, "_wl_credit_reservation_id");
    if (pending.creditReservationId && reservationId === String(pending.creditReservationId)) return true;
    const discountCode = cartPropertyValue(line, "_wl_credit_discount_code").toLowerCase();
    if (pending.discountCode && discountCode === String(pending.discountCode).toLowerCase()) return true;
    const packKey = cartPropertyValue(line, "_wl_pack_key");
    const packSize = cartPropertyValue(line, "_wl_pack_size");
    const matchesPack =
      String(line?.variant_id || line?.id || "") === normalizeShopifyNumericId(pending.variantId) &&
      normalizePackProductKey(packKey) === normalizePackProductKey(pending.packKey) &&
      (!pending.packSize || normalizeApparelSize(packSize) === normalizeApparelSize(pending.packSize));
    if (!matchesPack) return false;

    const pendingTeamCode = pending.packTeam?.code ? normalizeTeamCode(pending.packTeam.code) : "";
    if (!pendingTeamCode) return true;
    const pendingTeamLeague = String(pending.packTeam?.league || "")
      .trim()
      .toUpperCase();
    const lineTeamCode = normalizeTeamCode(cartPropertyValue(line, "_wl_pack_team_code"));
    const lineTeamLeague = cartPropertyValue(line, "_wl_pack_team_league").toUpperCase();
    return lineTeamCode === pendingTeamCode && (!pendingTeamLeague || lineTeamLeague === pendingTeamLeague);
  };

  const cartPropertyValue = (line, name) => {
    const properties = line?.properties;
    if (!properties) return "";
    if (Array.isArray(properties)) {
      const match = properties.find((property) => property?.name === name || property?.key === name);
      return String(match?.value || "").trim();
    }
    if (typeof properties === "object") {
      return String(properties[name] || "").trim();
    }
    return "";
  };

  const normalizeShopifyNumericId = (value) => {
    const raw = String(value || "").trim();
    const match = raw.match(/(\d+)$/);
    return match?.[1] || raw;
  };

  const normalizeId = (value) => normalizeShopifyNumericId(value);

  const cartError = async (response, fallback) => {
    try {
      const body = await response.json();
      return new Error(body.description || body.message || fallback);
    } catch {
      return new Error(fallback);
    }
  };

  const raffleListMarkup = (raffles, state = {}) => {
    if (!state.loggedIn) {
      return `
        <div class="wl-raffle-view__panel">
          <h2 id="wl-raffle-title">Raffles</h2>
          <p>Sign in to enter Raffles</p>
          <button type="button" class="wl-raffle-view__primary" data-action="pack-login">SIGN IN</button>
        </div>
      `;
    }
    if (state.loading) {
      return `<div class="wl-raffle-view__panel"><h2 id="wl-raffle-title">Raffles</h2><p>Loading raffles...</p></div>`;
    }
    if (!raffles.length) {
      return `<div class="wl-raffle-view__panel"><h2 id="wl-raffle-title">Raffles</h2><p>No raffles are live right now.</p></div>`;
    }
    return `
      <div class="wl-raffle-view__header">
        <h2 id="wl-raffle-title">Raffles</h2>
        <p>${escapeHtml(raffleFreeEntryLabel(raffles[0]))}</p>
      </div>
      <div class="wl-raffle-grid">
        ${raffles.map((raffle) => raffleCardMarkup(raffle)).join("")}
      </div>
    `;
  };

  const raffleCardMarkup = (raffle) => `
    <button type="button" class="wl-raffle-card" data-action="select-raffle" data-raffle-id="${escapeAttr(raffle.id)}">
      <span class="wl-raffle-card__image ${raffle.imageUrl ? "" : "is-missing"}">
        ${raffle.imageUrl ? `<img src="${escapeAttr(raffle.imageUrl)}" alt="">` : `<span>${escapeHtml(raffle.title || "Raffle")}</span>`}
      </span>
      <span class="wl-raffle-card__body">
        <strong>${escapeHtml(raffle.title || "Raffle")}</strong>
        <span class="wl-raffle-card__timer"${raffleTimerAttrs(raffle)}>${escapeHtml(raffleStatusLabel(raffle))}</span>
        <span class="wl-raffle-card__credits">1 ticket per entry</span>
      </span>
    </button>
  `;

  const raffleDetailMarkup = (raffle, state = {}) => {
    const isActive = raffle.status === "active";
    const creditBalance = Number(state.creditBalance || 0);
    const ticketBalance = Number(state.ticketBalance || 0);
    const paidEntriesRemaining = Math.max(0, Number(raffle.paidEntriesRemaining ?? 10) || 0);
    const ticketMaxQuantity = Math.max(0, Math.min(10, paidEntriesRemaining));
    const creditCostPerEntry = Math.max(0, Number(raffle.ticketCostCredits || 0) || 0);
    const creditMaxQuantity = creditCostPerEntry > 0 ? Math.min(25, Math.floor(creditBalance / creditCostPerEntry)) : 0;
    const maxQuantity = Math.max(1, ticketMaxQuantity, creditMaxQuantity);
    const quantity = Math.max(1, Math.min(maxQuantity, Number(state.quantity || 1)));
    const ticketCost = quantity;
    const creditCost = creditCostPerEntry * quantity;
    const canUseTickets = ticketBalance >= ticketCost && quantity <= ticketMaxQuantity;
    const canUseCredits = creditCostPerEntry > 0 && creditBalance >= creditCost && quantity <= creditMaxQuantity;
    const ticketVariantAvailable = Boolean(String(state.ticketVariantId || "").trim());
    const freeDisabled = !state.loggedIn || !isActive || !raffle.freeEntryAvailable || Boolean(state.busyAction);
    const ticketDisabled = !state.loggedIn || !isActive || !canUseTickets || Boolean(state.busyAction);
    const creditDisabled = !state.loggedIn || !isActive || !canUseCredits || Boolean(state.busyAction);
    const buyDisabled = !state.loggedIn || !isActive || !ticketVariantAvailable || Boolean(state.busyAction);
    const description = raffleDescriptionCopy(raffle);
    const usesDetailModel = raffleDetailUsesModel(raffle);
    return `
      <div class="wl-raffle-detail">
        <button type="button" class="wl-raffle-detail__back" data-action="raffle-back">BACK</button>
        <div class="wl-raffle-detail__image ${usesDetailModel ? "has-model" : ""} ${raffle.imageUrl ? "" : "is-missing"}">
          ${raffleDetailMediaMarkup(raffle)}
        </div>
        <div class="wl-raffle-detail__body">
          <p class="wl-slot__hint"${raffleTimerAttrs(raffle)}>${escapeHtml(raffleStatusLabel(raffle))}</p>
          <h2 id="wl-raffle-title">${escapeHtml(raffle.title || "Raffle")}</h2>
          ${description ? `<p class="wl-raffle-description">${escapeHtml(description)}</p>` : ""}
          <dl class="wl-raffle-stats">
            <div><dt>Your entries</dt><dd>${formatCredits(raffle.customerEntries || 0)}</dd></div>
            <div><dt>Total entries</dt><dd>${formatCredits(raffle.totalEntries || 0)}</dd></div>
            <div><dt>Your odds</dt><dd>${formatProbability(raffle.winProbability || 0)}</dd></div>
            <div><dt>Your tickets</dt><dd>${formatCredits(ticketBalance)}</dd></div>
          </dl>
          ${raffleWinnerMarkup(raffle)}
          <p class="wl-raffle-rules">${raffleRulesCopy(raffle)}</p>
          <div class="wl-raffle-actions">
            <button type="button" class="wl-raffle-view__primary ${state.busyAction === "free" ? "is-busy" : ""}" data-action="raffle-free-entry" ${freeDisabled ? "disabled" : ""}>
              ${raffle.freeEntryAvailable ? "Use free entry" : `Free entry ${relativeTimeLabel(raffle.freeEntryAvailableAt)}`}
            </button>
            <div class="wl-raffle-quantity">
              <button type="button" data-action="raffle-qty-dec" ${quantity <= 1 || state.busyAction || maxQuantity <= 1 ? "disabled" : ""}>-</button>
              <span>${quantity}</span>
              <button type="button" data-action="raffle-qty-inc" ${quantity >= maxQuantity || state.busyAction || maxQuantity <= 1 ? "disabled" : ""}>+</button>
            </div>
            <button type="button" class="wl-raffle-view__secondary ${state.busyAction === "paid-ticket" ? "is-busy" : ""}" data-action="raffle-paid-entry" ${ticketDisabled ? "disabled" : ""}>
              Enter ${quantity} with ${formatCredits(ticketCost)} ticket${ticketCost === 1 ? "" : "s"}
            </button>
            <button type="button" class="wl-raffle-view__secondary ${state.busyAction === "paid-credit" ? "is-busy" : ""}" data-action="raffle-credit-entry" ${creditDisabled ? "disabled" : ""}>
              Enter ${quantity} with ${formatCredits(creditCost)} credits
            </button>
            <button type="button" class="wl-raffle-view__secondary ${state.busyAction === "buy-tickets" ? "is-busy" : ""}" data-action="buy-raffle-tickets" ${buyDisabled ? "disabled" : ""}>
              Get 10 tickets - $20
            </button>
          </div>
        </div>
      </div>
    `;
  };

  const raffleDetailMediaMarkup = (raffle) => {
    const modelUrl = String(raffle.modelUrl || "").trim();
    const imageUrl = String(raffle.imageUrl || "").trim();
    if (imageUrl) return `<img src="${escapeAttr(imageUrl)}" alt="">`;
    if (modelUrl) {
      preloadPackModel(modelUrl);
      const modelControls = isMobilePackViewport() ? "" : "camera-controls";
      return `
        <span class="wl-pack-model wl-raffle-detail__model has-static-model is-model-loading" data-raffle-model aria-hidden="true">
          <model-viewer src="${escapeAttr(modelUrl)}" ${modelControls} disable-zoom interaction-prompt="none" loading="eager" reveal="auto" camera-orbit="${packFrontCameraOrbit()}" min-camera-orbit="${packSwayMinOrbit()}" max-camera-orbit="${packSwayMaxOrbit()}" field-of-view="30deg" min-field-of-view="30deg" max-field-of-view="30deg" shadow-intensity="0.85" alt="${escapeAttr(raffle.title || "Raffle")}"></model-viewer>
          <span class="wl-pack-model__placeholder">${escapeHtml(raffle.title || "Raffle")}</span>
        </span>
      `;
    }
    return `<span>${escapeHtml(raffle.title || "Raffle")}</span>`;
  };

  const raffleDetailUsesModel = (raffle) =>
    !String(raffle.imageUrl || "").trim() && Boolean(String(raffle.modelUrl || "").trim());

  const raffleDescriptionCopy = (raffle) => {
    const packKey = normalizePackProductKey(raffle.packKey);
    const titleKey = packKeyForProductText(String(raffle.title || "").toLowerCase());
    if (packKey === "the_one" || titleKey === "the_one") return THE_ONE_RAFFLE_DESCRIPTION;
    const explicit = String(raffle.description || "").trim();
    if (explicit) return explicit;
    return "";
  };

  const raffleWinnerMarkup = (raffle) => {
    if (raffle.status !== "finalized") return "";
    if (raffle.isWinner) return `<p class="wl-raffle-winner is-winner">You won this raffle.</p>`;
    if (raffle.winningEntryId) return `<p class="wl-raffle-winner">Winner selected.</p>`;
    return `<p class="wl-raffle-winner">Raffle closed with no entries.</p>`;
  };

  const raffleRulesCopy = (raffle) =>
    `No purchase needed: use the free entry when it is available. Paid entries can use raffle tickets or credits. Ticket entries use 1 ticket each, up to ${formatCredits(raffle.paidEntryLimit || 10)} per raffle. Credit entries are ${formatCredits(raffle.ticketCostCredits || 0)} credits each. Enter before the raffle closes; one winner is selected at random after the end time. Keep your account address current so we can ship the prize.`;

  const raffleStatusLabel = (raffle) => {
    if (raffle.status === "finalized") return raffle.isWinner ? "Winner" : "Finalized";
    if (raffle.status === "closed") return "Drawing soon";
    if (raffle.status === "scheduled") return raffleTimerLabel("scheduled", raffle.startsAt);
    return raffleTimerLabel("active", raffle.endsAt);
  };

  const raffleTimerAttrs = (raffle) => {
    if (raffle.status !== "active" && raffle.status !== "scheduled") return "";
    const target = raffle.status === "scheduled" ? raffle.startsAt : raffle.endsAt;
    if (!Number.isFinite(Date.parse(target || ""))) return "";
    return ` data-raffle-timer data-raffle-status="${escapeAttr(raffle.status)}" data-raffle-target="${escapeAttr(target)}"`;
  };

  const raffleTimerLabel = (status, target) => {
    if (status === "scheduled") return `Starts ${countdownLabel(target, "soon")}`;
    if (status === "active") {
      const timestamp = Date.parse(target || "");
      if (Number.isFinite(timestamp) && timestamp <= Date.now()) return "Drawing soon";
      return `Ends ${countdownLabel(target, "soon")}`;
    }
    return "";
  };

  const countdownLabel = (value, fallback = "soon") => {
    const timestamp = Date.parse(value || "");
    if (!Number.isFinite(timestamp)) return fallback;
    const totalSeconds = Math.max(0, Math.floor((timestamp - Date.now()) / 1000));
    if (totalSeconds <= 0) return "now";
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    if (days > 0) return `in ${days}d ${hours}h ${minutes}m ${seconds}s`;
    if (hours > 0) return `in ${hours}h ${minutes}m ${seconds}s`;
    return `in ${minutes}m ${seconds}s`;
  };

  const raffleFreeEntryLabel = (raffle) =>
    raffle?.freeEntryAvailable ? "One free entry is available." : `Free entry ${relativeTimeLabel(raffle?.freeEntryAvailableAt)}`;

  const relativeTimeLabel = (value) => {
    const timestamp = Date.parse(value || "");
    if (!Number.isFinite(timestamp)) return "soon";
    const diffMs = timestamp - Date.now();
    const abs = Math.abs(diffMs);
    if (abs < 60 * 1000) return diffMs >= 0 ? "in less than a minute" : "just now";
    const minutes = Math.round(abs / 60000);
    if (minutes < 60) return `${diffMs >= 0 ? "in " : ""}${minutes}m${diffMs < 0 ? " ago" : ""}`;
    const hours = Math.round(minutes / 60);
    if (hours < 48) return `${diffMs >= 0 ? "in " : ""}${hours}h${diffMs < 0 ? " ago" : ""}`;
    const days = Math.round(hours / 24);
    return `${diffMs >= 0 ? "in " : ""}${days}d${diffMs < 0 ? " ago" : ""}`;
  };

  const formatProbability = (value) => {
    const percent = Math.max(0, Math.min(1, Number(value) || 0)) * 100;
    if (percent === 0) return "0%";
    if (percent < 1) return `${percent.toFixed(2)}%`;
    return `${percent.toFixed(1).replace(/\.0$/, "")}%`;
  };

  const packRevealMarkup = (purchase, remainingCount, status = {}) => {
    const items = Array.isArray(purchase.items) ? purchase.items : [];
    const creditAward = packRevealCreditAward(purchase);
    const creditsAwarded = Boolean(creditAward);
    const settled = isRewardSettled(purchase);
    const notice = status.message || (creditsAwarded ? "" : settled ? rewardSettledMessage(purchase) : "");
    const shipDisabled = status.shipping || status.selling || settled;
    const sellAvailable = Number(purchase.buybackCredits || 0) > 0 && !shipDisabled;

    const creditAwardItem = creditsAwarded
      ? `
          <article class="wl-pack-reveal__item">
            <div class="wl-pack-reveal__media">
              <span aria-hidden="true">CR</span>
            </div>
            <div>
              <h3>${formatCredits(creditAward.credits)} Credits</h3>
              <p>Added to your account</p>
            </div>
          </article>
        `
      : "";

    if (creditsAwarded && items.length === 0) {
      return `
        <div class="wl-pack-reveal__summary">
          <span>REVEALED</span>
          <strong>${formatCredits(creditAward.credits)} CREDITS ADDED</strong>
          <em>${escapeHtml(packSourceLabel(purchase))}</em>
        </div>
        <div class="wl-pack-reveal__items is-single">
          <article class="wl-pack-reveal__item">
            <div class="wl-pack-reveal__media">
              <span aria-hidden="true">CR</span>
            </div>
            <div>
              <h3>${formatCredits(creditAward.credits)} Credits</h3>
              <p>Added to your account</p>
            </div>
          </article>
        </div>
        <div class="wl-pack-reveal__settlement">
          <button type="button" class="wl-pack-reveal__back" data-action="pack-home">BACK TO PACKS</button>
        </div>
        ${notice ? `<p class="wl-pack-reveal__notice">${escapeHtml(notice)}</p>` : ""}
      `;
    }

    const revealItemCount = items.length + (creditsAwarded ? 1 : 0);
    const revealSummary = creditsAwarded
      ? `${items.length} ITEM${items.length === 1 ? "" : "S"} + ${formatCredits(creditAward.credits)} CREDITS SECURED`
      : `${items.length} ITEM${items.length === 1 ? "" : "S"} SECURED`;

    return `
      <div class="wl-pack-reveal__summary">
        <span>REVEALED</span>
        <strong>${revealSummary}</strong>
        <em>${escapeHtml(packSourceLabel(purchase))}</em>
      </div>
      <div class="wl-pack-reveal__items ${revealItemCount === 1 ? "is-single" : ""}">
        ${creditAwardItem}
        ${items.map((item) => `
          <article class="wl-pack-reveal__item">
            <div class="wl-pack-reveal__media">
              ${item.imageUrl ? `<img data-pack-reveal-image src="${escapeAttr(item.imageUrl)}" alt="${escapeAttr(item.productTitle)}" loading="eager" decoding="async" fetchpriority="high">` : ""}
              <span aria-hidden="true" ${item.imageUrl ? "hidden" : ""}>${escapeHtml(String(item.productTitle || "WL").slice(0, 2).toUpperCase())}</span>
            </div>
            <div>
              <h3>${escapeHtml(item.productTitle)}</h3>
              <p>${escapeHtml(item.variantTitle || item.size || "")}${packRevealRetailText(item)}</p>
            </div>
          </article>
        `).join("")}
      </div>
      <div class="wl-pack-reveal__settlement">
        <button
          type="button"
          class="wl-pack-reveal__ship ${status.shipping ? "is-busy" : ""}"
          data-action="ship-pack"
          data-pack-purchase-id="${escapeAttr(purchase.id)}"
          ${shipDisabled ? "disabled" : ""}
          aria-busy="${status.shipping ? "true" : "false"}"
        >
          ${status.shipping ? "CREATING SHIPMENT" : settled ? rewardSettledActionLabel(purchase) : "SHIP"}
        </button>
        <button
          type="button"
          class="wl-pack-reveal__sell ${status.selling ? "is-busy" : ""}"
          data-action="sell-pack"
          data-pack-purchase-id="${escapeAttr(purchase.id)}"
          ${sellAvailable ? "" : "disabled"}
          aria-busy="${status.selling ? "true" : "false"}"
        >
          ${status.selling
            ? "SELLING BACK"
            : settled
              ? "ALREADY SETTLED"
              : Number(purchase.buybackCredits || 0) > 0
                ? `SELL FOR ${formatCredits(purchase.buybackCredits || 0)} CREDITS`
                : "NO SELLBACK CREDITS"}
        </button>
        <button type="button" class="wl-pack-reveal__back" data-action="pack-home">BACK TO PACKS</button>
      </div>
      ${notice ? `<p class="wl-pack-reveal__notice">${escapeHtml(notice)}</p>` : ""}
    `;
  };

  const bindRevealImageFallbacks = (root) => {
    root.querySelectorAll("[data-pack-reveal-image]").forEach((image) => {
      if (!(image instanceof HTMLImageElement)) return;
      const fallback = image.nextElementSibling;
      const showFallback = () => {
        image.hidden = true;
        if (fallback instanceof HTMLElement) fallback.hidden = false;
      };
      const hideFallback = () => {
        image.hidden = false;
        if (fallback instanceof HTMLElement) fallback.hidden = true;
      };

      image.addEventListener("load", () => (image.naturalWidth > 0 ? hideFallback() : showFallback()), { once: true });
      image.addEventListener("error", showFallback, { once: true });
      if (image.complete) {
        if (image.naturalWidth > 0) hideFallback();
        else showFallback();
      }
    });
  };

  const isRewardSettled = (purchase) =>
    purchase?.state === "credits_awarded" ||
    purchase?.state === "fulfillment_created" ||
    purchase?.state === "sold_back" ||
    purchase?.state === "voided" ||
    Boolean(purchase?.settledAt && purchase?.state !== "opened");

  const rewardSettledActionLabel = (purchase) => {
    if (purchase?.state === "credits_awarded") return "CREDITS ADDED";
    if (purchase?.state === "sold_back") return "SOLD BACK";
    if (purchase?.state === "voided") return "NO LONGER AVAILABLE";
    return "SHIPPING CREATED";
  };

  const rewardSettledMessage = (purchase) => {
    if (purchase?.state === "credits_awarded") return "";
    if (purchase?.state === "sold_back") return "This reward was already sold back for credits.";
    if (purchase?.state === "voided") return "This reward is no longer available.";
    return "This reward already has a shipping order.";
  };

  const packRevealRetailText = (item) => {
    const retailUsd = Number(item.retailUsd);
    if (!Number.isFinite(retailUsd) || retailUsd <= 0) return "";
    return ` / Retail ${formatUsd(retailUsd)}`;
  };

  const packRevealCreditAward = (purchase) => {
    const award = purchase?.creditAward || null;
    const credits = Number(award?.credits || 0);
    if (!award || !Number.isFinite(credits) || credits <= 0) return null;
    if (purchase?.state === "credits_awarded" || award.state === "granted") {
      return { ...award, credits };
    }
    return null;
  };

  const buildTestRevealPurchase = (pack, packSize) => {
    const now = new Date().toISOString();
    return {
      id: `animation-test-${pack.packKey || "pack"}`,
      shopifyOrderId: "animation-test",
      shopifyOrderName: "Animation Test",
      shopifyRevealOrderId: "animation-test",
      packKey: pack.packKey,
      packTitle: pack.packName || pack.title || "WL Pack",
      packSize,
      state: "fulfillment_created",
      items: buildTestRevealItems(pack, packSize),
      createdAt: now,
      openedAt: now
    };
  };

  const buildCreditOpeningPurchase = (pending) => {
    const now = new Date().toISOString();
    const pack = pending.pack || {};
    const variant = pending.variant || {};
    const packTitle = pack.packName || pack.title || "WL Pack";
    return {
      id: `credit-opening-${pending.idempotencyKey || variant.id || Date.now()}`,
      shopifyOrderId: "credit-pending",
      shopifyOrderName: "Credit purchase",
      shopifyRevealOrderId: null,
      packProductId: String(pack.productId || pack.id || ""),
      packVariantId: String(variant.id || ""),
      packKey: pack.packKey || packKeyForPayload(pack),
      packTitle,
      packSize: pending.packSize || variant.size || "",
      packTeam: pending.packTeam || null,
      packPriceCents: packPriceCents(pack, variant),
      buybackCredits: 0,
      canShip: true,
      state: "allocated",
      items: [],
      createdAt: now,
      openedAt: null,
      settledAt: null
    };
  };

  const findCreditPurchaseByIdempotency = (state, idempotencyKey) => {
    if (!state || !idempotencyKey) return null;
    const purchases = [
      ...(Array.isArray(state.openedPacks) ? state.openedPacks : []),
      ...(Array.isArray(state.unopenedPacks) ? state.unopenedPacks : []),
      ...(Array.isArray(state.settledPacks) ? state.settledPacks : [])
    ];
    return purchases.find((purchase) => String(purchase.shopifyOrderId || "").includes(idempotencyKey)) || null;
  };

  const buildTestRevealItems = (pack, packSize) => {
    const content = PACK_INFO_CONTENT[pack.packKey] || null;
    const sourceItems = [];
    if (content) {
      const guaranteedItems = Array.isArray(content.guaranteed) ? content.guaranteed : [];
      const randomSlots = Array.isArray(content.randomSlots) ? content.randomSlots : [];
      guaranteedItems
        .filter((item) => !/\brandom item\b/i.test(item))
        .forEach((item) => sourceItems.push(item));
      randomSlots.forEach((slot) => {
        const mostLikely = slot.odds[0]?.item;
        if (mostLikely) sourceItems.push(mostLikely);
      });
    }
    if (sourceItems.length === 0) sourceItems.push("Mystery item");

    return sourceItems.map((item, index) => {
      const title = testRevealItemTitle(item);
      return {
        id: `animation-test-item-${index + 1}`,
        shopifyProductId: `animation-test-product-${index + 1}`,
        shopifyVariantId: `animation-test-variant-${index + 1}`,
        productTitle: title,
        variantTitle: testRevealVariantTitle(title, packSize),
        productType: "Animation Test",
        size: testRevealVariantTitle(title, packSize),
        imageUrl: "",
        sku: "",
        retailUsd: testRevealRetailValue(title),
        slotKey: `animation_test_${index + 1}`,
        state: "order_created"
      };
    });
  };

  const testRevealItemTitle = (value) =>
    String(value || "Mystery item")
      .replace(/^\d+\s+/g, "")
      .replace(/^1\s+/i, "")
      .trim();

  const testRevealVariantTitle = (title, packSize) =>
    /\b(t-?shirt|tee|hoodie|mainline|piece)\b/i.test(title) ? packSize : "OS";

  const testRevealRetailValue = (title) => {
    if (/\bmainline|piece\b/i.test(title)) return 250;
    if (/\bhoodie\b/i.test(title)) return 120;
    if (/\bt-?shirt|tee\b/i.test(title)) return 60;
    if (/\bhat\b/i.test(title)) return 45;
    if (/\bsock\b/i.test(title)) return 25;
    if (/\bpencil\b/i.test(title)) return 10;
    return 35;
  };

  const packInfoMarkup = (content, displayName, displayPrice) => {
    const guaranteedItems = Array.isArray(content.guaranteed) ? content.guaranteed : [];
    const randomSlots = Array.isArray(content.randomSlots) ? content.randomSlots : [];
    return `
      <header class="wl-pack-info__header">
        <p class="wl-slot__hint">Pack odds</p>
        <h2 id="wl-pack-info-title">${escapeHtml(displayName)}</h2>
        <strong class="wl-pack-info__price">${escapeHtml(displayPrice)}</strong>
      </header>
      <div class="wl-pack-info__content">
        ${guaranteedItems.length ? `
          <section class="wl-pack-info__section">
            <h3>${escapeHtml(content.guaranteedLabel || "Guaranteed contents")}</h3>
            <ul>
              ${guaranteedItems.map((item) => `<li>${escapeHtml(item)}</li>`).join("")}
            </ul>
          </section>
        ` : ""}
        ${randomSlots.map((slot) => `
          <section class="wl-pack-info__section">
            <h3>${escapeHtml(slot.label)}</h3>
            <dl class="wl-pack-info__odds">
              ${slot.odds.map((odd) => `
                <div>
                  <dt>${escapeHtml(odd.chance)}</dt>
                  <dd>${escapeHtml(odd.item)}</dd>
                </div>
              `).join("")}
            </dl>
          </section>
        `).join("")}
      </div>
    `;
  };

  const bonusPackMenuLabel = (bonusState, hasKnownCustomer) => {
    if (!hasKnownCustomer) return "Bonus Packs: Sign In";
    if (!bonusState) return "Bonus Packs";
    if (bonusState.openedPack) return "Bonus Pack Opened";
    if (bonusState.unopenedPack) return "Open Bonus Pack";
    if (bonusState.eligible && !bonusState.claimed) return "Bonus Pack Ready";
    return "No Bonus Pack Available";
  };

  const packQueueReadyStatus = (unopenedCount) => {
    if (unopenedCount <= 1) return "";
    const remaining = unopenedCount - 1;
    return `1 OF ${unopenedCount} READY / ${packCountLabel(remaining)} AFTER THIS`;
  };

  const packQueueOpenedStatus = (queueTotal, remainingCount) => {
    const total = Math.max(queueTotal, remainingCount + 1);
    if (total <= 1) return "";
    const openedCount = Math.max(1, total - remainingCount);
    return `${openedCount} OF ${total} OPENED / ${packCountLabel(remainingCount)} REMAINING`;
  };

  const notificationPanelMarkup = (notifications, unreadCount) => `
    <div class="wl-notifications-menu__header">
      <strong>${notificationPanelTitle(notifications.length, unreadCount)}</strong>
      ${unreadCount > 0 ? `<button type="button" data-action="mark-all-notifications-read">Mark all read</button>` : ""}
    </div>
    ${notifications.map((notification) => notificationMarkup(notification)).join("")}
  `;

  const notificationPanelTitle = (totalCount, unreadCount) => {
    const activeLabel = `${totalCount} active pack${totalCount === 1 ? "" : "s"}`;
    if (unreadCount > 0) return `${unreadCount} new / ${activeLabel}`;
    return activeLabel;
  };

  const notificationMarkup = (notification) => `
    <article class="wl-notifications-menu__item ${notification.read ? "is-read" : "is-unread"}">
      <div>
        <div class="wl-notifications-menu__item-heading">
          <strong>${escapeHtml(notification.title)}</strong>
          <span>${notification.read ? "Seen" : "New"}</span>
        </div>
        <p>${escapeHtml(notification.detail)}</p>
      </div>
      <div class="wl-notifications-menu__actions">
        <button
          type="button"
          data-action="resume-pack"
          data-notification-id="${escapeAttr(notification.id || "")}"
          data-pack-purchase-id="${escapeAttr(notification.packPurchaseId || "")}"
          role="menuitem"
        >
          ${escapeHtml(notification.actionLabel)}
        </button>
        ${
          notification.read
            ? ""
            : `<button type="button" data-action="mark-notification-read" data-notification-id="${escapeAttr(notification.id || "")}" role="menuitem">Mark read</button>`
        }
      </div>
    </article>
  `;

  const emptyNotificationsMarkup = (hasKnownCustomer) => `
    <div class="wl-notifications-menu__empty" role="menuitem">
      <strong>${hasKnownCustomer ? "All caught up" : "Sign in to view notifications"}</strong>
      <p>${hasKnownCustomer ? "No pack actions need your attention right now." : "Pack notifications appear here after sign in."}</p>
    </div>
  `;

  const rewardNotificationDetail = (purchase) => {
    const items = Array.isArray(purchase.items) ? purchase.items : [];
    const itemLabel =
      items.length === 1
        ? cleanNotificationText(items[0]?.productTitle)
        : items.length > 1
          ? `${items.length} rewards`
          : "Reward";
    return [itemLabel, packSourceLabel(purchase)].filter(Boolean).join(" / ");
  };

  const notificationIdForPurchase = (purchase, fallbackState) =>
    `pack:${purchase?.id || "unknown"}:${purchase?.state || fallbackState}`;

  const packSourceLabel = (purchase) =>
    [
      cleanNotificationText(purchase.packTitle),
      cleanNotificationText(purchase.packSize),
      cleanNotificationText(purchase.packTeam?.name),
      cleanNotificationText(purchase.shopifyOrderName)
    ]
      .filter(Boolean)
      .join(" / ");

  const cleanNotificationText = (value) => String(value || "").trim();

  const packCountLabel = (count) => `${count} PACK${count === 1 ? "" : "S"}`;

  const packKeyForPayload = (pack) => {
    const explicitPackKey = normalizePackProductKey(pack?.packKey);
    const source = [pack?.packName, pack?.title, pack?.variantTitle, pack?.sku]
      .map((value) => String(value || ""))
      .join(" ")
      .toLowerCase();
    const inferredPackKey = packKeyForProductText(source);
    if (inferredPackKey === "the_one") return inferredPackKey;
    return explicitPackKey || inferredPackKey;
  };

  const packKeyForProductText = (source) => {
    if (/\brailroad[\s_-]*bum\b/.test(source)) return "railroadbum";
    if (/\bforbidden[\s_-]*merchant\b/.test(source) || /\bcursed[\s_-]*pack\b/.test(source)) return "forbiddenmerchant";
    if (/\buncle[\s_-]*sam'?s?\b/.test(source)) return "unclesams";
    if (/\bfast\b/.test(source)) return "fast";
    if (/\bfiesta\b/.test(source)) return "fiesta";
    if (/\bhot[\s_-]*streak\b/.test(source)) return "hot_streak";
    if (/\bholy[\s_-]*grail\b/.test(source)) return "holy_grail";
    if (/\bfree[\s_-]*love\b/.test(source)) return "free_love";
    if (/\bhard[\s_-]*labor\b/.test(source)) return "hard_labor";
    if (/\bpenny[\s_-]+pincher\b/.test(source)) return "penny_pincher";
    if (/\bthe[\s_-]+one[\s_-]+pack\b/.test(source)) return "the_one";
    if (/\bgold\b/.test(source)) return "gold";
    if (/\bhoney\b/.test(source)) return "honey";
    if (/\banime\b/.test(source)) return "anime";
    if (/\bclassics?\b/.test(source)) return "classics";
    if (/\bplatinum\b/.test(source)) return "platinum";
    if (/\bserenity\b/.test(source)) return "serenity";
    if (/\bdiamond\b/.test(source)) return "diamond";
    if (/\bmainline\b/.test(source)) return "mainline";
    if (/\bvision[\s_-]+quest\b/.test(source)) return "vision_quest";
    if (/\blost[\s_-]+in[\s_-]+vegas\b/.test(source)) return "lost_in_vegas";
    if (/\bchip[\s_-]+stacker\b/.test(source)) return "chip_stacker";
    if (/\bbank[\s_-]+breaker\b/.test(source)) return "bank_breaker";
    if (/\bslavic\b/.test(source)) return "slavic";
    if (/\bbread[\s_-]*winner\b/.test(source)) return "breadwinner";
    if (/\booze(?:[\s_-]+sprayer)?\b/.test(source)) return "ooze_sprayer";
    if (/\bgusher\b/.test(source)) return "gusher";
    if (/\bbasketball\b/.test(source) || /\bnba\b/.test(source)) return "basketball";
    if (/\bfootball\b/.test(source) || /\bnfl\b/.test(source)) return "football";
    return null;
  };

  const normalizePackProductKey = (value) => {
    const normalized = String(value || "")
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, " ");
    if (["railroadbum", "railroad bum", "railroad bum budget", "railroad bum budget pack"].includes(normalized)) return "railroadbum";
    if (["forbiddenmerchant", "forbidden merchant", "forbidden merchant cursed", "forbidden merchant cursed pack", "cursed pack"].includes(normalized)) {
      return "forbiddenmerchant";
    }
    if (["unclesams", "uncle sam", "uncle sams", "uncle sam s", "uncle sam crack", "uncle sams crack", "uncle sam s crack", "unclesams crack", "uncle sam crack pack", "uncle sams crack pack", "uncle sam s crack pack", "unclesams crack pack"].includes(normalized)) {
      return "unclesams";
    }
    if (normalized === "fast" || normalized === "fast pack") return "fast";
    if (normalized === "fiesta" || normalized === "fiesta pack") return "fiesta";
    if (normalized === "hotstreak" || normalized === "hot streak" || normalized === "hot streak pack") return "hot_streak";
    if (normalized === "holygrail" || normalized === "holy grail" || normalized === "holy grail pack") return "holy_grail";
    if (normalized === "freelove" || normalized === "free love" || normalized === "free love pack") return "free_love";
    if (normalized === "hardlabor" || normalized === "hard labor" || normalized === "hard labor pack") return "hard_labor";
    if (normalized === "penny pincher" || normalized === "penny pincher pack") return "penny_pincher";
    if (normalized === "the one" || normalized === "the one pack") return "the_one";
    if (normalized === "gold" || normalized === "gold pack") return "gold";
    if (normalized === "honey" || normalized === "honey pack") return "honey";
    if (normalized === "anime" || normalized === "anime pack") return "anime";
    if (normalized === "classics" || normalized === "classic" || normalized === "classics pack") return "classics";
    if (normalized === "platinum" || normalized === "platinum pack") return "platinum";
    if (normalized === "serenity" || normalized === "serenity pack") return "serenity";
    if (normalized === "diamond" || normalized === "diamond pack") return "diamond";
    if (normalized === "mainline" || normalized === "mainline pack") return "mainline";
    if (normalized === "visionquest" || normalized === "vision quest" || normalized === "vision quest pack") return "vision_quest";
    if (normalized === "lostinvegas" || normalized === "lost in vegas" || normalized === "lost in vegas pack") return "lost_in_vegas";
    if (normalized === "chipstacker" || normalized === "chip stacker" || normalized === "chip stacker pack") return "chip_stacker";
    if (normalized === "bankbreaker" || normalized === "bank breaker" || normalized === "bank breaker pack") return "bank_breaker";
    if (normalized === "slavic" || normalized === "slavic pack") return "slavic";
    if (normalized === "breadwinner" || normalized === "bread winner" || normalized === "breadwinner pack" || normalized === "bread winner pack") return "breadwinner";
    if (normalized === "oozesprayer" || normalized === "ooze sprayer" || normalized === "ooze sprayer pack" || normalized === "ooze" || normalized === "ooze pack") {
      return "ooze_sprayer";
    }
    if (normalized === "gusher" || normalized === "gusher pack") return "gusher";
    if (normalized === "basketball" || normalized === "basketball pack" || normalized === "nba" || normalized === "nba pack") return "basketball";
    if (normalized === "football" || normalized === "football pack" || normalized === "nfl" || normalized === "nfl pack") return "football";
    if (normalized === "bonus" || normalized === "bonus pack" || normalized === "bonus packs") return "bonus";
    return null;
  };

  const normalizePackLookupLabel = (value) =>
    String(value || "")
      .trim()
      .toLowerCase()
      .replace(/\bpack\b/g, "")
      .replace(/[^a-z0-9]+/g, " ")
      .trim();

  const packMatchesPendingCheckout = (pack, pending) => {
    const pendingCreatedAt = Number(pending?.createdAt || 0);
    const packCreatedAt = Date.parse(pack?.createdAt || "");
    if (
      Number.isFinite(pendingCreatedAt) &&
      pendingCreatedAt > 0 &&
      Number.isFinite(packCreatedAt) &&
      packCreatedAt < pendingCreatedAt - PENDING_PACK_MATCH_GRACE_MS
    ) {
      return false;
    }
    const pendingPackKey = normalizePackProductKey(pending.packKey);
    if (pendingPackKey && pack.packKey !== pendingPackKey) return false;
    const pendingSize = normalizeApparelSize(pending.packSize) || String(pending.packSize || "").trim();
    if (pendingSize && pack.packSize !== pendingSize) return false;
    const pendingTeam = pending.packTeam?.code ? normalizeTeamCode(pending.packTeam.code) : "";
    const packTeam = pack.packTeam?.code ? normalizeTeamCode(pack.packTeam.code) : "";
    if (pendingTeam && packTeam !== pendingTeam) return false;
    const pendingLeague = String(pending.packTeam?.league || "")
      .trim()
      .toUpperCase();
    const packLeague = String(pack.packTeam?.league || "")
      .trim()
      .toUpperCase();
    if (pendingLeague && packLeague !== pendingLeague) return false;
    return pendingPackKey ? true : normalizePackLookupLabel(pack.packTitle) === normalizePackLookupLabel(pending.packName);
  };

  const modelUrlForPack = (root, packKey) => {
    const urls = {
      railroadbum: root.dataset.railroadbumPackModelUrl,
      forbiddenmerchant: root.dataset.forbiddenmerchantPackModelUrl,
      unclesams: root.dataset.unclesamsPackModelUrl,
      fast: root.dataset.fastPackModelUrl,
      fiesta: root.dataset.fiestaPackModelUrl,
      hot_streak: root.dataset.hotStreakPackModelUrl,
      holy_grail: root.dataset.holyGrailPackModelUrl,
      free_love: root.dataset.freeLovePackModelUrl,
      hard_labor: root.dataset.hardLaborPackModelUrl,
      penny_pincher: root.dataset.pennyPincherPackModelUrl,
      the_one: root.dataset.theOnePackModelUrl,
      gold: root.dataset.goldPackModelUrl,
      honey: root.dataset.honeyPackModelUrl,
      anime: root.dataset.animePackModelUrl,
      classics: root.dataset.classicsPackModelUrl,
      mainline: root.dataset.mainlinePackModelUrl,
      vision_quest: root.dataset.visionQuestPackModelUrl || root.dataset.mainlinePackModelUrl,
      lost_in_vegas: root.dataset.lostInVegasPackModelUrl,
      chip_stacker: root.dataset.chipStackerPackModelUrl,
      bank_breaker: root.dataset.bankBreakerPackModelUrl,
      slavic: root.dataset.slavicPackModelUrl,
      breadwinner: root.dataset.breadwinnerPackModelUrl,
      ooze_sprayer: root.dataset.oozeSprayerPackModelUrl,
      gusher: root.dataset.gusherPackModelUrl,
      platinum: root.dataset.platinumPackModelUrl,
      serenity: root.dataset.serenityPackModelUrl,
      diamond: root.dataset.diamondPackModelUrl,
      basketball: root.dataset.basketballPackModelUrl,
      football: root.dataset.footballPackModelUrl,
      bonus: root.dataset.bonusPackModelUrl
    };
    return String(urls[packKey] || "").trim();
  };

  const modelUrlForPayloadProduct = (root, pack, packKey) => {
    if (isTheOnePackPayload(pack)) {
      const theOneModelUrl = String(root.dataset.theOnePackModelUrl || "").trim();
      if (theOneModelUrl) return theOneModelUrl;
    }
    return modelUrlForPack(root, packKey);
  };

  const isTheOnePackPayload = (pack) => {
    const source = [pack?.title, pack?.packName, pack?.variantTitle, pack?.url, pack?.handle]
      .map((value) => String(value || ""))
      .join(" ")
      .toLowerCase();
    return /\bthe[\s_-]+one[\s_-]+pack\b/.test(source) || /\/products\/the-one-pack\b/.test(source);
  };

  const packGuideCharacterUrl = (root) =>
    String(root.dataset.guideCharacterUrl || "").trim();

  const packFallbackImageUrl = (pack) => {
    const direct = String(pack?.imageUrl || "").trim();
    if (direct) return direct;
    const fallback = FALLBACK_PACK_PRODUCTS.find((item) => item.packKey === normalizePackProductKey(pack?.packKey));
    return String(fallback?.imageUrl || "").trim();
  };

  const preloadPackModel = (modelUrl) => {
    const href = animationAssetUrl(modelUrl);
    if (!href) return;
    const existing = Array.from(document.querySelectorAll("link[data-wl-pack-model-preload]"));
    if (existing.some((link) => link.href === href)) return;
    const link = document.createElement("link");
    link.rel = "preload";
    link.as = "fetch";
    link.href = href;
    link.crossOrigin = "anonymous";
    link.dataset.wlPackModelPreload = "true";
    document.head.append(link);
  };

  const prefetchPackModels = (modelUrls) => {
    const hrefs = Array.from(
      new Set(
        modelUrls
          .map((modelUrl) => String(modelUrl || "").trim())
          .filter(Boolean)
          .map((modelUrl) => animationAssetUrl(modelUrl))
      )
    );
    const desired = new Set(hrefs);
    Array.from(document.querySelectorAll("link[data-wl-pack-model-prefetch]")).forEach((link) => {
      if (!desired.has(link.href)) link.remove();
    });
    const existingHrefs = new Set(
      Array.from(document.querySelectorAll("link[data-wl-pack-model-prefetch]")).map((link) => link.href)
    );
    hrefs.forEach((href) => {
      if (existingHrefs.has(href)) return;
      const link = document.createElement("link");
      link.rel = "prefetch";
      link.as = "fetch";
      link.href = href;
      link.crossOrigin = "anonymous";
      link.dataset.wlPackModelPrefetch = "true";
      document.head.append(link);
      existingHrefs.add(href);
    });
  };

  const isMobilePackViewport = () => window.matchMedia("(max-width: 767px)").matches;

  const packSwayOrbitDegrees = () => (isMobilePackViewport() ? PACK_MOBILE_SWAY_ORBIT_DEGREES : PACK_SWAY_ORBIT_DEGREES);

  const packCameraPolarAngle = () => (isMobilePackViewport() ? "90deg" : "75deg");

  const packFrontCameraOrbit = () => `180deg ${packCameraPolarAngle()} auto`;

  const packSwayMinOrbit = () => `${180 - packSwayOrbitDegrees()}deg ${packCameraPolarAngle()} auto`;

  const packSwayMaxOrbit = () => `${180 + packSwayOrbitDegrees()}deg ${packCameraPolarAngle()} auto`;

  const packImageFallbackLabel = (pack) =>
    String(pack?.packName || pack?.title || "WL Pack")
      .replace(/\bpack\b/gi, "")
      .trim()
      .slice(0, 22) || "WL";

  const isBonusPackProductTitle = (value) => {
    const normalized = String(value || "").trim().toLowerCase();
    return normalized === "bonus pack" || normalized === "bonus packs";
  };

  const normalizeApparelSize = (value) => {
    const normalized = String(value || "").trim().toUpperCase().replace(/\s+/g, " ").replace(/-/g, " ");
    if (normalized === "SMALL") return "S";
    if (normalized === "MEDIUM") return "M";
    if (normalized === "LARGE") return "L";
    if (["X LARGE", "EXTRA LARGE", "XLARGE", "1X", "1XL"].includes(normalized.replace(/\s+/g, ""))) return "XL";
    if (["2XL", "2X", "XX LARGE", "XXLARGE"].includes(normalized.replace(/\s+/g, ""))) return "XXL";
    const match = normalized.match(/\b(S|M|L|XL|XXL)\b/);
    return match?.[1] || "";
  };

  const isApparelSizeLabel = (value) => Boolean(normalizeApparelSize(value));

  const tokenPrice = (price, priceCents) => {
    const cleaned = stripHtml(String(price || "")).trim();
    if (cleaned) return cleaned;
    const cents = Number(priceCents);
    if (!Number.isFinite(cents) || cents <= 0) return "";
    const dollars = cents / 100;
    return `$${dollars.toFixed(dollars % 1 === 0 ? 0 : 2)}`;
  };

  const packPriceCents = (pack, variant) => {
    const variantCents = Number(variant?.priceCents);
    if (Number.isFinite(variantCents) && variantCents > 0) return Math.round(variantCents);
    const packCents = Number(pack?.priceCents);
    if (Number.isFinite(packCents) && packCents > 0) return Math.round(packCents);
    return moneyTextToCents(variant?.price || pack?.price || "");
  };

  const moneyTextToCents = (value) => {
    const parsed = Number.parseFloat(String(value || "").replace(/[^0-9.-]/g, ""));
    return Number.isFinite(parsed) ? Math.max(0, Math.round(parsed * 100)) : 0;
  };

  const creditsForPriceCents = (priceCents) => Math.max(0, Math.ceil(Number(priceCents || 0) / 10));

  const formatCredits = (credits) => new Intl.NumberFormat("en-US").format(Math.max(0, Math.round(Number(credits) || 0)));

  const packApiUrl = (config, path) => {
    const base = String(config.apiBase || "/apps/wl-packs").replace(/\/$/, "");
    const absolute = /^https?:\/\//i.test(base);
    const url = new URL(`${base}/${path}`, window.location.origin);
    if (isLocalPackApi(url)) {
      url.searchParams.set("shop", config.shop || "warren-lotus.myshopify.com");
      if (config.customerId) url.searchParams.set("logged_in_customer_id", config.customerId);
    }
    return absolute ? url.toString() : serializeUrl(url);
  };

  const isLocalPackApi = (url) =>
    isLocalHostname(url.hostname) && (url.pathname === "/proxy" || url.pathname.startsWith("/proxy/"));

  const localDevConfig = () => {
    if (!isLocalThemeDevHost()) return {};
    const params = new URLSearchParams(window.location.search);
    if (params.get("wl_clear_dev") === "1") clearLocalDevConfig();
    return {
      apiBase: localDevValue(params, "api_base", "http://localhost:8787/proxy"),
      shop: localDevValue(params, "shop", "warren-lotus.myshopify.com"),
      customerId: localDevValue(params, "customer_id", "preview-customer"),
      customerLabel: localDevValue(params, "customer_label", "Local Tester"),
      creditBalance: localDevValue(params, "credit_balance", ""),
      raffleTicketVariantId: localDevValue(params, "raffle_ticket_variant_id", "")
    };
  };

  const localDevValue = (params, key, fallback) => {
    const paramValue = params.get(`wl_${key}`);
    if (paramValue !== null) {
      setLocalDevConfigValue(key, paramValue);
      return paramValue.trim();
    }
    try {
      return window.localStorage.getItem(localDevStorageKey(key)) || fallback;
    } catch {
      return fallback;
    }
  };

  const setLocalDevConfigValue = (key, value) => {
    try {
      window.localStorage.setItem(localDevStorageKey(key), value.trim());
    } catch {
      // Storage is best effort only.
    }
  };

  const clearLocalDevConfig = () => {
    try {
      ["api_base", "shop", "customer_id", "customer_label", "credit_balance"].forEach((key) =>
        window.localStorage.removeItem(localDevStorageKey(key))
      );
    } catch {
      // Storage is best effort only.
    }
  };

  const localDevStorageKey = (key) => `wl-packs-dev:${key}`;

  const isLocalThemeDevHost = () => isLocalHostname(window.location.hostname);

  const isLocalHostname = (hostname) =>
    hostname === "localhost" || hostname === "127.0.0.1" || hostname === "::1" || hostname === "[::1]";

  const creditPackPayload = (pack, variant, packSize, idempotency, packTeam = null) => ({
    shopifyProductId: pack.productId,
    shopifyVariantId: variant.id,
    packKey: pack.packKey,
    packTitle: pack.title,
    packSize,
    ...(packTeam ? { packTeam } : {}),
    packPriceCents: packPriceCents(pack, variant),
    idempotencyKey: idempotency
  });

  const packAvailabilityPayload = (pack, variant, packSize, packTeam = null) => ({
    shopifyProductId: pack.productId,
    shopifyVariantId: variant.id,
    packKey: pack.packKey,
    packTitle: pack.title,
    packSize,
    ...(packTeam ? { packTeam } : {}),
    packPriceCents: packPriceCents(pack, variant)
  });

  const idempotencyKey = (prefix) => {
    const random = window.crypto?.randomUUID ? window.crypto.randomUUID() : `${Date.now()}-${Math.random()}`;
    return `${prefix}:${random}`;
  };

  const formatUsd = (value) =>
    new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: value % 1 === 0 ? 0 : 2
    }).format(value);

  const stripHtml = (value) => value.replace(/<[^>]*>/g, "");

  const wrapIndex = (index, length) => {
    if (length <= 0) return 0;
    return ((index % length) + length) % length;
  };

  const buildCustomerAccountUrl = (baseUrl, storefrontOrigin = "") => {
    if (!baseUrl) return "";
    const url = new URL(baseUrl, customerAuthOrigin(storefrontOrigin));
    const returnParam = url.pathname.includes("/customer_authentication/login") ? "return_to" : "return_url";
    url.searchParams.delete("return_to");
    url.searchParams.delete("return_url");
    url.searchParams.set(returnParam, storefrontReturnUrl());
    return serializeUrl(url);
  };

  const customerAuthOrigin = (storefrontOrigin) => {
    if (!isShopifyPreviewHost(window.location.hostname)) return window.location.origin;
    return normalizeOrigin(storefrontOrigin) || canonicalOrigin() || window.location.origin;
  };

  const isShopifyPreviewHost = (hostname) => hostname.endsWith(".shopifypreview.com");

  const isPackAnimationTestMode = () => {
    const hostname = window.location.hostname;
    if (!["127.0.0.1", "localhost", "::1", "[::1]"].includes(hostname)) return false;
    return new URL(window.location.href).searchParams.has(PACK_ANIMATION_TEST_QUERY_PARAM);
  };

  const canonicalOrigin = () => {
    const canonicalHref = document.querySelector('link[rel="canonical"]')?.href || "";
    return normalizeOrigin(canonicalHref);
  };

  const normalizeOrigin = (value) => {
    if (!value) return "";
    try {
      const url = new URL(value.includes("://") ? value : `https://${value}`);
      return isShopifyPreviewHost(url.hostname) ? "" : url.origin;
    } catch {
      return "";
    }
  };

  const storefrontReturnUrl = () => {
    const url = new URL(window.location.href);
    url.searchParams.delete("wl_fresh");
    url.searchParams.delete("wl_guest");
    url.searchParams.delete("wl_logged_out");
    const previewThemeId = getPreviewThemeId();
    if (previewThemeId && !url.searchParams.has("preview_theme_id")) url.searchParams.set("preview_theme_id", previewThemeId);
    return `${url.pathname}${url.search}${url.hash}` || "/";
  };

  const getPreviewThemeId = () => {
    const previewData = document.querySelector("#OnlineStorePreviewBarNextData")?.textContent;
    if (!previewData) return "";
    try {
      const parsed = JSON.parse(previewData);
      return parsed.theme?.isDraft && parsed.theme.id ? String(parsed.theme.id) : "";
    } catch {
      return "";
    }
  };

  const normalizeLocalUrl = (baseUrl) => {
    if (!baseUrl) return "";
    const url = new URL(baseUrl, window.location.origin);
    return serializeUrl(url);
  };

  const serializeUrl = (url) => {
    if (url.origin === window.location.origin) return `${url.pathname}${url.search}${url.hash}`;
    return url.toString();
  };

  const pendingCheckoutAgeMs = (pending) => {
    const createdAt = Number(pending?.createdAt || 0);
    return Number.isFinite(createdAt) && createdAt > 0 ? Date.now() - createdAt : Infinity;
  };

  const pendingCheckoutExpiresAtMs = (pending) => {
    const expiresAt = Date.parse(String(pending?.expiresAt || ""));
    return Number.isFinite(expiresAt) ? expiresAt : NaN;
  };

  const isCreditPendingCheckout = (pending) =>
    Boolean(pending?.creditReservationId || pending?.discountCode || pending?.discountUrl);

  const pendingCreditCheckoutExpired = (pending) => {
    const expiresAt = pendingCheckoutExpiresAtMs(pending);
    if (Number.isFinite(expiresAt)) return Date.now() >= expiresAt;
    return pendingCheckoutAgeMs(pending) >= PENDING_PACK_CHECKOUT_TTL_MS;
  };

  const pendingCheckoutUrl = (pending) => {
    const savedUrl = String(pending?.discountUrl || "").trim();
    if (savedUrl) return savedUrl;
    const discountCode = String(pending?.discountCode || "").trim();
    if (discountCode) return `/discount/${encodeURIComponent(discountCode)}?redirect=/checkout`;
    return "/checkout";
  };

  const shouldResumePendingCheckout = (pending) =>
    isCreditPendingCheckout(pending) &&
    !pendingCreditCheckoutExpired(pending) &&
    Number(pending?.checkoutResumeAttempts || 0) < PENDING_PACK_CHECKOUT_MAX_RESUME_ATTEMPTS;

  const pendingPackStorageKey = (shop) => `wl-pending-pack-checkout:${shop || "default"}`;

  const readNotificationsStorageKey = (config) =>
    `wl-pack-notifications-read:${config.shop || "default"}:${config.customerId || "guest"}`;

  const loadReadNotificationIds = (config) => {
    try {
      const source = window.localStorage.getItem(readNotificationsStorageKey(config));
      const parsed = source ? JSON.parse(source) : [];
      return new Set(Array.isArray(parsed) ? parsed.filter(Boolean).map(String) : []);
    } catch {
      return new Set();
    }
  };

  const saveReadNotificationIds = (config, ids) => {
    try {
      window.localStorage.setItem(readNotificationsStorageKey(config), JSON.stringify(Array.from(ids).slice(-200)));
    } catch {
      // Storage is best effort only.
    }
  };

  const savePendingPackCheckout = (shop, pending) => {
    try {
      window.localStorage.setItem(pendingPackStorageKey(shop), JSON.stringify(pending));
    } catch {
      // Storage is best effort only.
    }
  };

  const loadPendingPackCheckout = (shop) => {
    try {
      const source = window.localStorage.getItem(pendingPackStorageKey(shop));
      if (!source) return null;
      const parsed = JSON.parse(source);
      if (!parsed || Date.now() - Number(parsed.createdAt || 0) > PENDING_PACK_CHECKOUT_TTL_MS) {
        clearPendingPackCheckout(shop);
        return null;
      }
      return parsed;
    } catch {
      return null;
    }
  };

  const clearPendingPackCheckout = (shop) => {
    try {
      window.localStorage.removeItem(pendingPackStorageKey(shop));
    } catch {
      // Storage is best effort only.
    }
  };

  class PackOpeningAnimator {
    constructor(mount, modelUrl) {
      this.mount = mount;
      this.modelUrl = animationAssetUrl(modelUrl);
      this.stage = null;
      this.sparkLayer = null;
      this.renderer = null;
      this.scene = null;
      this.camera = null;
      this.modelRoot = null;
      this.displayGroup = null;
      this.lidPivot = null;
      this.frame = 0;
      this.resizeObserver = null;
      this.materialStates = [];
      this.THREE = null;
    }

    async play() {
      const modules = await loadThreeOpeningModules();
      this.THREE = modules.THREE;
      try {
        this.createStage();
        await this.loadModel(modules.GLTFLoader);
        this.prepareScene();
        this.updateSize();
        this.observeSize();
        this.stage.classList.add("is-visible");
        await this.animate();
      } finally {
        this.destroy();
      }
    }

    createStage() {
      this.stage = document.createElement("span");
      this.stage.className = "wl-pack-opening-stage";
      this.stage.setAttribute("aria-hidden", "true");
      this.mount.appendChild(this.stage);
      this.mount.classList.add("is-opening-3d");

      const renderer = new this.THREE.WebGLRenderer({
        alpha: true,
        antialias: true,
        powerPreference: "high-performance"
      });
      renderer.setClearColor(0x000000, 0);
      renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
      if ("outputColorSpace" in renderer && this.THREE.SRGBColorSpace) {
        renderer.outputColorSpace = this.THREE.SRGBColorSpace;
      }
      this.renderer = renderer;
      this.stage.appendChild(renderer.domElement);
      this.sparkLayer = buildPackOpeningSparkLayer();
      this.stage.appendChild(this.sparkLayer);
    }

    async loadModel(GLTFLoader) {
      const loader = new GLTFLoader();
      if (typeof loader.setCrossOrigin === "function") loader.setCrossOrigin("anonymous");
      const gltf = await loader.loadAsync(this.modelUrl);
      this.modelRoot = gltf.scene;
    }

    prepareScene() {
      const { THREE } = this;
      this.scene = new THREE.Scene();
      this.camera = new THREE.PerspectiveCamera(32, 1, 0.01, 100);
      this.camera.position.set(0, 0.02, 3.8);
      this.camera.lookAt(0, 0, 0);

      this.scene.add(new THREE.AmbientLight(0xffffff, 1.3));
      const frontLight = new THREE.DirectionalLight(0xffffff, 2.8);
      frontLight.position.set(1.8, 2.6, 3.4);
      this.scene.add(frontLight);
      const rimLight = new THREE.DirectionalLight(0xf8f7ff, 1.4);
      rimLight.position.set(-2.4, 1.1, -1.8);
      this.scene.add(rimLight);

      this.displayGroup = new THREE.Group();
      this.scene.add(this.displayGroup);
      this.displayGroup.add(this.modelRoot);

      this.modelRoot.updateMatrixWorld(true);
      this.cloneMaterials();
      this.lidPivot = this.createLidPivot(findPackPartNodes(this.modelRoot, ["TopSeal", "PeelFlap", "TearStrip"]));

      const box = new THREE.Box3().setFromObject(this.modelRoot);
      const size = box.getSize(new THREE.Vector3());
      const center = box.getCenter(new THREE.Vector3());
      this.modelRoot.position.sub(center);

      const fitDistance = (size.y * 1.3) / (2 * Math.tan((this.camera.fov * Math.PI) / 360));
      this.camera.position.z = Math.max(3.25, fitDistance);
      this.camera.lookAt(0, 0, 0);
      this.displayGroup.rotation.x = -0.04;
      this.displayGroup.rotation.y = PACK_FRONT_Y_ROTATION;
    }

    cloneMaterials() {
      const { THREE } = this;
      this.modelRoot.traverse((object) => {
        if (!object.isMesh || !object.material) return;
        const materials = Array.isArray(object.material) ? object.material : [object.material];
        const cloned = materials.map((material) => {
          const copy = material.clone();
          copy.transparent = true;
          copy.depthWrite = true;
          this.materialStates.push({
            material: copy,
            color: copy.color?.clone() || new THREE.Color(0xffffff),
            emissive: copy.emissive?.clone() || null,
            map: copy.map || null,
            metalness: typeof copy.metalness === "number" ? copy.metalness : null,
            roughness: typeof copy.roughness === "number" ? copy.roughness : null,
            opacity: typeof copy.opacity === "number" ? copy.opacity : 1
          });
          return copy;
        });
        object.material = Array.isArray(object.material) ? cloned : cloned[0];
      });
    }

    createLidPivot(parts) {
      const { THREE } = this;
      if (parts.length === 0) return null;
      const topBox = new THREE.Box3();
      parts.forEach((part) => topBox.expandByObject(part));
      const topCenter = topBox.getCenter(new THREE.Vector3());
      const hinge = new THREE.Vector3(topBox.min.x, topBox.min.y, topCenter.z);
      const pivot = new THREE.Group();
      pivot.name = "WLPackOpeningLidPivot";
      this.modelRoot.add(pivot);
      pivot.position.copy(hinge);
      pivot.userData.baseX = pivot.position.x;
      pivot.userData.baseY = pivot.position.y;
      pivot.userData.baseZ = pivot.position.z;
      pivot.updateMatrixWorld(true);
      parts.forEach((part) => pivot.attach(part));
      return pivot;
    }

    observeSize() {
      if (!("ResizeObserver" in window)) return;
      this.resizeObserver = new ResizeObserver(() => this.updateSize());
      this.resizeObserver.observe(this.mount);
    }

    updateSize() {
      if (!this.renderer || !this.camera) return;
      const rect = this.mount.getBoundingClientRect();
      const width = Math.max(1, Math.round(rect.width || this.mount.clientWidth || 320));
      const height = Math.max(1, Math.round(rect.height || this.mount.clientHeight || 420));
      this.renderer.setSize(width, height, false);
      this.camera.aspect = width / height;
      this.camera.updateProjectionMatrix();
    }

    animate() {
      return new Promise((resolve) => {
        const start = performance.now();
        const tick = (now) => {
          const elapsed = Math.min(PACK_OPEN_ANIMATION_DURATION_MS, now - start);
          this.renderFrame(elapsed / PACK_OPEN_ANIMATION_DURATION_MS);
          if (elapsed < PACK_OPEN_ANIMATION_DURATION_MS) {
            this.frame = window.requestAnimationFrame(tick);
            return;
          }
          resolve();
        };
        this.frame = window.requestAnimationFrame(tick);
      });
    }

    renderFrame(progress) {
      const { THREE } = this;
      const shake = 1 - smoothstep(0, 0.3, progress);
      const peel = easeInOutCubic(smoothstep(0.04, 0.28, progress));
      const fade = smoothstep(0.2, 0.38, progress);
      const spin = smoothstep(0.22, 0.97, progress);
      const spinAcceleration = Math.pow(spin, 3.7);
      const glow = smoothstep(0.3, 0.9, progress);
      const spark = smoothstep(0.5, 0.72, progress);
      const burst = smoothstep(0.8, 0.93, progress);

      this.stage.style.setProperty("--wl-pack-open-glow", glow.toFixed(3));
      this.stage.style.setProperty("--wl-pack-open-burst", burst.toFixed(3));
      this.stage.classList.toggle("is-glowing", glow > 0.08);
      this.stage.classList.toggle("is-sparking", spark > 0.08);
      this.stage.classList.toggle("is-exploding", progress > 0.8);

      if (this.displayGroup) {
        this.displayGroup.rotation.x = -0.04 + Math.sin(progress * Math.PI * 14) * 0.025 * shake;
        this.displayGroup.rotation.y =
          PACK_FRONT_Y_ROTATION +
          Math.sin(progress * Math.PI * 10) * 0.045 * shake +
          spin * Math.PI * 1.3 +
          spinAcceleration * Math.PI * 24;
        this.displayGroup.rotation.z =
          Math.sin(progress * Math.PI * 12) * 0.035 * shake +
          Math.sin(spinAcceleration * Math.PI * 42) * 0.042 * spin +
          Math.sin(burst * Math.PI) * 0.05;
        const scale =
          1 +
          glow * 0.08 +
          Math.sin(spin * Math.PI) * 0.035 +
          burst * 0.07 +
          Math.sin(burst * Math.PI) * 0.045;
        this.displayGroup.scale.setScalar(scale);
      }

      this.applyGlow(THREE, glow);

      if (this.lidPivot) {
        this.lidPivot.rotation.x = -1.25 * peel;
        this.lidPivot.rotation.y = 0.32 * peel;
        this.lidPivot.rotation.z = -0.62 * peel;
        this.lidPivot.position.x = this.lidPivot.userData.baseX + 0.62 * peel;
        this.lidPivot.position.y = this.lidPivot.userData.baseY + 0.34 * peel;
        this.lidPivot.position.z = this.lidPivot.userData.baseZ + 0.2 * peel;
        setObjectOpacity(this.lidPivot, Math.max(0, 1 - fade));
      }

      this.renderer.render(this.scene, this.camera);
    }

    applyGlow(THREE, glow) {
      const white = new THREE.Color(0xffffff);
      this.materialStates.forEach((state) => {
        const { material } = state;
        const whiteAmount = Math.pow(glow, 1.8);
        const shineAmount = Math.pow(glow, 1.55);

        if (state.map && material.map !== state.map) {
          material.map = state.map;
          material.needsUpdate = true;
        }

        if (material.color) material.color.copy(state.color).lerp(white, whiteAmount);
        if (material.emissive) {
          material.emissive.copy(state.emissive || white).lerp(white, whiteAmount);
          material.emissiveIntensity = shineAmount * 1.95;
        }
        if (state.metalness !== null) material.metalness = lerp(state.metalness, 0.03, whiteAmount);
        if (state.roughness !== null) material.roughness = lerp(state.roughness, 0.14, whiteAmount);
        material.opacity = state.opacity;
      });
    }

    destroy() {
      if (this.frame) window.cancelAnimationFrame(this.frame);
      this.resizeObserver?.disconnect();
      if (this.modelRoot) disposeThreeObject(this.modelRoot);
      this.renderer?.dispose();
      this.stage?.remove();
      this.mount.classList.remove("is-opening-3d");
    }
  }

  let threeOpeningModulesPromise = null;

  const loadThreeOpeningModules = () => {
    if (!threeOpeningModulesPromise) {
      threeOpeningModulesPromise = Promise.all([
        import(THREE_MODULE_SRC),
        import(GLTF_LOADER_MODULE_SRC)
      ]).then(([THREE, loaderModule]) => ({ THREE, GLTFLoader: loaderModule.GLTFLoader }));
    }
    return threeOpeningModulesPromise;
  };

  const buildPackOpeningSparkLayer = () => {
    const layer = document.createElement("span");
    layer.className = "wl-pack-opening-sparks";
    layer.setAttribute("aria-hidden", "true");

    const core = document.createElement("span");
    core.className = "wl-pack-opening-spark-core";
    layer.appendChild(core);

    for (let index = 0; index < PACK_OPEN_SPARK_COUNT; index += 1) {
      const spark = document.createElement("span");
      const isRay = index % 2 === 0;
      spark.className = `wl-pack-opening-spark${isRay ? " wl-pack-opening-spark--ray" : ""}`;
      const angle = (360 / PACK_OPEN_SPARK_COUNT) * index + (index % 4) * 3.5;
      const distance = 100 + (index % 9) * 9;
      const burstDistance = Math.round(distance * 0.66);
      const midDistance = 24 + (index % 7) * 7;
      const simmerDistance = Math.round(midDistance * 0.58);
      const size = 4 + (index % 6);
      const length = 28 + (index % 7) * 6;
      spark.style.setProperty("--spark-angle", `${angle}deg`);
      spark.style.setProperty("--spark-distance", `${distance}px`);
      spark.style.setProperty("--spark-burst-distance", `${burstDistance}px`);
      spark.style.setProperty("--spark-mid-distance", `${midDistance}px`);
      spark.style.setProperty("--spark-simmer-distance", `${simmerDistance}px`);
      spark.style.setProperty("--spark-size", `${size}px`);
      spark.style.setProperty("--spark-length", `${length}px`);
      spark.style.setProperty("--spark-delay", `${(index % 12) * 34}ms`);
      spark.style.setProperty("--spark-explode-delay", `${(index % 6) * 14}ms`);
      layer.appendChild(spark);
    }

    return layer;
  };

  const playFallbackPackOpenAnimation = async (mount) => {
    mount?.classList.add("is-opening");
    await delay(PACK_OPEN_ANIMATION_DURATION_MS);
    mount?.classList.remove("is-opening");
  };

  const findPackPartNodes = (root, prefixes) => {
    const normalizedPrefixes = prefixes.map(normalizePackPartName);
    const matches = [];
    root.traverse((object) => {
      const name = normalizePackPartName(object.name);
      if (name && normalizedPrefixes.some((prefix) => name.startsWith(prefix))) matches.push(object);
    });
    return matches;
  };

  const normalizePackPartName = (value) =>
    String(value || "")
      .split(".")[0]
      .replace(/[^a-z0-9]+/gi, "")
      .toLowerCase();

  const setObjectOpacity = (object, opacity) => {
    object.traverse((child) => {
      if (!child.isMesh || !child.material) return;
      const materials = Array.isArray(child.material) ? child.material : [child.material];
      materials.forEach((material) => {
        material.opacity = opacity;
        material.transparent = true;
      });
      child.visible = opacity > 0.01;
    });
  };

  const disposeThreeObject = (object) => {
    object.traverse((child) => {
      if (child.geometry) child.geometry.dispose();
      if (!child.material) return;
      const materials = Array.isArray(child.material) ? child.material : [child.material];
      materials.forEach((material) => {
        ["map", "normalMap", "roughnessMap", "metalnessMap", "emissiveMap", "aoMap"].forEach((key) => {
          material[key]?.dispose?.();
        });
        material.dispose?.();
      });
    });
  };

  const animationAssetUrl = (value) => new URL(String(value || ""), window.location.href).toString();

  const smoothstep = (edge0, edge1, value) => {
    const x = clamp((value - edge0) / (edge1 - edge0), 0, 1);
    return x * x * (3 - 2 * x);
  };

  const easeInOutCubic = (value) =>
    value < 0.5 ? 4 * value * value * value : 1 - Math.pow(-2 * value + 2, 3) / 2;

  const lerp = (start, end, amount) => start + (end - start) * amount;

  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

  const delay = (durationMs) => new Promise((resolve) => window.setTimeout(resolve, durationMs));

  const safeJson = (source) => {
    try {
      return JSON.parse(source);
    } catch {
      return {};
    }
  };

  const getErrorMessage = (error) => (error instanceof Error ? error.message : String(error || "Something went wrong."));

  const ensureModelViewer = () => {
    if (customElements.get("model-viewer")) return;
    if (document.querySelector(`script[src="${MODEL_VIEWER_SRC}"]`)) return;
    const script = document.createElement("script");
    script.type = "module";
    script.src = MODEL_VIEWER_SRC;
    document.head.append(script);
  };

  const escapeHtml = (value) =>
    String(value ?? "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");

  const escapeAttr = escapeHtml;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initAll());
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", (event) => initAll(event.target));
})();
